<template>
    <Attr :widget_id="widget_id" :attr_id="attr_id">
        <!-- IE 2026 09 15 / ODOO-… (заказ Игоря): командная панель графа (Assign / Webworker / масштаб / вписать) и шестерёнка —
             островком в нижнем правом углу поля графа (ниже, .graph-panel-island); в верхней строке остаются только чипсы -->
        <div class="grid-top-line" ref="attr_top_line" v-if="!attr?.hideCommandPanel && !get_viewParam('hideCHIPS')">
            <div class="grid-chips" v-if="!get_viewParam('hideCHIPS')">
                <span class="p-float-label">
                    <AttrChips ref="chips"
                        :widget_id="widget_id"
                        :attr_id="attr_id"
                        @update:modelValue="apply_CHIPS"
                        :mode="'Embedded'"
                    ></AttrChips>
                </span>
            </div>
        </div>
        
        <div class="attr-graph0" ref="attr_container"
            v-visible="handleVisibility"
            :class="{ 'attr-graph-rectsel-on': rectSelect }"
        >
            <!-- IE 2026 09 05 / ODOO-336800 (заказ Игоря): прямоугольник выделения узлов — режим по кнопке командной панели -->
            <div class="attr-graph-rectsel" v-if="rectSel_box" :style="rectSel_box" v-uiHelp="'chart.graph.rectSel'"></div>
            <!-- АН 2026 08 09: шестерёнка настроек графа (поведение как у AttrGrid:
                 hover — быстрые настройки, клик — виджет строки настроек) -->
            <!-- IE 2026 09 15 / ODOO-… (заказ Игоря): парящая шестерёнка — островком (как у графика и карты) -->
            <!-- IE 2026 09 23 / ODOO-341407: i18n -->
            <div class="corner-island corner-island-tr" v-if="(!attr?.hideGridSettings || mapViewOn) && !graphPanelVisible" style="right:28px;">
                <GraphEngineToggle :widget="WIDGET" :attr="attr"/><!-- Odoo 348733: «Classic / Lens» — только где линза рисует данные (graph/lens/lensSwitch.js), иначе ничего -->
                <!-- IE 2026 09 17 / ODOO-… (заказ Игоря: «Flow-tree-map»): окно легенды графа — как у карты -->
                <div class="button-1 p-2" v-if="mapViewOn" :class="{'attr-graph-btn-on': mapLegendVisible}"
                    v-wjTooltip="mapLegendVisible ? t('Hide legend') : t('Show legend')" @click="mapLegendVisible = !mapLegendVisible" v-uiHelp="{ key: 'chart.graph.legendBtn', state: () => (mapLegendVisible ? 'on' : 'off') }">
                    <i class="pi pi-tags"/>
                </div>
                <div class="button-1 p-2" v-if="!attr?.hideGridSettings" ref="cogButton"
                    v-wjTooltip="t('Graph settings')"
                    @click="onToggle_graphSettings" v-uiHelp="{ key: 'chart.graph.cog', state: () => (show_graphQuickSettings ? 'quick' : 'idle') }"
                    @mouseenter="onShow_graphQuickSettings" @mouseleave="onClose_graphQuickSettings">
                    <i class="pi pi-cog"/>
                </div>
            </div>
            <!-- IE 2026 09 15 / ODOO-… (заказ Игоря): командная панель графа — островок нижнего правого угла -->
            <!-- IE 2026 09 23 / ODOO-341407: i18n -->
            <div class="corner-island corner-island-br graph-panel-island" v-if="graphPanelVisible && (commandPanel.length || !attr?.hideGridSettings)">
                <GraphEngineToggle :widget="WIDGET" :attr="attr"/><!-- Odoo 348733: «Classic / Lens» — только где линза рисует данные (graph/lens/lensSwitch.js), иначе ничего -->
                <component v-for="attrM in commandPanel"
                    :key="attrM.html_id"
                    :widget_id="widget_id"
                    :is="attrM.component"
                    :attr_id="attrM.id"
                    :initialAttr="attrM"
                />
                <!-- IE 2026 09 17 / ODOO-… (заказ Игоря: «Flow-tree-map»): окно легенды графа — как у карты -->
                <div class="button-1 p-2" v-if="mapViewOn" :class="{'attr-graph-btn-on': mapLegendVisible}"
                    v-wjTooltip="mapLegendVisible ? t('Hide legend') : t('Show legend')" @click="mapLegendVisible = !mapLegendVisible" v-uiHelp="{ key: 'chart.graph.legendBtn', state: () => (mapLegendVisible ? 'on' : 'off') }">
                    <i class="pi pi-tags"/>
                </div>
                <div class="button-1 p-2" ref="cogButton" v-if="!attr?.hideGridSettings"
                    v-wjTooltip="t('Graph settings')"
                    @click="onToggle_graphSettings" v-uiHelp="{ key: 'chart.graph.cog', state: () => (show_graphQuickSettings ? 'quick' : 'idle') }"
                    @mouseenter="onShow_graphQuickSettings" @mouseleave="onClose_graphQuickSettings">
                    <i class="pi pi-cog"/>
                </div>
            </div>
            <div class="widget-commandPanel-2" v-show="show_graphQuickSettings"
                :style="!graphPanelVisible ? 'position:absolute; top:2px; right:8px; z-index:7; padding:8px 12px; min-width:250px;' : 'position:absolute; bottom:46px; right:8px; z-index:7; padding:8px 12px; min-width:250px;'"
                @mouseenter="onShow_graphQuickSettings" @mouseleave="onClose_graphQuickSettings">
                <template v-for="opt in graphQuickOptions" :key="opt.key">
                    <div v-if="opt.items" class="mb-1" style="white-space:nowrap;" v-uiHelp="uiHelp6_qsKey(opt)">
                        <div class="mb-1" style="opacity:.7">{{ opt.title }}</div>
                        <div v-for="it in opt.items" :key="it.id" class="ml-3" style="cursor:pointer;" @click="setGraphOption(opt, it.id)">
                            <i :class="['pi', opt.value === it.id ? 'pi-circle-fill' : 'pi-circle', 'mr-2']"/>
                            <span>{{ it.title }}</span>
                        </div>
                    </div>
                    <div v-else class="mb-1" style="cursor:pointer; white-space:nowrap;" @click="toggleGraphOption(opt)" v-uiHelp="{ key: uiHelp6_qsKey(opt), state: () => (opt.value ? 'on' : 'off') }">
                        <i :class="['pi', opt.value ? 'pi-check-square' : 'pi-stop', 'mr-2']"/>
                        <span>{{ opt.title }}</span>
                    </div>
                </template>
            </div>
            <div id="graph-container" ref="sigmaRoot" class="attr-graph absolute inset-0" />
            <!-- IE 2026 09 15 / ODOO-… (замечание Игоря): муравьиная логистика на графе — частицы по рёбрам (общие часы страницы) -->
            <canvas v-if="antsOn" ref="antCanvas" class="attr-graph-ants"></canvas>
            <AntPlayer v-if="antsOn && antClockObj" :clock="antClockObj" :stats="antStats" :tick="antTick" month="all"/>

            <!-- IE 2026 09 17 / ODOO-… (заказ Игоря: «Flow-tree-map»): окно легенды — свободное, как у карты: вкладка Node (наведённый
                 узел / связь / область страны с мерами) и вкладка Legend (мера раскраски, глифы узла, толщина связей, отбор) -->
            <Teleport :to="overlayPortal(legendPortal)"><!-- IE 2026 09 23 / ODOO-… (замечание Игоря: панели-меню в Full screen) -->
            <div class="attr-graph-mappanel" v-if="mapViewOn && mapLegendVisible && legendOwner_shown()" ref="legendPanel" :data-widget="WIDGET && WIDGET.id" :style="legendPanelStyle()">
                <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                <div class="attr-graph-mappanel-head" @mousedown="legendDragStart" v-uiHelp="'chart.graph.legend.window'">
                    <i class="pi pi-times attr-graph-mappanel-close" v-uiHelp="'chart.graph.legend.close'" :title="t('Close')" @mousedown.stop @click.stop="mapLegendVisible = false"/>
                    <span>{{ t('Legend') }}</span>
                </div>
                <div class="attr-graph-mappanel-tabs" @mousedown.stop>
                    <span class="attr-graph-mappanel-tab" :class="{'is-on': mapLegendTab === 'node'}" @click="mapLegendTab = 'node'" v-uiHelp="{ key: 'chart.graph.legend.tabNode', state: () => (mapLegendTab) }">{{ t('Node') }}</span>
                    <span class="attr-graph-mappanel-tab" :class="{'is-on': mapLegendTab === 'legend'}" @click="mapLegendTab = 'legend'" v-uiHelp="{ key: 'chart.graph.legend.tabLegend', state: () => (mapLegendTab) }">{{ t('Legend') }}</span>
                </div>
                <template v-if="mapLegendTab === 'node'">
                    <div class="attr-graph-mappanel-hover" v-if="mapHoverInfo" v-uiHelp="{ key: 'chart.graph.legend.nodeBlock', state: () => (mapHoverEl ? mapHoverEl.kind : 'none') }">
                        <div class="attr-graph-mappanel-hover-head">
                            <span class="attr-graph-mappanel-hover-kind">{{ mapHoverInfo.kind }}</span>
                            <b class="attr-graph-mappanel-hover-title" :title="mapHoverInfo.title">{{ mapHoverInfo.title }}</b>
                            <span class="attr-graph-mappanel-hover-sub" v-if="mapHoverInfo.sub">{{ mapHoverInfo.sub }}</span>
                        </div>
                        <table class="attr-graph-mappanel-table"><tbody>
                            <tr v-for="(r, i) in mapHoverInfo.rows" :key="i" :class="{'is-active': r.active}">
                                <td class="attr-graph-mappanel-name" :title="r.title">{{ r.title }}</td>
                                <td class="attr-graph-mappanel-val" :class="{'is-unc': r.unc}" v-html="r.text"></td>
                            </tr>
                        </tbody></table>
                    </div>
                    <div class="attr-graph-mappanel-hint" v-else>{{ t('Hover a node, a link or a country area on the graph') }}</div>
                </template>
                <template v-else>
                    <label class="attr-graph-mappanel-row" v-for="m in mapMeasures" :key="m.binding" :class="{'is-active': m.binding === mapValueBinding}">
                        <input type="checkbox" :checked="m.binding === mapValueBinding" @change="mapSetMeasure(m.binding)" v-uiHelp="{ key: 'chart.graph.legend.measure', state: () => (m.binding === mapValueBinding ? 'on' : 'off') }"/>
                        <span class="attr-graph-mappanel-title">{{ m.title }}</span>
                        <i class="attr-graph-mappanel-bar" v-if="m.binding === mapValueBinding && mapAreaScale" :style="{ background: mapAreaScale.gradient }"></i>
                    </label>
                    <div class="attr-graph-mappanel-foot" v-if="mapAreasOn">
                        <span class="attr-graph-mappanel-area"></span><span>{{ t('country areas: fill = {title} of the country nodes', { title: mapValueTitle }) }}</span>
                    </div>
                    <div class="attr-graph-mappanel-foot" v-uiHelp="'chart.graph.legend.feet'">
                        <span class="attr-graph-mappanel-dot"></span><span>{{ t('nodes: fill = {fill}, circle size = {size}', { fill: mapValueTitle, size: mapSizeTitle }) }}<template v-if="mapRingTitle">, {{ t('ring = {title}', { title: mapRingTitle }) }}</template><template v-if="mapCoreTitle">, {{ t('red core = {title}', { title: mapCoreTitle }) }}</template></span>
                    </div>
                    <div class="attr-graph-mappanel-foot" v-if="mapLinkValueTitle">
                        <span class="attr-graph-mappanel-line" :style="{ background: '#3d6fd1' }"></span><span>{{ t('links: width = {title}', { title: mapLinkValueTitle }) }}</span>
                        <template v-if="mapLinkUncTitle"><span class="attr-graph-mappanel-line" :style="{ background: '#d9534f' }"></span><span>{{ t('red = {title}', { title: mapLinkUncTitle }) }}</span></template>
                    </div>
                    <div class="attr-graph-mappanel-foot" v-if="mapSelectedCount">
                        <span>{{ t('{n} selected', { n: mapSelectedCount }) }}</span>
                        <a href="#" @click.prevent="mapClearSelection" v-uiHelp="'chart.graph.legend.selected'">{{ t('clear') }}</a>
                    </div>
                </template>
            </div>
            </Teleport>
            <!-- IE 2026 09 17 / ODOO-… (заказ Игоря): подпись наведения — чекбокс селектора, иконка записи, название и меры (бейдж карты) -->
            <!-- IE 2026 09 23 / ODOO-341407: i18n -->
            <div class="attr-graph-badge" v-if="mapViewOn && mapBadge" :style="{ left: mapBadge.x + 'px', top: mapBadge.y + 'px' }"
                @mouseenter="mapBadgeHold(true)" @mouseleave="mapBadgeHold(false)">
                <i class="attr-graph-check" v-if="mapBadge.key" :class="mapBadge.selected ? 'pi pi-check-square' : 'pi pi-stop'"
                    v-wjTooltip="t('Click — add / remove in the selector, Alt+click — only this one')" @click.stop="mapBadgeToggle($event)" v-uiHelp="{ key: 'chart.graph.badge.check', state: () => (mapBadge.selected ? 'on' : 'off') }"></i>
                <i class="pi attr-graph-open" v-if="mapBadge.key" :class="mapBadge.icon" :title="t('Open record')" @click.stop="mapBadgeOpen()" v-uiHelp="'chart.graph.badge.open'"></i>
                <span class="attr-graph-badge-flag" v-if="mapBadge.flag">{{ mapBadge.flag }}</span>
                <span class="attr-graph-badge-name">{{ mapBadge.title }}</span>
                <span class="attr-graph-badge-ext" :class="{ 'alt-details-fading': badgeDetailsFading }" :style="badgeFadeStyle" v-if="mapBadge.html && badgeDetailsOn" v-html="mapBadge.html"></span><!-- IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции): меры — по Alt -->
                <!-- IE 2026 09 17 / ODOO-… (заказ Игоря): бейдж страны поставщика — флаг, название и свой чекбокс селектора -->
                <span class="attr-graph-badge-country" v-if="mapBadge.country">
                    <i class="attr-graph-check" v-if="mapBadge.country.key" :class="mapBadge.country.selected ? 'pi pi-check-square' : 'pi pi-stop'"
                        v-wjTooltip="t('Click — add / remove the country in the selector, Alt+click — only this one')" @click.stop="mapBadgeToggle($event, 'country')" v-uiHelp="{ key: 'chart.graph.badge.countryCheck', state: () => (mapBadge.country.selected ? 'on' : 'off') }"></i>
                    <i class="pi attr-graph-open" v-if="mapBadge.country.key" :class="mapBadge.country.icon" :title="t('Open record')" @click.stop="mapBadgeOpen('country')"></i>
                    <span class="attr-graph-badge-flag" v-if="mapBadge.country.flag">{{ mapBadge.country.flag }}</span>
                    <span class="attr-graph-badge-cname">{{ mapBadge.country.title }}</span>
                </span>
            </div>

            <!-- ODOO-3221: легенда графа (цвета вершин + направление рёбер); данные с бэка: data_graph.legend -->
            <div class="attr-graph-legend" v-if="data_graph?.legend?.items?.length" v-uiHelp="'chart.graph.serverLegend'">
                <div class="attr-graph-legend-row" v-for="(item, i) in data_graph.legend.items" :key="i">
                    <span v-if="item.marker" class="attr-graph-legend-marker" :style="{ color: item.color || '#666' }">{{ item.marker }}</span>
                    <span v-else class="attr-graph-legend-swatch" :style="{ background: item.color || '#999' }"></span>
                    <span>{{ item.title }}</span>
                </div>
            </div>

            <!-- webscm 2026 10 23 / Odoo 348730: сетевой режим (doc.params.graph_network) — обязательный чипс отбора пуст (строка WHERE
                 selector_required), бэк граф не строит: подсказка вместо пустого поля -->
            <div class="attr-graph-net-hint" v-if="netHint()">{{ netHint() }}</div>

            <!-- ODOO-3221: панель связей вершины (клик; opt-in через graph-eval 'command-clickNode'.links_panel) -->
            <!-- IE 2026 09 23 / ODOO-341407: i18n: запасные подписи панели связей (бэк может дать свои в linksPanel.ui); ревью: хвост стоял вне комментария и рендерился текстом -->
            <div class="attr-graph-links" v-if="linksPanel" v-uiHelp="'chart.graph.linksPanel'">
                <div class="attr-graph-links-header">
                    <span class="attr-graph-legend-swatch" :style="{ background: linksPanel.color }"></span>
                    <b class="attr-graph-links-label">{{ linksPanel.label }}</b>
                    <i class="pi pi-times attr-graph-links-close" @click="linksPanel = null"></i>
                </div>
                <div class="attr-graph-links-sub">
                    <span class="attr-graph-links-id">{{ linksPanel.segment }}</span>
                    <span class="attr-graph-links-openlist" @click="openSegmentList(linksPanel.segment)">
                        <i class="pi pi-folder-open"></i> {{ linksPanel.ui.btn_list || t('Open list') }}
                    </span>
                </div>
                <template v-if="linksPanel.links_out.length">
                    <div class="attr-graph-links-section">{{ linksPanel.ui.title_out || t('Uses →') }}</div>
                    <table class="attr-graph-links-table">
                        <tr v-for="(row, i) in linksPanel.links_out" :key="'out' + i">
                            <td class="attr-graph-links-binding">{{ row.binding }}</td>
                            <td class="attr-graph-links-arrow">→</td>
                            <td class="attr-graph-links-node" @click="openLinksPanel(row.node)">{{ row.label }}</td>
                        </tr>
                    </table>
                </template>
                <template v-if="linksPanel.links_in.length">
                    <div class="attr-graph-links-section">{{ linksPanel.ui.title_in || t('← Used by') }}</div>
                    <table class="attr-graph-links-table">
                        <tr v-for="(row, i) in linksPanel.links_in" :key="'in' + i">
                            <td class="attr-graph-links-node" @click="openLinksPanel(row.node)">{{ row.label }}</td>
                            <td class="attr-graph-links-arrow">→</td>
                            <td class="attr-graph-links-binding">{{ row.binding }}</td>
                        </tr>
                    </table>
                </template>
            </div>
        </div>
    </Attr>
</template>

<script>
import { markRaw, toRaw } from 'vue'   // IE 2026 10 26 / ODOO-348733 (заказ webscm #105553: netOn и реактивные чтения в редьюсерах на каждый проход): toRaw — данные графа в graphology без прокси Vue (fe.perf.graphRawImport)
import { snapCache, reducerSnapRead, nodeReduceSnap, edgeReduceSnap } from '@/utils/graphReducerSnap'   // IE 2026 10 26 / ODOO-348733 (заказ webscm #105553: netOn и реактивные чтения в редьюсерах на каждый проход): снимок реактивных чтений редьюсеров на проход (fe.perf.graphReducerSnap)
import { uiHelp_html, uiHelp_enabled, uiHelp_has } from '@/utils/uiHelp'   // U6 (заказ Игоря: объяснение элементов по Alt): chart.graph.node / edge / area — источник «по точке»; ключи быстрых настроек
import altTooltip from '@/utils/altTooltip'   // IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции): бейдж графа: меры — по Alt (detailsOn)
import AntPlayer from './AntPlayer.vue'
import { overlayPortal } from '@/utils/overlayRoot'   // IE 2026 09 23 / ODOO-… (замечание Игоря: панели-меню в Full screen): цель телепорта окна легенды
import { legendOwnerMixin } from '@/utils/legendOwner'   // IE 2026 09 20 / ODOO-… (Игорь: легенда закрывается вместе с виджетом и на вкладке, к которой не относится)
// IE 2026 09 15 / ODOO-… (замечание Игоря): муравьиная логистика на графе — частицы по рёбрам, общие часы страницы
import { antClock, antClockJoin, antClockLeave, antClockTick, antClockSig, antClockSyncPeriod, antClockStartMode, antClockTotal } from '../../../utils/antClock'
import { AntRunner, antHex } from '../../../utils/antRunner'
import { stableBoxApply, stableBoxReset } from '@/utils/stableBox'   // IE 2026 09 17 / ODOO-… (замечание Игоря): окно легенды не прыгает по размеру
import { useMainStore } from '@/stores/mainStore'
import { ctxMenu_allowed, ctxMenu_count } from '@/utils/ctxMenuGuard'   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — график / узел карты)
import { ref } from 'vue'
import Sigma from 'sigma'
import EdgeCurveProgram, { EdgeCurvedArrowProgram, createEdgeCurveProgram } from "@sigma/edge-curve"   // IE 2026 09 12 / ODOO-335246 (Igor): кривая стрелка для рёбер обратной связи (документы → своя задача)
import { EdgeArrowProgram, createEdgeArrowProgram } from 'sigma/rendering'   // АН 2026 08 09 / стрелки направления; IE 2026 09 14 / ODOO-335246 (Igor): заметные головки
import { createNodePiechartProgram } from "@sigma/node-piechart"
import NodeSquareProgram from "./graph/NodeSquareProgram"   // IE 2026 09 12 / ODOO-335246 (Igor): задачи — квадраты
import graphology from 'graphology'
import { animateNodes } from "sigma/utils"
const MASK_GLYPH = '\uE000'   // IE 2026 09 13 / ODOO-335246 (Igor): маркер «иконка-маска» в месте глифа primeicons
// IE 2026 09 17 / ODOO-… (заказ Игоря: «Flow-tree-map» — граф по правилам карты): гамма шкалы мер (min → max), цвет связи,
// цвет непокрытого объёма (красное ядро узла / красная связь), цвет области без значения и границы размера узла
const MAP_COLORS = ['#e57373', '#ffd54f', '#81c784']
const MAP_SINGLE = '#8fa8c8'
const MAP_LINK = '#3d6fd1'
const MAP_UNC = '#d9534f'
const MAP_EMPTY = '#cfd8dc'
const MAP_MIN_S = 3, MAP_MAX_S = 17
// цвет меры по шкале — как paletteColor карты (линейная интерполяция по остановкам гаммы)
function mapPalette(t) {
    const stops = MAP_COLORS.map(c => wjcCore.Color.fromString(c)).filter(Boolean)
    if (!stops.length) return MAP_SINGLE
    t = Math.max(0, Math.min(1, Number.isFinite(t) ? t : 0))
    const pos = t * (stops.length - 1), i = Math.min(stops.length - 2, Math.floor(pos)), k = pos - i
    const a = stops[i], b = stops[i + 1]
    return wjcCore.Color.fromRgba(a.r + (b.r - a.r) * k, a.g + (b.g - a.g) * k, a.b + (b.b - a.b) * k, 1).toString()
}
function mapAlpha(color, alpha) {
    const c = wjcCore.Color.fromString(color)
    return c ? wjcCore.Color.fromRgba(c.r, c.g, c.b, alpha).toString() : color
}

import circular from "graphology-layout/circular"
import circlepack from "graphology-layout/circlepack"
import forceLayout from 'graphology-layout-force'
import forceAtlas2 from "graphology-layout-forceatlas2"
import noverlap from 'graphology-layout-noverlap'

import ForceSupervisor from "graphology-layout-force/worker"
import FA2Layout from 'graphology-layout-forceatlas2/worker'
import NoverlapLayout from 'graphology-layout-noverlap/worker'

import dagre from 'dagre'
import { layoutStd, ieGraphLayout } from './graphLayoutStd'
import { searchTerms, matchTerms, foundTerms, fuzzyMaxTier, FUZZY_TIERS } from '@/utils/searchMatch'   // IE 2026 09 13 / ODOO-335246 (Igor): поиск по графу тем же механизмом, что чипс селектора / поиск в таблице
import { layoutCandidates } from '@/utils/keyboardLayout'   // IE 2026 09 13 / ODOO-335246 (Igor): стандартная раскладка (Sugiyama/dagre) — опциональный движок
import { findRow as schemeFindRow } from '@/utils/schemeGraph'   // IE 2026 10 25 / ODOO-348925: строка узла / связи графа схемы (AttrSchemeGraph) — по ключу или позиции
import { sgTitleBand, sgTitleHit } from '@/utils/schemeGraph'   // IE 2026 10 25 / ODOO-348925: подпись узла не ложится на заголовок группы схемы (rect labelClear)
import { sgTitleRoom, sgEdgeLabels } from '@/utils/schemeGraph'   // IE 2026 10 25 / ODOO-348925: запас под заголовок группы в экранных px (rect titleRoom), подписи связей схемы раскладкой кадра (labelDeclutter)
import { drawStraightEdgeLabel } from 'sigma/rendering'   // IE 2026 10 25 / ODOO-348925: подпись связи без labelDeclutter — штатно, как раньше
import * as wjcCore from '@mescius/wijmo';

let tooltip = new wjcCore.Tooltip({ 
    // showAtMouse: true,
    showDelay: 1500,
})

export default {
    components: { AntPlayer },
    mixins: [legendOwnerMixin],   // IE 2026 09 20 / ODOO-… (Игорь: легенда закрывается вместе с виджетом и на вкладке, к которой не относится)
    props: [
        'widget_id',
        'attr_id',
    ],
    data: () => ({ 
            antTick: 0, antStats: '', antClockObj: null,   // IE 2026 09 15: муравьи по рёбрам
            autoNoSqY: false,   // IE 2026 09 12 / ODOO-335246 (Igor): авто «Keep vertical spacing» включён по наложению узлов
            layoutFree: false,   // IE 2026 09 26 / ODOO-… (дефект Игоря: кнопки раскладки графа не вписывают граф): раскладка кнопкой (Assign / Webworker) — база _xF/_yF, правила колонок не действуют
        WIDGET: {},
        state: {
            hoveredNode: undefined,
            hoveredNeighbors: undefined,
            hoveredRect: undefined,   // IE 2026 09 10 (Igor): наведение на заголовок области
            filter_values: undefined,
            selector_values: undefined,
            selector_valuesNeighbors: undefined,
            selector_values_inEdges: undefined,
            selector_values_outEdges: undefined,

            // selectedNode: undefined,
            // suggestions: undefined,
        },
        commandPanel: [],
        // IE 2026 09 05 / ODOO-336800 (заказ Игоря): режим выделения прямоугольником (кнопка панели) и его рамка
        rectSelect: false,
        rectSel_box: null,
        // ODOO-3221: hover по вершине = подсветка соседей + лёгкий тултип (эталонное
        // поведение старого фронта). Открытие widget-row карточки на hover перекрывало
        // весь граф — теперь оно opt-in через graph-eval:
        //   'command-hoveredNode': { tooltip_widget: 'widget-row' }
        tooltip_widget: '',
        set_selector: true,
        // ODOO-3221: панель связей выбранной вершины (см. openLinksPanel)
        linksPanel: null,

        data: {},
        data_graph: {},

        // IE 2026 09 17 / ODOO-… (заказ Игоря: «Flow-tree-map»): вид графа по правилам карты — окно легенды (вкладки Node / Legend),
        // наведённый элемент (узел / связь / область страны), подпись-бейдж наведения и области стран
        mapLegendVisible: false,
        mapLegendBox: { w: 0, h: 0 },   // IE 2026 09 17 / ODOO-… (замечание Игоря): окно легенды не сжимается обратно
        mapLegendTab: 'node',
        mapActiveBinding: '',
        mapHoverEl: null,
        mapBadge: null,
        mapAreasData: [],
        mapTick: 0,
        legendPos: null, legendPortal: null, legendDefTick: 0,

        // АН 2026 08 09: быстрые настройки графа (шестерёнка)
        show_graphQuickSettings: false,
        timerId_graphQuickSettings: null,
        graphOptionsTick: 0,
    }),
    setup() {
        const store = useMainStore()
        return {
            store,
            sigmaRoot: ref(null),
            // sigmaInstance: shallowRef<Sigma | null>(null),
        }
    },
    computed: {
        // IE 2026 09 15 / ODOO-… (заказ Игоря): панель графа «визуализирована» — не скрыта у attr (hideCommandPanel) и не выключена
        // кнопкой Panel виджета (styleWidget.hideGridPanel); иначе вместо островка кнопок — островок шестерёнки справа вверху
        graphPanelVisible() { return !this.attr?.hideCommandPanel && !this.WIDGET?.styleWidget?.hideGridPanel },
        // АН 2026 08 09: опции графа для быстрой формы (читаются бэком из doc.params)
        antsOn() { this.graphOptionsTick; return this.WIDGET?.record?.doc?.params?.graph_ants === true },   // IE 2026 09 15 / ODOO-… (замечание Игоря)
        graphQuickOptions() {
            this.graphOptionsTick
            const p = this.WIDGET?.record?.doc?.params || {}
            // IE 2026 09 23 / ODOO-341407: i18n: подписи быстрых настроек (опции из attr.graphOptions — подписи бэка, как есть)
            return [
                { key: 'graph_route_columns',      title: this.t('Route columns'),      value: p.graph_route_columns !== false },
                { key: 'graph_minimize_crossings', title: this.t('Minimize crossings'), value: p.graph_minimize_crossings !== false },
                { key: 'graph_flat_list',          title: this.t('Flat list (data tab)'), value: p.graph_flat_list !== false },
                { key: 'graph_unique_nodes',       title: this.t('Unique nodes'),       value: p.graph_unique_nodes === true },
                { key: 'graph_edge_arrows',        title: this.t('Edge arrows'),        value: p.graph_edge_arrows !== false },
                { key: 'graph_hide_unused',        title: this.t('Hide unused (use = false)'), value: p.graph_hide_unused === true },
                // АН 2026 08 11: дорасширение выборки цепочками BOM (влево и вправо)
                // АН 2026 08 11: «змейка» против слипания коллинеарных связей
                { key: 'graph_avoid_horizontal',   title: this.t('Avoid horizontal links (snake)'), value: p.graph_avoid_horizontal !== false },
                { key: 'graph_avoid_vertical',     title: this.t('Avoid vertical links (snake)'), value: p.graph_avoid_vertical === true },
                { key: 'graph_chain_step',         title: this.t('Expand chain +1 step'), value: p.graph_chain_step === true },
                { key: 'graph_chain_all',          title: this.t('Expand chain (all steps)'), value: p.graph_chain_all === true },
                // IE 2026 09 06 / ODOO-335246 (Igor): не ужимать раскладку — минимальный шаг между узлами в пикселях, при нехватке места полоса прокрутки
                { key: '_rectSelect', title: this.t('Rectangle select (drag on an empty area; Shift adds)'), value: this.rectSelect === true, local: true },
                // IE 2026 09 17 / ODOO-… (заказ Игоря: «Flow-tree-map»): вид карты — области стран, меры в размере и цвете узлов и связей
                { key: 'graph_map', title: this.t('Map view (areas, measures in nodes and links)'), value: this.mapViewOn, local: true, viewParam: true },
                { key: 'graph_areas', title: this.t('Map view: country areas'), value: this.mapAreasOn, local: true, viewParam: true },
                { key: 'graph_ants', title: this.t('Flow map: ants along the edges'), value: p.graph_ants === true, local: true },   // IE 2026 09 15 / ODOO-… (замечание Игоря)
                { key: 'graph_ants_total', title: this.t('Flow map: start with whole-period totals (Σ)'), value: p.graph_ants_total !== false, local: true },   // IE 2026 09 16 (заказ Игоря)
                { key: 'graph_nudge_off_links', title: this.t('Move nodes off the links crossing their labels'), value: p.graph_nudge_off_links !== false, local: true },   // IE 2026 09 14 / ODOO-335246 (Igor)   // IE 2026 09 06 (Igor)
                { key: 'graph_no_squeeze_y',       title: this.t('Keep vertical spacing (scroll)') + (p.graph_no_squeeze_y === undefined ? ' · ' + this.t('auto') : ''), value: this.effNoSqY() },   // IE 2026 09 12 (Igor): авто, пока не менял пользователь
                { key: 'graph_no_squeeze_x',       title: this.t('Keep horizontal spacing (scroll)'), value: p.graph_no_squeeze_x === true },
                // IE 2026 09 07 / ODOO-335246 (Igor): колесо / трекпад при полосах прокрутки — по умолчанию прокрутка; с флагом — масштаб камеры
                // IE 2026 09 13 / ODOO-335246 (Igor): опция «Zoom with wheel / trackpad» снята — колесо и тачпад во всех режимах только
                // прокручивают, масштаб — щипком (Ctrl+колесо) и кнопками; сохранённое doc.params.graph_wheel_zoom не читается
                // IE 2026 09 08 / ODOO-335246 (Igor): наведение на узел — соседи и их связи подсвечены, остальное приглушено (во всех графах, по умолчанию вкл)
                { key: 'graph_hover_neighbors', title: this.t('Highlight linked nodes on hover (dim the rest)'), value: p.graph_hover_neighbors !== false },
                // IE 2026 09 13 / ODOO-335246 (Igor): стандартная раскладка Sugiyama (dagre) на фронте — подпись в габарите узла; выкл — координаты бэка
                { key: 'graph_engine_std',         title: this.t('Standard layout (Sugiyama: labels in node size)'), value: p.graph_engine_std === true },   // IE 2026 09 13 (Igor): по умолчанию ВЫКЛ
                // IE 2026 09 05 / ODOO-335246 (Igor): опции, объявленные в атрибуте вью (attr.graphOptions:
                // [{key, title, default}]) — виджет-специфичные переключатели читает бэк из doc.params
                // IE 2026 09 06 / ODOO-335246 (Igor): опция со списком значений (items: [{id, title}]) — выбор одного из
                ...((this.attr?.graphOptions || []).map(o => o.items
                    ? { key: o.key, title: o.title, items: o.items, value: p[o.key] === undefined ? o.default : p[o.key] }
                    : { key: o.key, title: o.title, value: p[o.key] === undefined ? o.default !== false : p[o.key] !== false })),
            ]
        },
        // ===== IE 2026 09 17 / ODOO-… (заказ Игоря: «Flow-tree-map» — граф показывается по правилам карты) =====
        // Области стран — прямоугольники, закрашенные мерой (как территории карты), узлы — диск (мера размера), кольцо
        // (вторая мера) и красное ядро (непокрытое), связи — толщина по мере и красный цвет при непокрытом объёме.
        // Настройки живут в viewParams вкладки графа (dataGraph): graph_map / graph_areas / graph_*_binding.
        mapViewOn() { this.graphOptionsTick; return this.get_viewParam('graph_map', false) === true && this.store.setting('fe.ux.graphMapView', true) !== false },
        mapAreasOn() { this.graphOptionsTick; return this.get_viewParam('graph_areas', true) !== false },
        // поля вью виджета: привязка → определение (заголовок с названием группы, тип, справочник)
        mapFields() {
            const out = new Map()
            const walk = (arr, path) => {
                for (const a of arr || []) {
                    if (!a) continue
                    if (a.binding && !out.has(a.binding)) out.set(a.binding, { ...a, _title: (path ? path + ' · ' : '') + (a.title || a.binding) })
                    const p2 = (a.binding || !a.title) ? path : (a.title || '')
                    if (a.attrs) walk(a.attrs, p2)
                }
            }
            walk(this.store.get_value(this.WIDGET?.record, 'doc.viewList', []), '')
            return out
        },
        // меры узлов: числовые ключи attributes.D в порядке вью
        mapMeasures() {
            void this.mapTick
            const g = this.graph
            if (!g) return []
            const keys = new Set()
            g.forEachNode((n, a) => { const D = a?.D; if (!D) return; for (const k in D) { if (k === 'size') continue; const v = D[k]; if (typeof v === 'number' && Number.isFinite(v)) keys.add(k) } })
            const out = []
            for (const [b, f] of this.mapFields) if (keys.has(b)) { out.push({ binding: b, title: f._title || b }); keys.delete(b) }
            for (const b of keys) out.push({ binding: b, title: b })
            return out
        },
        mapValueBinding() {
            const list = this.mapMeasures
            const has = (b) => b && list.some(m => m.binding === b)
            if (has(this.mapActiveBinding)) return this.mapActiveBinding
            const cfg = this.get_viewParam('graph_value_binding', '')
            if (has(cfg)) return cfg
            for (const b of ['DOS::now', 'open_balance::now', 'IN::rc']) if (has(b)) return b
            return list[0]?.binding || ''
        },
        mapSizeBinding() { return this.mapPickMeasure('graph_point_size_binding', ['open_balance::now', 'IN::rc']) },
        mapRingBinding() { return this.mapPickMeasure('graph_point_ring_binding', ['OUT::rc']) },
        mapCoreBinding() { return this.mapPickMeasure('graph_point_core_binding', ['OOS::rc']) },
        mapLinkValueBinding() { return this.mapPickMeasure('graph_link_value_binding', ['IN::rc', 'OUT::rc']) },
        mapLinkUncBinding() { return this.mapPickMeasure('graph_link_unc_binding', ['OOS::rc']) },
        mapValueTitle() { return this.mapTitleOf(this.mapValueBinding) },
        mapSizeTitle() { return this.mapTitleOf(this.mapSizeBinding) },
        mapRingTitle() { return this.mapRingBinding ? this.mapTitleOf(this.mapRingBinding) : '' },
        mapCoreTitle() { return this.mapCoreBinding ? this.mapTitleOf(this.mapCoreBinding) : '' },
        mapLinkValueTitle() { return this.mapLinkValueBinding ? this.mapTitleOf(this.mapLinkValueBinding) : '' },
        mapLinkUncTitle() { return this.mapLinkUncBinding ? this.mapTitleOf(this.mapLinkUncBinding) : '' },
        // шкала активной меры по УЗЛАМ (заливка узла) и по ОБЛАСТЯМ (заливка страны — как территория карты)
        mapScale() { return this.mapScaleOf((this.mapNodeValues || [])) },
        mapAreaScale() { return this.mapScaleOf(this.mapAreasData.map(a => a.value)) },
        mapNodeValues() {
            void this.mapTick
            const g = this.graph, b = this.mapValueBinding
            const out = []
            if (!g || !b) return out
            g.forEachNode((n, a) => { const v = +(a.D || {})[b]; if (Number.isFinite(v)) out.push(v) })
            return out
        },
        // объёмы связей: суммы меры (и непокрытой меры) строк данных по ключу ребра
        mapLinkVals() {
            void this.mapTick
            const out = new Map()
            const vb = this.mapLinkValueBinding, ub = this.mapLinkUncBinding
            if (!vb) return out
            const walk = (arr) => {
                for (const r of arr || []) {
                    if (!r) continue
                    const ek = r._graph?.edge
                    if (ek) {
                        const D = r.rules?.D || {}
                        const e = out.get(ek) || { value: 0, unc: 0 }
                        const v = +(D[vb] !== undefined ? D[vb] : r[vb]); if (Number.isFinite(v)) e.value += v
                        const u = ub ? +(D[ub] !== undefined ? D[ub] : r[ub]) : NaN; if (Number.isFinite(u)) e.unc += u
                        out.set(ek, e)
                    }
                    if (r.attrs) walk(r.attrs)
                }
            }
            walk(this.data)
            return out
        },
        // ключ (id) значения по названию: узлы графа несут НАЗВАНИЯ стран, чипсу нужен id справочника
        mapCountryIds() {
            void this.mapTick
            const out = new Map()
            const binds = ['country', 'country_rule', 'country_from', 'country_to'].filter(b => this.mapFields.has(b))
            const walk = (arr) => {
                for (const r of arr || []) {
                    if (!r) continue
                    for (const b of binds) {
                        const id = r[b]
                        if (!id || typeof id !== 'string' || out.has(id)) continue
                        const seg = this.mapFields.get(b)?.relation_segment
                        const t = seg && this.store.itemsSource?.[seg]?.ids?.[id]?.title
                        if (t && !out.has(String(t).trim())) out.set(String(t).trim(), { key: id, binding: b })
                    }
                    if (r.attrs) walk(r.attrs)
                }
            }
            walk(this.data)
            return out
        },
        // поле чипса узла: в каких полях строк встречается его id (subject / subject_from / subject_to)
        mapNodeBindings() {
            void this.mapTick
            const out = new Map()
            const binds = ['subject', 'subject_rule', 'subject_from', 'subject_to'].filter(b => this.mapFields.has(b))
            const walk = (arr) => {
                for (const r of arr || []) {
                    if (!r) continue
                    for (const b of binds) { const id = r[b]; if (id && typeof id === 'string' && !out.has(id)) out.set(id, b === 'subject_rule' ? 'subject' : b) }
                    if (r.attrs) walk(r.attrs)
                }
            }
            walk(this.data)
            return out
        },
        // IE 2026 09 25 / ODOO-… (правило Игоря: подсказки только по Alt или опции): меры в бейдже наведения — только пока зажат Alt (и дожитие после
        // отпускания, как у подсказок), в режиме Show tooltips и при fe.ux.hoverTooltips=true; без Alt — чекбокс селектора, иконка записи, название
        badgeDetailsOn() {
            const epoch = this.store.altTipEpoch || 0, show = !!this.store.showTooltip   // реактивные зависимости: эхо Alt (altTooltip._epoch) и опция
            return epoch >= 0 && (show || altTooltip.detailsOn())
        },
        // затухание блока мер после отпускания Alt (пауза прошла): класс alt-details-fading (CSS в App.vue), длительность — fe.data.altTooltipFadeMs
        badgeDetailsFading() {
            const epoch = this.store.altTipEpoch || 0
            return epoch >= 0 && !this.store.showTooltip && altTooltip.detailsFading()
        },
        badgeFadeStyle() {
            return this.badgeDetailsFading ? { transitionDuration: (typeof altTooltip.fadeMs === 'function' ? altTooltip.fadeMs() : 600) + 'ms' } : null
        },
        // блок вкладки Node окна легенды: последний наведённый узел / связь / область
        mapHoverInfo() {
            void this.mapTick
            const el = this.mapHoverEl
            if (!el) return null
            if (el.kind === 'node') return this.mapNodeInfo(el.key)
            if (el.kind === 'edge') return this.mapEdgeInfo(el.key)
            if (el.kind === 'area') return this.mapAreaInfo(el.key)
            return null
        },
        mapSelectedCount() {
            void this.mapTick
            let n = 0
            for (const b of ['subject', 'subject_from', 'subject_to', 'country']) n += this.mapSelectedFor(b).size
            return n
        },
        CHIPS: {
            get() {
                if (!this.WIDGET?.record || !this.attr?.name) return []
                return this.store.get_value(this.WIDGET.record, `doc.viewParams.${this.attr.name}.CHIPS`) || []
            },
            set(value) {
                if (this.WIDGET?.record && this.attr?.name) {
                    this.store.set_value(this.WIDGET.record, `doc.viewParams.${this.attr.name}.CHIPS`, value)
                }
            }
        },
    },
    created() {
        // console.log(`created ${this.attr_id}`)
        this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        this.content_Changed()
    },
    watch: {
        // IE 2026 09 17 / ODOO-… (замечание Игоря): наведение сменилось — пересчитать «пол» размера окна легенды
        mapHoverInfo() { this.mapLegendBox_fix() },
        mapLegendTab() { this.mapLegendBox_reset(); this.mapLegendBox_fix() },
        mapLegendVisible(v) { if (!v) { this.mapLegendBox_reset(); this.legendPanelClosed() } else this.mapLegendBox_fix() },   // IE 2026 09 17 / ODOO-… (заказ Игоря): свободное окно легенды
        // IE 2026 09 11 / ODOO-335246 (Igor): счётчики грязных узлов пришли по штампу опроса (cascade_state_refresh →
        // record._doc.cascade_dirty_ids) — перекрасить иконки и цепочку вниз без перестроения графа
        'WIDGET.record._doc.cascade_dirty_ids': { handler(v) { this.applyDirtyIds(v) }, deep: true },
    },
    mounted() {
        ieGraphLayout.register(this)   // IE 2026 09 13 (Igor): window.ieGraphLayout.apply() перекладывает живые графы
        this.WIDGET.attrsResize.push(this.attrResize)
        this.attrResize()
        // U6 (заказ Игоря: объяснение элементов по Alt): узел / ребро / область страны рисует sigma на canvas (DOM-узлов нет) — источник altTooltip
        // «по точке» на контейнере графа, только в виде карты (graph_map). Ключ — по ЖИВОМУ наведению: узел — state.hoveredNode (enterNode / leaveNode),
        // ребро — _altEdge6 (enterEdge / leaveEdge), область — _rectTipRow (заголовок области под курсором, rectTitleHover). mapHoverEl для этого не годится:
        // он держит ПОСЛЕДНИЙ наведённый элемент для блока Node окна легенды. Подсказка — у курсора и без дожития после Alt; выключатель fe.ux.uiHelp
        if (this.$refs.sigmaRoot) {
            this.$refs.sigmaRoot.__altTipAt = (x, y) => {
                if (!uiHelp_enabled() || !this.mapViewOn) return null
                const node9 = this.state && this.state.hoveredNode
                const area9 = this._rectTipRow && this._rectTipRow._ieArea
                const key9 = node9 ? 'chart.graph.node' : this._altEdge6 ? 'chart.graph.edge' : area9 ? 'chart.graph.area' : ''
                const html9 = key9 ? uiHelp_html(key9) : ''
                return html9 ? { content: html9, rect: new wjcCore.Rect(x - 8, y - 8, 16, 16), noLinger: true } : null
            }
            this.$refs.sigmaRoot.setAttribute('data-alt-tip-at', '')
        }

        this.isMounted = true
        // АН 2026 08 06: content_Changed отрабатывает в created(), то есть ДО mount,
        // и рисовать тогда ещё некуда — граф оставался пустым до первого обновления
        // данных. Если данные уже пришли, строим сразу после монтирования.
        if (this.data_graph) {
            this.load_data(this.data_graph)
        }
        // АН 2026 08 15 / ODOO-4997 (заказ Игоря): приём подсветки от других
        // виджетов (грид/бабл) — ТИХОЕ выделение узлов, без ре-эмита (анти-цикл)
        this._dimHlHandler = (ev) => this.applyDimHighlight(ev?.detail)
        window.addEventListener('wscm-dim-highlight', this._dimHlHandler)
        this.NODE_ICON_PX = 12   // IE 2026 09 10 / ODOO-335246 (Igor): размер иконки типа узла перед подписью, px (один для всех узлов)
        // IE 2026 09 12 / ODOO-335246 (Igor): контейнер появился (скрытая подвкладка показана) — загрузить отложенные данные /
        // переложить раскладку, посчитанную вслепую; событие видимости подвкладок приходит не всегда, размер — всегда
        try {
            const el = this.$refs.attr_container || this.$refs.sigmaRoot
            if (el && typeof ResizeObserver !== 'undefined') { this._ro = new ResizeObserver(() => this.onContainerResize()); this._ro.observe(el) }
        } catch (e) { /* без наблюдателя — как раньше */ }
        try {   // IE 2026 09 12 / ODOO-335246 (Igor): колесо — прокрутка / панорама (не масштаб)
            const elw = this.$refs.sigmaRoot
            // IE 2026 09 13 / ODOO-335246 (Igor): фаза ЗАХВАТА — раньше слушатель висел на всплытии, а слой мыши sigma (дочерний
            // .sigma-mouse) гасил колесо (preventDefault + stopPropagation): тачпад не прокручивал растянутый холст
            if (elw) { this._wheelHandler = (ev) => this.onGraphWheel(ev); elw.addEventListener('wheel', this._wheelHandler, { passive: false, capture: true }) }
        } catch (e) { /* ignore */ }
    },
    beforeUnmount() {
        this.antStop()   // IE 2026 09 15: муравьи
        try { clearTimeout(this._mapBadgeTimer); this.legendPanelClosed() } catch (e) { /* окно легенды уже снято */ }   // IE 2026 09 17 / ODOO-…
        ieGraphLayout.unregister(this)
        if (this._dimHlHandler) window.removeEventListener('wscm-dim-highlight', this._dimHlHandler)
        try { this._ro && this._ro.disconnect() } catch (e) { /* ignore */ }
        try { if (this._wheelHandler && this.$refs.sigmaRoot) this.$refs.sigmaRoot.removeEventListener('wheel', this._wheelHandler, { capture: true }) } catch (e) { /* ignore */ }
        this.kill()
    },
    methods: {
        overlayPortal,   // IE 2026 09 23 / ODOO-… (замечание Игоря: панели-меню в Full screen): портал страницы, а в полноэкране виджета — сам виджет
        // IE 2026 09 20 / ODOO-… (Игорь: легенда закрывается вместе с виджетом и на вкладке, к которой не относится)
        legendOwner_flagOn() { return !!this.mapLegendVisible },
        legendOwner_close() { this.mapLegendVisible = false },
        legendOwner_related() { return false },
        // АН 2026 08 09: шестерёнка графа — hover: быстрые настройки; клик: виджет
        // строки настроек (поведение как у AttrGrid.onToggle_gridSettings)
        onShow_graphQuickSettings() {
            if (this.timerId_graphQuickSettings) clearTimeout(this.timerId_graphQuickSettings)
            this.timerId_graphQuickSettings = setTimeout(() => { this.show_graphQuickSettings = true }, this.store.setting('fe.ux.chartSettingsHoverMs', 500))   // IE 2026 09 05 / ODOO-336330
        },
        onClose_graphQuickSettings() {
            if (this.timerId_graphQuickSettings) clearTimeout(this.timerId_graphQuickSettings)
            this.timerId_graphQuickSettings = setTimeout(() => { this.show_graphQuickSettings = false }, this.store.setting('fe.ux.hoverHideMs', 200))   // IE 2026 09 05 / ODOO-336330
        },
        setGraphOption(opt, value) {   // IE 2026 09 06 / ODOO-335246 (Igor): опция-список
            const params = this.WIDGET.record.doc.params = this.WIDGET.record.doc.params || {}
            params[opt.key] = value
            this.graphOptionsTick++
            this.store.executeStoreMethod(this.WIDGET.vueObj, { command: 'executeWidgetMethod', method: 'select' }, this.attr)
        },
        toggleGraphOption(opt) {
            if (opt.local) {   // локальный режим (выделение прямоугольником) — без запроса к бэку
                if (opt.viewParam) {   // IE 2026 09 17 / ODOO-… (заказ Игоря): настройка вкладки графа (viewParams) — сохраняется с виджетом
                    this.store.set_viewParam(this.WIDGET, this.attr.name, opt.key, !opt.value, this.attr)
                    this.graphOptionsTick++
                    this.$nextTick(() => { try { this.mapView_apply() } catch (e) { console.warn('graph map view skipped', e) } this.refresh() })
                    return
                }
                if (opt.key === '_rectSelect') this.onRectSelect__Click()
                if (opt.key === 'graph_ants_total') {   // IE 2026 09 16 (заказ Игоря): старт в Σ; живые часы переключить сразу
                    const params = this.WIDGET.record.doc.params = this.WIDGET.record.doc.params || {}
                    params.graph_ants_total = !opt.value
                    const c = this.antClockObj
                    if (c && !!c.total !== params.graph_ants_total) antClockTotal(c)
                }
                if (opt.key === 'graph_ants') {   // IE 2026 09 15 / ODOO-… (замечание Игоря): муравьи по рёбрам
                    const params = this.WIDGET.record.doc.params = this.WIDGET.record.doc.params || {}
                    params.graph_ants = !opt.value
                    this.$nextTick(() => this.antEnsure())
                }
                if (opt.key === 'graph_nudge_off_links') {   // IE 2026 09 14 / ODOO-335246 (Igor): переложить от базовых координат — конец graphPostLayout запустит проход подписей
                    const params = this.WIDGET.record.doc.params = this.WIDGET.record.doc.params || {}
                    params[opt.key] = !opt.value
                    try { this.graphPostLayout(); if (this._graphBBox && this.sigma) this.sigma.setCustomBBox(this._graphBBox); this.refresh() } catch (e) { console.warn('graph relayout skipped', e) }
                }
                this.graphOptionsTick++
                return
            }
            const params = this.WIDGET.record.doc.params = this.WIDGET.record.doc.params || {}
            params[opt.key] = !opt.value
            if (opt.key === 'graph_no_squeeze_y' && !params[opt.key]) this.autoNoSqY = false   // IE 2026 09 13 (Igor): снятие флага гасит и авто-режим
            this.graphOptionsTick++
            // перечитать граф: запись уходит в запросе, бэк соберёт с новыми опциями
            this.store.executeStoreMethod(this.WIDGET.vueObj, { command: 'executeWidgetMethod', method: 'select' }, this.attr)
        },
        // IE 2026 09 07 / ODOO-335246 (Igor): камера sigma (колесо = масштаб, перетаскивание = панорама) включена, когда холст
        // не растянут под прокрутку (keep spacing выкл) или стоит флаг graph_wheel_zoom; иначе колесо и drag отдаются
        // нативной прокрутке контейнера. Эта сборка sigma читает camera.enabledZooming/enabledPanning (не settings) — ставим оба
        applyCameraMode() {
            if (!this.sigma) return
            const wheelZoom = false   // IE 2026 09 13 / ODOO-335246 (Igor): колесо не масштабирует ни в одном режиме (щипок — onGraphWheel)
            const on = !this._noSqueezeApplied
            // IE 2026 09 12 / ODOO-335246 (Igor): масштаб колесом — только по опции «Zoom with wheel / trackpad»; иначе колесо
            // прокручивает (onGraphWheel), масштаб — кнопками слева сверху; перетаскивание мышью — панорама, как раньше
            try { this.sigma.setSetting('enableCameraZooming', wheelZoom); this.sigma.setSetting('enableCameraPanning', on) } catch (e) { /* нет такой настройки в этой версии */ }
            try { const cam = this.sigma.getCamera(); cam.enabledZooming = wheelZoom; cam.enabledPanning = on } catch (e) { console.warn('camera mode skipped', e) }
        },
        // IE 2026 09 13 / ODOO-335246 (Igor): пользовательские коэффициенты раскладки по осям (doc.params.graph_scale_y / _x, 1 = как есть):
        // высота — шаг между рядами узлов (холст выше области → прокрутка; меньше 1 — граф ужимается на экран), ширина — шаг между колонками
        userScale() {
            const p = this.WIDGET?.record?.doc?.params || {}
            const num = (v) => { const n = Number(v); return isFinite(n) && n > 0 ? n : 1 }
            return { fx: num(p.graph_scale_x), fy: num(p.graph_scale_y) }
        },
        scaleAxis(axis, f) {
            const params = this.WIDGET.record.doc.params = this.WIDGET.record.doc.params || {}
            const key = axis === 'x' ? 'graph_scale_x' : 'graph_scale_y'
            const cur = this.userScale()[axis === 'x' ? 'fx' : 'fy']
            let v = Math.max(0.2, Math.min(8, cur * f))
            if (Math.abs(v - 1) < 0.02) v = 1
            params[key] = v
            try { this.graphPostLayout(); if (this.sigma) { this.sigma.resize(); if (this._graphBBox) this.sigma.setCustomBBox(this._graphBBox); this.sigma.resize(); this.applyCameraMode(); this.refresh() } } catch (e) { console.warn('scale axis skipped', e) }
        },
        // IE 2026 09 12 / ODOO-335246 (Igor): кнопки масштаба; f < 1 — ближе, f > 1 — дальше
        zoomBy(f) {
            if (!this.sigma) return
            // камера с выключенным масштабом колесом (enabledZooming=false) отбрасывает ratio в setState — на время анимации включаем
            try { const cam = this.sigma.getCamera(); const st = cam.getState(); const was = cam.enabledZooming; cam.enabledZooming = true
                cam.animate({ ...st, ratio: st.ratio * f }, { duration: 250, easing: 'quadraticInOut' }, () => { cam.enabledZooming = was }) } catch (e) { console.warn('zoom skipped', e) }
        },
        zoomFit(opts) {
            // IE 2026 09 13 / ODOO-335246 (Igor): «Fit to view» = граф целиком в области виджета: коэффициенты высоты / ширины → 1,
            // Keep vertical / horizontal spacing → выкл (растянутый холст под прокрутку вписать нельзя), прокрутка в начало,
            // раскладка заново, камера в исходное положение. Раньше только сбрасывалась камера — растянутый холст оставался
            // IE 2026 09 26 / ODOO-… (дефект Игоря: кнопки раскладки графа не вписывают граф): opts.relayout — раскладка заново от базы (после Assign /
            // остановки Webworker), opts.keepOptions — флаги Keep spacing пользователя не трогать; без перекладки габарит (кастомный bbox sigma) — по ТЕКУЩИМ
            // координатам узлов: прежний оставлял за краем узлы, ушедшие из него (раскладка кнопкой, перетаскивание)
            const o = (opts && typeof opts === 'object') ? opts : {}
            try {
                const params = this.WIDGET.record.doc.params = this.WIDGET.record.doc.params || {}
                const changed = !!o.relayout || params.graph_scale_x !== undefined || params.graph_scale_y !== undefined || this.effNoSqY() || params.graph_no_squeeze_x === true   // IE 2026 09 26 / ODOO-…: + relayout
                delete params.graph_scale_x; delete params.graph_scale_y
                if (!o.keepOptions) { params.graph_no_squeeze_y = false; params.graph_no_squeeze_x = false }   // IE 2026 09 26 / ODOO-…
                this.autoNoSqY = false
                const cont = this.$refs.attr_container
                if (cont) { cont.scrollTop = 0; cont.scrollLeft = 0 }
                if (changed) { this.graphPostLayout(); if (this.sigma) { this.sigma.resize(); if (this._graphBBox) this.sigma.setCustomBBox(this._graphBBox); this.sigma.resize(); this.applyCameraMode() } }
                else if (this.sigma) this.graphBBox_update()   // IE 2026 09 26 / ODOO-…: все узлы — габарит по текущим координатам
                this.graphOptionsTick++
            } catch (e) { console.warn('fit layout skipped', e) }
            if (!this.sigma) return
            try { const cam = this.sigma.getCamera(); const wz = cam.enabledZooming, wp = cam.enabledPanning; cam.enabledZooming = true; cam.enabledPanning = true
                cam.animatedReset({ duration: 250 }, () => { cam.enabledZooming = wz; cam.enabledPanning = wp; this.refresh() }) } catch (e) { console.warn('fit skipped', e) }
        },
        // IE 2026 09 26 / ODOO-… (дефект Игоря: кнопки раскладки графа не вписывают граф): раскладка кнопкой (Assign, остановка Webworker) меняла x/y узлов,
        // а кастомный bbox sigma и база раскладки (_xB/_yB — координаты бэка) оставались от прежней: нормировка по старому габариту уводила узлы за край,
        // «Fit to view» сбрасывал только камеру, растянуть / сжать по осям возвращали раскладку бэка. Теперь текущие координаты — база свободной раскладки
        // (_xF/_yF, флаг layoutFree): кнопки осей, «Вписать» и ресайз работают от неё; коэффициенты осей → 1; перекладка и камера в исходное положение
        layoutAdopt() {
            const g = this.graph
            if (!g) return false
            g.forEachNode((n, a) => { g.mergeNodeAttributes(n, { _xF: a.x, _yF: a.y }) })
            this.layoutFree = true
            this._layoutStd = false   // стандартная раскладка (Sugiyama) заменена — её правила холста 1:1 больше не действуют
            this.autoNoSqY = false
            const params = this.WIDGET?.record?.doc?.params
            if (params) { delete params.graph_scale_x; delete params.graph_scale_y }
            return true
        },
        layoutAdoptFit() {
            this._layoutRunning = false
            if (!this.layoutAdopt()) return
            this.zoomFit({ relayout: true, keepOptions: true })
        },
        // ход раскладки Webworker: холст — в область (свободная раскладка без коэффициентов), на время хода кастомный bbox выключен (нормировка sigma по
        // габариту узлов на каждом кадре), камера в исходном положении — граф в окне; вписывание с полями под подписи — по остановке (layoutAdoptFit)
        layoutRunBegin() {
            this._layoutRunning = false
            if (!this.layoutAdopt()) return
            try {
                const cont = this.$refs.attr_container
                if (cont) { cont.scrollTop = 0; cont.scrollLeft = 0 }
                this.graphPostLayout()
            } catch (e) { console.warn('graph layout run prepare skipped', e) }
            this._layoutRunning = true
            this._graphBBox = null
            if (!this.sigma) return
            try {
                this.sigma.setCustomBBox(null)
                const cam = this.sigma.getCamera(), wz = cam.enabledZooming, wp = cam.enabledPanning
                cam.enabledZooming = true; cam.enabledPanning = true
                cam.setState({ x: 0.5, y: 0.5, ratio: 1, angle: 0 })
                cam.enabledZooming = wz; cam.enabledPanning = wp
            } catch (e) { console.warn('graph layout run camera skipped', e) }
        },
        // IE 2026 09 12 / ODOO-335246 (Igor): колесо / тачпад — всегда прокрутка: растянутый холст (keep spacing) крутит контейнер
        // нативно, иначе панорама камеры sigma; Ctrl+колесо (pinch тачпада) — масштаб. По опции graph_wheel_zoom — прежнее поведение
        onGraphWheel(ev) {
            // IE 2026 09 13 / ODOO-335246 (Igor): ОДНО поведение во всех режимах — колесо / тачпад только прокручивают (растянутый
            // холст: сдвиг scrollTop/scrollLeft контейнера своими руками и preventDefault, чтобы прокрутка не уходила цепочкой на
            // страницу и не «перепрыгивала» назад; иначе — панорама камеры ровно на дельту в пикселях); масштаб — только щипком
            // (Ctrl/Meta+колесо), плавно по величине дельты, и кнопками «+ / − / Fit»
            if (!this.sigma) return
            ev.stopPropagation()   // IE 2026 09 13 (Igor): колесо обрабатываем сами — до слоя мыши sigma
            const cont = this.$refs.attr_container
            const cam = this.sigma.getCamera(); const st = cam.getState()
            if (ev.ctrlKey || ev.metaKey) {
                ev.preventDefault()
                const f = Math.exp(Math.max(-40, Math.min(40, ev.deltaY)) * 0.01)
                const was = cam.enabledZooming; cam.enabledZooming = true
                try { cam.setState({ ...st, ratio: cam.getBoundedRatio ? cam.getBoundedRatio(st.ratio * f) : st.ratio * f }) } finally { cam.enabledZooming = was }
                return
            }
            if (cont && (cont.scrollHeight > cont.clientHeight + 2 || cont.scrollWidth > cont.clientWidth + 2)) {
                ev.preventDefault()
                const t0 = cont.scrollTop, l0 = cont.scrollLeft
                cont.scrollTop = Math.max(0, Math.min(cont.scrollHeight - cont.clientHeight, cont.scrollTop + ev.deltaY))
                cont.scrollLeft = Math.max(0, Math.min(cont.scrollWidth - cont.clientWidth, cont.scrollLeft + ev.deltaX))
                if (cont.scrollTop !== t0 || cont.scrollLeft !== l0) return   // IE 2026 09 13 (Igor): на границе прокрутки — панорама камеры
            }
            ev.preventDefault()
            // IE 2026 09 13 / ODOO-335246 (Igor): в растянутом режиме панорама камеры выключена (applyCameraMode) и setState молча
            // отбрасывал x/y — колесо «не двигало» граф после растяжки; на время сдвига панорама включается
            const wp = cam.enabledPanning; cam.enabledPanning = true
            try {   // сдвиг ровно на deltaX/deltaY пикселей экрана
                const p0 = this.sigma.viewportToFramedGraph({ x: 0, y: 0 }), p1 = this.sigma.viewportToFramedGraph({ x: ev.deltaX, y: ev.deltaY })
                cam.setState({ ...st, x: st.x + (p1.x - p0.x), y: st.y + (p1.y - p0.y) })
            } catch (e) {
                const { width, height } = this.sigma.getDimensions()
                if (width && height) cam.setState({ ...st, x: st.x + (ev.deltaX / width) * st.ratio, y: st.y - (ev.deltaY / height) * st.ratio })
            } finally { cam.enabledPanning = wp }
        },
        onToggle_graphSettings() {
            const vueObj = this
            const WRow = vueObj.store.get_childrenWidget(vueObj.WIDGET, 'widget-row')
            if (WRow && !WRow._softClosed && WRow.parentAction?.type === 'widget-row-viewParams' && WRow.record?._meta?.binding === this.attr.binding) {
                vueObj.store.widget_close(WRow.id)
                return
            }
            const cogEl = this.$refs.cogButton
            const widgetEl = document.getElementById('WIDGET' + vueObj.WIDGET.id)
            let x, y
            if (cogEl && widgetEl) {
                const cr = cogEl.getBoundingClientRect()
                const wr = widgetEl.getBoundingClientRect()
                x = cr.left - wr.left + cr.width / 2
                y = cr.top - wr.top + cr.height / 2
            }
            const actionMenu = {
                command: 'widget_open',
                'widget': 'widget-row',
                'type': 'widget-row-viewParams',
                'source_attr_type': 'AttrGraph',
                '_activate': true,
                'binding': vueObj.attr.binding,
                'source_name': vueObj.attr.name,
                'get_Parent': true,
                'open_in_children_widget': true,
                'widgetRow_params': { 'top_pct': 0.2, 'left_pct': 0.2, 'width_pct': 0.8, 'height_pct': 0.8 },
                selectedCog: { x, y },
            }
            this.show_graphQuickSettings = false
            vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, actionMenu, vueObj.attr)
        },
        content_Changed() {
            this.store.widget_attr_set(this)
            
            // let dateStr = this.store.attr_get(this.WIDGET, this.attr)
            // date = wjcCore.asDate(date)
            
            const [doc, binding] = this.store.attr_get_link(this.WIDGET, this.attr)
            this.doc = doc,
            this.binding = binding // data_graph

            this.data = this.store.get_value(this.WIDGET.record, '_doc.data', [])

            this.data_graph = doc[binding]
            if (this.netOn() && this.netSelectorStale()) return   // webscm 2026 10 23 / Odoo 348730: ответ по прежним чипсам — не рисуем, ушёл перезапрос
            if (this.isMounted && this.data_graph) {
                this.load_data(this.data_graph)
            }
        },
        // IE 2026 09 12 / ODOO-335246 (Igor): обновление данных графа с той же структурой (те же узлы с теми же базовыми
        // координатами, те же рёбра, те же области) — ТОЧЕЧНО: атрибуты узлов/рёбер (грязность, ошибки, флаги, цвета, подписи)
        // переписываются в живом графе без пересборки и перераскладки (камера, выделение и подсветка сохраняются;
        // граф на скрытой вкладке не считает раскладку по нулевой высоте). Иначе — полная пересборка (load_data).
        tryPatchGraph(dg) {
            const g = this.graph
            if (!g || !this.sigma || !dg) return false
            const nodes = dg.nodes || [], edges = dg.edges || []
            if (nodes.length !== g.order || edges.length !== g.size) return false
            for (const n of nodes) {
                if (!n?.key || !g.hasNode(n.key)) return false
                const a = g.getNodeAttributes(n.key), na = n.attributes || {}
                if (a._xB !== na.x || a._yB !== na.y) return false
            }
            for (const e of edges) { if (!e?.key || !g.hasEdge(e.key) || g.source(e.key) !== e.source || g.target(e.key) !== e.target) return false }
            const rOld = (this.data_graph?.graphContext || []).filter(r => !r._ieArea), rNew = (dg.graphContext || [])   // IE 2026 09 17: области вида карты — свои строки, не с бэка
            if (rOld.length !== rNew.length) return false
            for (let i = 0; i < rOld.length; i++) {
                const a = rOld[i], b = rNew[i]
                if ((a.type || '') !== (b.type || '') || (a._y0B ?? a.y0) !== b.y0 || (a._y1B ?? a.y1) !== b.y1 || (a._x0B ?? a.x0 ?? null) !== (b.x0 ?? null) || (a._x1B ?? a.x1 ?? null) !== (b.x1 ?? null)) return false
            }
            const KEEP = new Set(['x', 'y', '_xB', '_yB', 'highlighted', 'selector'])   // состояние взаимодействия и раскладка — не трогаем
            const STATE = ['dirty', 'error', 'own', 'flag_use', 'flag_auto', 'hollow', 'color_body', 'stale', 'wait']   // IE 2026 09 12 (Igor): + hollow
            for (const n of nodes) {
                const cur = g.getNodeAttributes(n.key), na = n.attributes || {}, upd = {}
                for (const k of STATE) if (k in cur && !(k in na)) g.removeNodeAttribute(n.key, k)
                for (const [k, v] of Object.entries(na)) if (!KEEP.has(k)) upd[k] = v
                g.mergeNodeAttributes(n.key, upd)
            }
            this.applyNodeScheme(g, true)   // IE 2026 09 13 / ODOO-335246 (Igor): схема маркировки узлов (заливка = состояние, обводка = участие)
            for (const e of edges) { if (!('mark' in (e.attributes || {})) && g.hasEdgeAttribute(e.key, 'mark')) g.removeEdgeAttribute(e.key, 'mark'); g.mergeEdgeAttributes(e.key, { ...(e.attributes || {}) }) }   // IE 2026 09 13 (Igor): снятая пометка ребра
            // области: геометрия старых строк (уже растянутых раскладкой) + остальные поля из новых
            for (let i = 0; i < rOld.length; i++) {
                const a = rOld[i], b = rNew[i]
                for (const [k, v] of Object.entries(b)) if (!['x0', 'x1', 'y0', 'y1', '_y0B', '_y1B', '_x0B', '_x1B'].includes(k)) a[k] = v
            }
            dg.graphContext = rOld
            this.data_graph = dg
            this.linksPanel = null
            try { this.mapView_apply() } catch (e) { console.warn('graph map view skipped', e) }   // IE 2026 09 17 / ODOO-… (заказ Игоря)
            this.refresh()
            if (this.labelsLive()) this.labelsSchedule(null, true)   // IE 2026 09 14 / ODOO-335246 (Igor)
            return true
        },
        // IE 2026 09 13 / ODOO-335246 (Igor): движок раскладки — 'std' (Sugiyama/dagre на фронте, подпись в габарите узла) или 'be'
        // (координаты бэка как были). Флаги: window.ieGraphLayout.get() / set({engine:'be'}) / reset() / apply(); URL ?graph_layout=be;
        // шестерёнка графа — «Standard layout (Sugiyama)». Сырые данные бэка хранятся в _rawDataGraph — для apply() без перезапроса.
        applyLayoutEngine(data_graph) {
            this._rawDataGraph = data_graph
            const opts = ieGraphLayout.get(this.WIDGET?.record?.doc?.params)
            this._layoutStd = opts.engine === 'std'
            if (!this._layoutStd) return data_graph
            try {
                const st = this.sigma ? { labelSize: this.sigma.getSetting('labelSize') || 14, labelFont: this.sigma.getSetting('labelFont') || 'Arial', labelWeight: this.sigma.getSetting('labelWeight') || '' } : null
                const res = layoutStd(data_graph, opts, st)
                this._layoutStd = !!res?._layoutStd
                if (this._layoutStd) this.data_graph = res   // graphPostLayout / области читают this.data_graph
                return res
            } catch (e) { console.warn('ieGraphLayout: std layout failed — backend coordinates', e); this._layoutStd = false; return data_graph }
        },
        load_data(data_graph) {
            if (this.netOn() && this._netReselect) return   // webscm 2026 10 23 / Odoo 348730: ждём перезапрос по новым чипсам — устаревшие данные не рисуем
            const vueObj = this
            // IE 2026 09 12 / ODOO-335246 (Igor): контейнер скрыт (подвкладка Params / другая вкладка) — раскладку по нулевой высоте не
            // считать: данные ждут появления контейнера (onContainerResize); уже построенный граф остаётся до тех пор
            try {
                const r0 = this.$refs.sigmaRoot?.getBoundingClientRect?.()
                if (this.isMounted && r0 && (r0.width <= 50 || r0.height <= 50)) { this._pendingData = data_graph; return }
            } catch (e) { /* без замера — как раньше */ }
            data_graph = this.applyLayoutEngine(data_graph)   // IE 2026 09 13 / ODOO-335246 (Igor): опциональная стандартная раскладка (Sugiyama/dagre), флаги window.ieGraphLayout
            if (this.tryPatchGraph(data_graph)) { if (this._layoutStale) this.relayoutNow(); return }   // IE 2026 09 12 (Igor): та же структура — точечно; слепая раскладка — переложить
            // АН 2026 08 11: при пересборке графа (обновление отчёта) открытый
            // попап настроек графа теряет привязку и перерождается в форму
            // другого атрибута — закрываем его
            try {
                const WRow = this.store.get_childrenWidget(this.WIDGET, 'widget-row')
                if (WRow && WRow.parentAction?.type === 'widget-row-viewParams'
                    && WRow.parentAction?.source_attr_type === 'AttrGraph') {
                    this.store.widget_close(WRow.id)
                }
            } catch (e) { console.warn('close viewParams popup skipped', e) }
            this.params = this.store.str_toJSON(this.WIDGET, this.WIDGET?.record?.doc?.params?.['graph-eval'] || this.attr?.graphEval || '')   // IE 2026 09 07 / ODOO-335246 (Igor): умолчание из вью (attr.graphEval), если у записи нет graph-eval
            // ODOO-3221: opt-in карточка строки на hover (см. data.tooltip_widget)
            this.tooltip_widget = this.params['command-hoveredNode']?.tooltip_widget || ''
            this.linksPanel = null // граф пересобирается — панель связей устарела

            // this.is_load_data = true
            const graph = this.graph = new graphology.Graph()
            // IE 2026 10 26 / ODOO-348733 (заказ webscm #105553: netOn и реактивные чтения в редьюсерах на каждый проход): graphology хранит объект attributes по ссылке — из записи Pinia это прокси Vue, и sigma на каждом проходе копирует его
            // Object.assign по прокси (~190 мс на 7 181 / 16 520); toRaw — сырое дерево целиком (прокси Vue создаёт лениво при чтении). false — как было
            graph.import(this.store.setting('fe.perf.graphRawImport', true) !== false ? toRaw(data_graph) : data_graph)
            if (this.netOn()) this.netSelWatch(graph)   // webscm 2026 10 23 / Odoo 348730: выделение узлов → их связи (netEdgeReduce)
            // IE 2026 09 11 / ODOO-335246 (Igor, два флага): узел задачи без Use in calculation cascade (attributes.flag_use === false) —
            // пустое тело: заливка белая, цвет узла уходит в color_body и рисуется кольцом (drawFlagMarks); иконка/подписи — тем же цветом
            this.applyNodeScheme(graph, true)   // IE 2026 09 13 / ODOO-335246 (Igor): схема маркировки узлов (заливка = состояние, обводка = участие)

            // IE 2026 08 21: снапшот базовых координат узлов и graphContext.
            // Растяжка по вертикали и «змейка» переехали в graphPostLayout() и
            // переприменяются при ресайзе виджета: первый рендер считал k по ещё
            // не финальной высоте контейнера, и граф оставался узкой полосой
            // до ручного обновления.
            this.layoutFree = false; this._layoutRunning = false   // IE 2026 09 26 / ODOO-…: новые данные — раскладка бэка (база _xB/_yB)
            graph.forEachNode((n, a2) => { graph.mergeNodeAttributes(n, { _xB: a2.x, _yB: a2.y }) })
            for (const r of data_graph.graphContext || []) {
                if (r.y0 != null && r._y0B == null) r._y0B = r.y0
                if (r.y1 != null && r._y1B == null) r._y1B = r.y1
                if (r.x0 != null && r._x0B == null) r._x0B = r.x0   // IE 2026 09 13 / ODOO-335246 (Igor): и по x — иначе кнопки ширины копили масштаб областей
                if (r.x1 != null && r._x1B == null) r._x1B = r.x1
            }

            this.graphPostLayout()


            // АН 2026 08 11 (замечание Андрея): все узлы мелкие — непропорционально;
            // поднимаем РАВНОМЕРНО до читаемого максимума, пропорции сохраняются
            try {
                let mxSize = 0
                graph.forEachNode((n, a2) => { if ((a2.size || 0) > mxSize) mxSize = a2.size || 0 })
                if (mxSize > 0 && mxSize < 8) {
                    const kS = 8 / mxSize
                    graph.updateEachNodeAttributes((n, a2) => ({ ...a2, size: (a2.size || 1) * kS }))
                }
            } catch (e) { console.warn("graph size boost skipped", e) }

            // АН 2026 08 09: стрелки направления на рёбрах (Edge arrows, дефолт ВКЛ);
            // встречные рёбра A->B и B->A дают стрелки на обоих концах
            if (this.WIDGET?.record?.doc?.params?.graph_edge_arrows !== false) {
                graph.forEachEdge((e) => {
                    if (!graph.getEdgeAttribute(e, 'type')) graph.setEdgeAttribute(e, 'type', 'arrow')
                    // головка стрелки пропорциональна толщине ребра — при size=1 её не видно;
                    // АН 2026 08 10: стрелки заметнее — толще и контрастнее (заказ Андрея)
                    const sz = graph.getEdgeAttribute(e, 'size') || 1
                    if (sz < 3.5) graph.setEdgeAttribute(e, 'size', 3.5)
                    if (!graph.getEdgeAttribute(e, 'color')) graph.setEdgeAttribute(e, 'color', '#9aa0aa')
                })
            }
            
            // Use degrees for node sizes:
            if (this.params['command-select']?.node?.size === 'degree') {
                // graph.forEachNode((node, atts) => {
                //     atts.size = graph.degree(node)
                // })
                const degrees = graph.nodes().map((node) => graph.degree(node))
                const minDegree = Math.min(...degrees)
                const maxDegree = Math.max(...degrees)
                const minSize = 2,
                    maxSize = 15
                
                // const degreeCountMap = {}
                // degrees.forEach((degree) => {
                //     if (!degreeCountMap[degree]) {
                //         degreeCountMap[degree] = 0
                //     }
                //     degreeCountMap[degree]++
                // })
                // const degreeValues = Object.keys(degreeCountMap).map(Number)
                // const minDegree2 = Math.min(...degreeValues)
                // const maxDegree2 = Math.max(...degreeValues)
                
                graph.forEachNode((node) => {
                    const degree = graph.degree(node)
                    const size = Math.round(minSize + ((degree - minDegree) / (maxDegree - minDegree)) * (maxSize - minSize))
                    const currentSize = graph.getNodeAttribute(node, "size") || 0
                    graph.setNodeAttribute( node, "size", size )
                })
            }

            // АН 2026 08 15 / ODOO-4997 (замечание Игоря п.10): точка не должна
            // быть тоньше соединительных линий — минимальный ДИАМЕТР узла ≥ 3
            // толщин самого толстого ребра (size узла в sigma — РАДИУС: ≥ 3·e/2)
            try {
                let mxE = 0
                graph.forEachEdge((e) => {
                    const s = graph.getEdgeAttribute(e, 'size') || 1
                    if (s > mxE) mxE = s
                })
                const minNode = Math.max(6, Math.ceil(mxE * 3 / 2))
                graph.forEachNode((n) => {
                    if ((graph.getNodeAttribute(n, 'size') || 0) < minNode) graph.setNodeAttribute(n, 'size', minNode)
                })
            } catch (e) { console.warn('graph min node size skipped', e) }

            // // baseSize
            // graph.forEachNode((node) => {
            //     const size = graph.getNodeAttribute(node, "size")
            //     graph.setNodeAttribute( node, "baseSize", size )
            // })

            this.layout_start({name:'command-select'})

            let options = { nodeProgramClasses: { square: NodeSquareProgram } }   // IE 2026 09 12 / ODOO-335246 (Igor): квадрат — всегда (задачи каскада)
            if (this.params['command-select']?.['createNodePiechartProgram']) {
                const NodePiechartProgram = createNodePiechartProgram({
                    ...this.params['command-select']?.['createNodePiechartProgram'],
                    // defaultColor: "#BCB7C4",
                    // slices: [
                    //     { color: { value: "#F05454" }, value: { attribute: "OOS" } },
                    //     { color: { value: "#7798FA" }, value: { attribute: "opt" } },
                    //     { color: { value: "#6DDB55" }, value: { attribute: "OS" } },
                    // ]
                })

                options.nodeProgramClasses = {
                    piechart: NodePiechartProgram,
                    square: NodeSquareProgram,   // IE 2026 09 12 / ODOO-335246 (Igor): attributes.type = 'square' (задачи каскада)
                }
            }

            this.apply_CHIPS()
            this.set_highlighted()

            this.kill()
            // АН 2026 08 15 / ODOO-4997: ссылка на компонент с DOM-корня — для
            // диагностики/автотестов (координаты узлов через sigma.graphToViewport)
            if (this.sigmaRoot) this.sigmaRoot.__vueGraph = this
            const sigma = this.sigma = new Sigma( graph, this.sigmaRoot, {
                allowInvalidContainer: true,
                enableEdgeEvents: true,   // АН 2026 08 10: hover по связи (widget-row строки)
                renderEdgeLabels: true, 
                labelRenderedSizeThreshold: -Infinity,
                // IE 2026 09 10 / ODOO-335246 (Igor): подпись узла — иконка типа (атрибут icon) перед текстом; клик по иконке
                // открывает запись узла (как Alt+клик). Всегда, без опции графа
                defaultDrawNodeLabel: (c, d, st) => this.drawNodeLabelIcon(c, d, st),
                defaultDrawNodeHover: (c, d, st) => this.drawNodeHoverIcon(c, d, st),
                defaultDrawEdgeLabel: (c, e, s, t, st) => this.drawEdgeLabelQ(c, e, s, t, st),   // IE 2026 10 25 / ODOO-348925: связи с labelDeclutter — в очередь кадра, прочие — штатно
    
                // IE 2026 09 14 / ODOO-335246 (Igor): головка стрелки у sigma пропорциональна толщине ребра (2.5 × 2 толщины) — при рёбрах 1.2–2.4 px её не
                // видно (Igor: «сделай на связях более явными стрелочки»); коэффициент fe.ux.graphArrowScale (умолчание 2) умножает
                // длину (5 толщин); ширина — 0.6 множителя (2.4 толщины): Igor 15.09 «по длине ок, сделай уже по ширине». 1 — как у sigma
                edgeProgramClasses: {
                    curve: EdgeCurveProgram,
                    curvedArrow: (this.arrowScale() !== 1 ? createEdgeCurveProgram({ arrowHead: { extremity: 'target', lengthToThicknessRatio: 2.5 * this.arrowScale(), widenessToThicknessRatio: 2 * this.arrowScale() * 0.6 } }) : EdgeCurvedArrowProgram),   // IE 2026 09 12 / ODOO-335246 (Igor): обратная связь / ребро назад по уровням — бэк ставит type: 'curvedArrow'
                    arrow: (this.arrowScale() !== 1 ? createEdgeArrowProgram({ lengthToThicknessRatio: 2.5 * this.arrowScale(), widenessToThicknessRatio: 2 * this.arrowScale() * 0.6 }) : EdgeArrowProgram),   // АН 2026 08 09; IE 2026 09 14 / ODOO-335246 (Igor)
                },
                
                // defaultNodeType: "piechart",
                // defaultEdgeType: "curve",

                ...options,
                ...this.params['command-select']?.['sigma-options'] || {},
    
                // itemSizesReference: "positions",
                // zoomToSizeRatioFunction: (ratio) => ratio,   // линейно “как координаты”
                // zoomToSizeRatioFunction: (ratio) => 1 / Math.sqrt(ratio),
                // zoomToSizeRatioFunction: () => 1, // (x) => x,
                // resizeNodes: false,
                // // zoomingEnabled: false,
                // panningEnabled: false,
                // initialCameraState: {
                //     x: 0,
                //     y: 0,
                //     angle: 30,
                //     ratio: 1,
                // },

                // minNodeSize: 0.5,     // или 0.2
                // maxNodeSize: 30,      // по вкусу
                // minEdgeSize: 0.1,
                // maxEdgeSize: 5,
            })

            // ~~~~~~~~~~~~~~~~~~~ graphContext ~~~~~~~~~~~~~~~~~~~
            sigma.createCanvasContext("overlay", {
                afterLayer: "labels", // или "hovers" если хочешь прям поверх hover
                style: { pointerEvents: "none" }, // чтобы мышь проходила насквозь
            });
            const graphContext = sigma.getCanvases().overlay;
            const ctx = graphContext.getContext("2d");
            // IE 2026 09 06 / ODOO-335246 (Igor, п.4.4): подложка под рёбрами — для прямоугольников областей (rect)
            sigma.createCanvasContext("underlay", { beforeLayer: "edges", style: { pointerEvents: "none" } });
            const underlayCanvas = sigma.getCanvases().underlay;
            const ctxUnder = underlayCanvas.getContext("2d");

            // sigma.createCanvasContext("background", {
            //     beforeLayer: "edges",
            //     style: { pointerEvents: "none" },
            // });

            const { width, height } = sigma.getDimensions(); // CSS px
            const dpr = window.devicePixelRatio || 1;

            // CSS размер (как у sigma-labels)
            graphContext.style.width = `${width}px`;
            graphContext.style.height = `${height}px`;
            underlayCanvas.style.width = `${width}px`;
            underlayCanvas.style.height = `${height}px`;

            // Внутренний буфер (как width="2428" height="926")
            graphContext.width = Math.round(width * dpr);
            graphContext.height = Math.round(height * dpr);
            underlayCanvas.width = Math.round(width * dpr);
            underlayCanvas.height = Math.round(height * dpr);
            ctxUnder.setTransform(dpr, 0, 0, dpr, 0, 0);

            // Чтобы рисовать в CSS-пикселях
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
            this.set_ratio1()
            // IE 2026 08 21: поле под титулы правых узлов действует с первого кадра
            if (this._graphBBox) sigma.setCustomBBox(this._graphBBox)
            // IE 2026 09 07 / ODOO-335246 (Igor): перестроение графа (смена опции) создаёт НОВЫЙ экземпляр sigma — режим
            // keep spacing (размер холста, отключённые зум/панорамирование камеры) нужно применить к нему заново
            try { this.graphPostLayout(); if (this._graphBBox) sigma.setCustomBBox(this._graphBBox) } catch (e) { console.warn('postlayout after sigma skipped', e) }
            this.$nextTick(() => this.autoCheckSpacing())   // IE 2026 09 12 (Igor): авто «Keep vertical spacing» по реальной геометрии

            // IE 2026 09 10 / ODOO-335246 (Igor): шрифт иконок типов узлов — перерисовать подписи, когда он загрузится
            try { document.fonts?.load?.('16px primeicons').then(() => { if (this.sigma === sigma) sigma.refresh() }) } catch (e) { /* шрифт иконок уже загружен */ }
            sigma.on('beforeRender', () => { this._iconBoxes = {} })
            sigma.on('beforeRender', () => { this._elQ = null; this._nlBoxes = null; this._inRender = true })   // IE 2026 10 25 / ODOO-348925: очередь подписей связей кадра; прямоугольники подписей узлов кадра
            sigma.on('afterRender', () => { this._inRender = false; this.drawEdgeLabelsQ() })   // IE 2026 10 25 / ODOO-348925: подписи связей схемы — после всех слоёв кадра, разом
            this.$nextTick(() => this.antEnsure())   // IE 2026 09 15: муравьи по рёбрам (после сборки графа)   // IE 2026 09 10 (Igor): прямоугольники иконок — заново на каждый кадр
            const redrawOverlay = () => {
                // rect — на подложке, остальное — поверх подписей
                // IE 2026 09 17 / ODOO-… (заказ Игоря): строки берём из ЖИВОГО data_graph — области стран вида карты
                // добавляются в него после раскладки (mapView_applyAreas), замыкание держало прежний массив
                const rows = (this.data_graph || data_graph).graphContext || []
                this.drawGraphContext({ sigma, ctx: ctxUnder, data_graph: { ...data_graph, graphContext: rows.filter(r => r.type === 'rect' || r.type === 'fillRect') } });
                this.drawGraphContext({ sigma, ctx, data_graph: { ...data_graph, graphContext: rows.filter(r => r.type !== 'rect' && r.type !== 'fillRect') }, overlay: true });   // IE 2026 09 10 (Igor): верхний слой — полное название области при наведении
                this.drawOwnNodeRing(sigma, ctx)   // IE 2026 09 11 (Igor): кольцо вокруг узла записи, в форме которой построен каскад
                this.drawFlagMarks(sigma, ctx)   // IE 2026 09 11 (Igor, два флага): пустое тело без флага участия, значок автозапуска
                this.mapGlyphs(sigma, ctx)   // IE 2026 09 17 / ODOO-… (заказ Игоря): кольцо и красное ядро узла — как глиф точки карты
                if (this.mapBadge) this.mapBadge_place()   // подпись наведения следует за узлом при панораме / масштабе
            };

            vueObj.overlayScheduled = false;
            vueObj.lastState = null;

            const scheduleOverlayRedraw = () => {
                const state = sigma.getCamera().getState();

                if (vueObj.lastState &&
                    state.x === vueObj.lastState.x &&
                    state.y === vueObj.lastState.y &&
                    state.ratio === vueObj.lastState.ratio &&
                    state.angle === vueObj.lastState.angle) {
                    // return;
                    12
                }

                vueObj.lastState = { ...state };

                if (!vueObj.overlayScheduled) {
                    vueObj.overlayScheduled = true;
                    this._ovRaf = requestAnimationFrame(() => {
                        this._ovRaf = null;
                        vueObj.overlayScheduled = false;
                        if (!sigma || this.sigma !== sigma) return;   // IE 2026 11 01 / ODOO-349799 (дефект webscm #122495: гонка кадру sigma після kill): sigma убита (kill) до кадра
                        redrawOverlay();
                    });
                }
            };

            this._scheduleOverlayRedraw = scheduleOverlayRedraw   // IE 2026 09 10 / ODOO-335246 (Igor): перерисовка областей при их перетаскивании
            // перехват refresh
            const originalRefresh = sigma.refresh.bind(sigma);
            const rsnap = snapCache(() => reducerSnapRead(this))   // IE 2026 10 26 / ODOO-348733 (заказ webscm #105553: netOn и реактивные чтения в редьюсерах на каждый проход): снимок состояния редьюсеров — один на проход sigma (utils/graphReducerSnap.js)
            sigma.refresh = (opts) => {
                rsnap.reset()   // IE 2026 10 26 / ODOO-348733 (заказ webscm #105553: netOn и реактивные чтения в редьюсерах на каждый проход): полный проход редьюсеров идёт внутри refresh — снимок заново перед каждым
                originalRefresh(opts);
                scheduleOverlayRedraw();
            };

            // Камера/интеракции
            sigma.getCamera().on("updated", scheduleOverlayRedraw);

            // Resizes (если есть)
            window.addEventListener("resize", scheduleOverlayRedraw);
            // IE 2026 09 06 (Igor): прокрутка контейнера (режим keep spacing) — подписи дорожек липнут к видимому углу
            if (this.$refs.attr_container && !this._scrollRedrawBound) {
                this._scrollRedrawBound = true
                this.$refs.attr_container.addEventListener("scroll", scheduleOverlayRedraw, { passive: true })
            }

            // И самое важное: первый запуск — после первого кадра/рендера:
            this._firstRaf = requestAnimationFrame(() => {
                this._firstRaf = null;
                if (!sigma || this.sigma !== sigma) return;   // IE 2026 11 01 / ODOO-349799 (дефект webscm #122495: гонка кадру sigma після kill): ответ addons_graph_load убил экземпляр A до его кадра — refresh убитой sigma падал на bindFramebuffer
                sigma.refresh();     // заставить sigma посчитать bbox/размеры
                scheduleOverlayRedraw();   // и нарисовать
            });

            // ~~~~~~~~~~~~~~~~~~~  ~~~~~~~~~~~~~~~~~~~
            if (this.params['command-select']?.animate?.use) {
                this.animateStart()

                // const nodesToDelete = graph.nodes()
                // this.animateNodeDeletion(graph, nodesToDelete, () => {
                //     console.log('Nodes and edges deleted.')
                // })
            }

            // АН 2026 08 11 (замечание Андрея): штатный labelGrid sigma не знает
            // ширины текста — длинные названия наезжают друг на друга, а свободные
            // узлы молчат из-за соседа в той же грид-ячейке. Свой отбор: реальные
            // прямоугольники текста (measureText), жадно без пересечений; пересчёт
            // при зуме/пане с дебаунсом.
            {
                const cam = sigma.getCamera()
                cam.on('updated', () => {
                    clearTimeout(this._lvTimer)
                    this._lvTimer = setTimeout(() => this.recomputeLabelVisibility(), this.store.setting('fe.ux.graphLabelDebounceMs', 150))   // IE 2026 09 05 / ODOO-336330
                })
                setTimeout(() => this.recomputeLabelVisibility(), this.store.setting('fe.ux.graphLabelDebounceMs', 150) * 2)
            }

            // ~~~~~~~~~~~~~~~~~~~ Bind graph interactions ~~~~~~~~~~~~~~~~~~~
            // IE 2026 09 06 / ODOO-335246 (Igor): клик по связи с атрибутом row — карточка строки (не зависит от опции hover)
            sigma.on("clickEdge", ({ edge, event }) => {
                if (this.iconAtPoint(event) || this.rectIconAtPoint(event)) return   // IE 2026 09 10 (Igor): иконка узла / области поверх линии — клик по иконке
                const rr = graph.getEdgeAttribute(edge, 'row')
                if (rr) this.openRowWidget(rr, event)
            })
            // IE 2026 09 08 / ODOO-335246 (Igor): подсветка соседей при наведении — во ВСЕХ графах по умолчанию (быстрая настройка
            // graph_hover_neighbors); прочие узлы и связи приглушаются, а не прячутся. Opt-in 'command-hoveredNode' (карточки строк
            // по связям, свои редьюсеры) — как прежде
            const hoverOptIn = !!this.params['command-hoveredNode']?.use
            const hoverNeighbors = () => this.WIDGET?.record?.doc?.params?.graph_hover_neighbors !== false
            if (!hoverOptIn) {
                sigma.on("enterNode", ({ node }) => { if (hoverNeighbors()) this.setHoveredNode(node) })
                sigma.on("leaveNode", () => { if (this.state.hoveredNode) this.setHoveredNode(undefined) })
                const DIM_NODE = '#e9ebef', DIM_EDGE = '#e6e9ee'
                // IE 2026 09 10 / ODOO-335246 (Igor): наведение на заголовок области (rectTitleHover) — как наведение на каждый
                // её узел сразу: узлы области и их соседи подсвечены, остальное приглушено (state.hoveredRect = {inside, nbrs})
                sigma.setSetting("nodeReducer", (node, attributes) => {
                    const res = { ...attributes }
                    const h = this.state.hoveredNode, hr = this.state.hoveredRect
                    // IE 2026 09 14 / ODOO-335246 (Igor): обрезка «…» и отбор подписей из recomputeLabelVisibility применялись только в opt-in редьюсере
                    // (command-hoveredNode) — в графах каскада (этот редьюсер) подписи не обрезались и не прятались, проход считал
                    // в пустоту (скрин Igor 14.09: I19 поверх «СводнаяНоменклатура»). У наведённого узла — полная подпись
                    { const cutL0 = this._labelCut?.get(node); if (cutL0 && res.label && h !== node) res.label = cutL0 }
                    if (attributes.own) { res.forceLabel = true; res.zIndex = Math.max(res.zIndex || 0, 6) }
                    // IE 2026 09 13 / ODOO-335246 (Igor): поиск чипсами (state.filter_values, apply_CHIPS) — этот редьюсер его не знал,
                    // чипс ничего не менял на графе. Совпавшие узлы — как выделенные (оранжевые, крупнее, подпись всегда; совпавшая
                    // часть подписи подсвечена в drawNodeLabelIcon), остальные приглушены, если у чипса не включено «Show rows without matches»
                    const fv = this.state.filter_values, searching = !!(fv && fv.size) || !!(this.CHIPS && this.CHIPS.length)
                    if (searching && !(h && hoverNeighbors()) && !(hr && hoverNeighbors())) {
                        if (fv && fv.has(node)) { res.color = "rgb(255, 150, 30)"; res.size = (res.size || 5) * 1.25; res.forceLabel = true; res.zIndex = 9 }
                        else if (!this._searchShowAll) { res.label = ""; res.color = DIM_NODE; res.zIndex = 0 }
                        return res
                    }
                    if (h && hoverNeighbors()) {
                        if (node === h) { res.forceLabel = true; res.zIndex = 10 }
                        else if (this.state.hoveredNeighbors?.has(node)) { res.forceLabel = true; res.zIndex = 9 }
                        else { res.label = ""; res.color = DIM_NODE; res.zIndex = 0 }
                    } else if (hr && hoverNeighbors()) {
                        if (hr.inside.has(node)) { res.forceLabel = true; res.zIndex = 10 }
                        else if (hr.nbrs.has(node)) { res.forceLabel = true; res.zIndex = 9 }
                        else { res.label = ""; res.color = DIM_NODE; res.zIndex = 0 }
                    } else if (res.label && this._labelVis && !attributes.own) {   // IE 2026 09 14 / ODOO-335246 (Igor): отбор подписей (см. recomputeLabelVisibility)
                        if (this._labelVis.has(node)) res.forceLabel = true
                        else res.label = ""
                    }
                    return res
                })
                sigma.setSetting("edgeReducer", (edge, attributes) => {
                    const res = { ...attributes }
                    const h = this.state.hoveredNode, hr = this.state.hoveredRect
                    const fv = this.state.filter_values   // IE 2026 09 13 (Igor): поиск — связи, не касающиеся совпавших узлов, приглушены
                    if (fv && fv.size && !this._searchShowAll && !(h && hoverNeighbors()) && !(hr && hoverNeighbors())) {
                        if (!fv.has(graph.source(edge)) && !fv.has(graph.target(edge))) { res.color = DIM_EDGE; res.zIndex = 0 }
                        return res
                    }
                    if (h && hoverNeighbors()) {
                        if (graph.target(edge) === h) { res.color = "#7798FA"; res.zIndex = 5; res.size = Math.max(res.size || 1, 2) }
                        else if (graph.source(edge) === h) { res.color = "#6DDB55"; res.zIndex = 5; res.size = Math.max(res.size || 1, 2) }
                        else { res.color = DIM_EDGE; res.zIndex = 0 }   // приглушить, не прятать
                    } else if (hr && hoverNeighbors()) {
                        if (hr.inside.has(graph.target(edge))) { res.color = "#7798FA"; res.zIndex = 5; res.size = Math.max(res.size || 1, 2) }
                        else if (hr.inside.has(graph.source(edge))) { res.color = "#6DDB55"; res.zIndex = 5; res.size = Math.max(res.size || 1, 2) }
                        else { res.color = DIM_EDGE; res.zIndex = 0 }
                    }
                    return res
                })
            }
            if (hoverOptIn) {
                sigma.on("enterNode", ({ node }) => { this.setHoveredNode(node) })
                sigma.on("leaveNode", () => { this.setHoveredNode(undefined) })
                // АН 2026 08 10 (заказ Игоря): ребро графа = строка _doc.data —
                // hover по связи открывает widget-row её строки (row_id пишет бэкенд)
                // АН 2026 08 10 (UX Андрея): первый показ карточки — только по КЛИКУ
                // на связь; открытая карточка обновляется по hover; закрыли — снова клик
                sigma.on("clickEdge", ({ edge, event }) => {
                    if (this.iconAtPoint(event) || this.rectIconAtPoint(event)) return   // IE 2026 09 10 (Igor): иконка узла / области поверх линии — клик по иконке
                    // IE 2026 09 06 / ODOO-335246 (Igor): связь с атрибутом row — карточка строки таблицы (связи каскада)
                    if (graph.getEdgeAttribute(edge, 'row')) { this.openRowWidget(graph.getEdgeAttribute(edge, 'row'), event); return }
                    this.setHoveredEdge(edge, event, true)
                    // АН 2026 08 15 / ODOO-4997: клик по связи = выделение (как у узла),
                    // с каскадом подсветки измерений в соседние виджеты
                    if (this.set_selector) {
                        if (!graph.getEdgeAttribute(edge, "selector")) graph.setEdgeAttribute(edge, "selector", true)
                        else graph.removeEdgeAttribute(edge, "selector")
                        this.emit_dimHighlight()
                        this.sigma?.refresh()
                    }
                })
                sigma.on("enterEdge", ({ edge, event }) => { this.setHoveredEdge(edge, event) })
                sigma.on("leaveEdge", () => { this._altEdge6 = null })   // U6 (заказ Игоря: объяснение элементов по Alt): ушли с ребра — объяснения ребра по Alt нет

                // Render nodes accordingly to the internal state:
                // 1. If a node is selected, it is highlighted === selector
                // 2. If there is query, all non-matching nodes are greyed
                // 3. If there is a hovered node, all non-neighbor nodes are greyed
                // IE 2026 10 26 / ODOO-348733 (заказ webscm #105553: netOn и реактивные чтения в редьюсерах на каждый проход): прежний редьюсер без изменений — при fe.perf.graphReducerSnap = false; по умолчанию — nodeReduceSnap (та же логика по снимку, без второй копии)
                const nodeReduceOld = (node, attributes) => {
                    const res = { ...attributes }

                    // // пропорционально масштабу:
                    // const ratio = sigma.getCamera().getState().ratio; // >1 zoom-out, <1 zoom-in
                    // const ratio1 = this.ratio1 || 1
                    // const base = attributes.baseSize ?? attributes.size ?? 5;
                    // const size = base / ratio / ratio1;
                    // const min = 1.5;
                    // const max = 40;
                    // res.size = Math.max(min, Math.min(max, size));

                    // АН 2026 08 11: обрезка «…» до соседнего узла; у НАВЕДЁННОГО
                    // узла бейдж показывает ПОЛНОЕ название (просьба Андрея)
                    {
                        const cutL0 = this._labelCut?.get(node)
                        if (cutL0 && res.label && this.state.hoveredNode !== node) res.label = cutL0
                    }

                    if (attributes.own) { res.forceLabel = true; res.zIndex = Math.max(res.zIndex || 0, 6) }   // IE 2026 09 11 (Igor): узел записи-хозяина — подпись всегда
                    if (res.selector) {
                        // АН 2026 08 15 / ODOO-4997: выделение узла ЯВНОЕ (заказ Игоря —
                        // «как в таблице с рыжим обводом»): крупнее, подпись всегда, поверх
                        res.color = "rgb(255, 150, 30)"
                        res.size = (res.size || 5) * 1.4
                        res.forceLabel = true
                        res.zIndex = 10
                    } else if (attributes.dim_hl) {
                        // подсветка от другого виджета (навигация по гриду / клик бабла)
                        res.color = "rgb(255, 150, 30)"
                        res.size = (res.size || 5) * 1.25
                        res.forceLabel = true
                        res.zIndex = 9
                    }

                    if (res.highlighted) {
                        //
                    } else if (this.state.hoveredNeighbors?.size || this.state.hoveredNode || this.state.selector_valuesNeighbors?.size || this.state.filter_values?.size || this.CHIPS.length) {
                        if (!this.state.hoveredNeighbors?.has(node) && this.state.hoveredNode !== node && !this.state.selector_valuesNeighbors?.has(node) && !this.state.filter_values?.has(node)) {
                            res.label = ""
                            res.type = ""
                            res.color = "#f6f6f6"
                        }
                    } else if (this.params['command-select']?.node?.hideLabel) {
                        res.label = ""
                    } else if (res.label && this._labelVis) {
                        // АН 2026 08 11: свой отбор лейблов (см. recomputeLabelVisibility)
                        if (this._labelVis.has(node)) res.forceLabel = true
                        else res.label = ""
                    }

                    // if (this.state.selectedNode === node) {
                    //     res.highlighted = true
                    // } else if (this.state.suggestions) {
                    //     if (this.state.suggestions.has(node)) {
                    //         res.forceLabel = true
                    //     } else {
                    //         res.label = ""
                    //         res.color = "#f6f6f6"
                    //     }
                    // }

                    if (this.netOn()) this.netNodeReduce(node, res)   // webscm 2026 10 23 / Odoo 348730: подписи соседей наведённого / выделенного узла

                    return res
                }
                sigma.setSetting("nodeReducer", (node, attributes) => { const s = rsnap.get(); return s.on ? nodeReduceSnap(node, attributes, s) : nodeReduceOld(node, attributes) })   // IE 2026 10 26 / ODOO-348733 (заказ webscm #105553: netOn и реактивные чтения в редьюсерах на каждый проход)

                // Render edges accordingly to the internal state:
                // 1. If a node is hovered, the edge is hidden if it is not connected to the node
                // 2. If there is a query, the edge is only visible if it connects two suggestions
                // IE 2026 10 26 / ODOO-348733 (заказ webscm #105553: netOn и реактивные чтения в редьюсерах на каждый проход): прежний редьюсер без изменений — при fe.perf.graphReducerSnap = false; по умолчанию — edgeReduceSnap
                const edgeReduceOld = (edge, attributes) => {
                    const res = { ...attributes }

                    // if (this.state.hoveredNode && !graph.hasExtremity(edge, this.state.hoveredNode)) {
                    //     res.hidden = true
                    // }
                    if (this.state.selector_values_inEdges?.size || this.state.selector_values_outEdges?.size || this.state.hoveredNode) {
                        // IE 2026 09 08 / ODOO-335246 (Igor): при наведении несвязанные связи ПРИГЛУШАЮТСЯ, а не прячутся; прятать — в режиме отбора
                        const selMode = !!(this.state.selector_values_inEdges?.size || this.state.selector_values_outEdges?.size)
                        if (selMode) res.hidden = true
                        else { res.color = "#e6e9ee"; res.zIndex = 0 }
                        if (this.state.selector_values_inEdges?.has(edge) && this.state.selector_values_outEdges?.has(edge)) {
                            res.hidden = false; res.color = attributes.color; res.zIndex = attributes.zIndex
                        } else if (this.state.selector_values_inEdges?.has(edge) || graph.target(edge) === this.state.hoveredNode) {
                            res.hidden = false
                            res.color = "#7798FA"; res.zIndex = 5
                        } else if (this.state.selector_values_outEdges?.has(edge) || graph.source(edge) === this.state.hoveredNode) {
                            res.hidden = false
                            res.color = "#6DDB55"; res.zIndex = 5
                        }
                    } else if (this.params['command-select']?.edge?.hidden) {
                        res.hidden = true
                    }
                    
                    // if (this.state.suggestions &&
                    //     (!this.state.suggestions.has(graph.source(edge)) || !this.state.suggestions.has(graph.target(edge)))
                    // ) {
                    //     res.hidden = true
                    // }
                    
                    if (this.params['command-select']?.edge?.hideLabel) {
                        res.label = ""
                    }

                    // АН 2026 08 15 / ODOO-4997: выделенная связь — явная (рыжая,
                    // толще, поверх) и не прячется никакими режимами выше
                    if (attributes.selector) {
                        res.hidden = false
                        res.color = "rgb(255, 150, 30)"
                        res.size = Math.max(res.size || 1, 5)
                        res.zIndex = 10
                    }

                    if (this.netOn()) this.netEdgeReduce(edge, attributes, res)   // webscm 2026 10 23 / Odoo 348730: связи выделенных узлов

                    return res
                }
                sigma.setSetting("edgeReducer", (edge, attributes) => { const s = rsnap.get(); return s.on ? edgeReduceSnap(edge, attributes, s, graph) : edgeReduceOld(edge, attributes) })   // IE 2026 10 26 / ODOO-348733 (заказ webscm #105553: netOn и реактивные чтения в редьюсерах на каждый проход)
            }

            this.applyCameraMode()   // IE 2026 09 12 / ODOO-335246 (Igor): режим камеры сразу после создания sigma (колесо — прокрутка, масштаб — кнопки)
            sigma.on("clickNode", (e) => {
                const node = e.node
                // IE 2026 09 07 / ODOO-335246 (Igor): после перетаскивания узла отпускание мыши — не клик: без выделения и карточки строки
                if (this.isDragged) { this.isDragged = null; return }
                // IE 2026 09 13 / ODOO-335246 (Igor): узел записи, в форме которой построен граф (own) — подсказать, что пользователь уже в ней
                if (graph.getNodeAttribute(node, 'own')) this.store.show_notification({ text: this.t('You are already in "{title}" — this graph is built from it', { title: graph.getNodeAttribute(node, 'label') || this.WIDGET?.record?.title || '' }), status: 'info' })   // IE 2026 09 23 / ODOO-341407: i18n
                // IE 2026 09 08 / ODOO-335246 (Igor): Alt+клик по узлу со ссылкой (doc.id) — открыть запись, как Alt+клик по
                // ссылочной ячейке таблицы (двойной клик — то же); отбор и карточка строки не трогаются. Cmd/Meta+клик — эксклюзивный отбор
                const mevA = e?.event?.original
                if (mevA?.altKey && !mevA.ctrlKey && !mevA.metaKey && !mevA.shiftKey && graph.getNodeAttribute(node, 'doc')?.id) {
                    if (this._clickRowTimer) { clearTimeout(this._clickRowTimer); this._clickRowTimer = null }
                    // IE 2026 09 10 / ODOO-335246 (Igor): Alt+клик — СПИСОК записей сегмента узла (хранимый сегмент / источник
                    // данных); у узлов без сегмента (задачи) — запись. IE 2026 09 12 (Igor): Alt+клик по иконке — то же, клик — запись
                    const dA = graph.getNodeAttribute(node, 'doc'), segA = this.nodeListSegment(dA)
                    if (segA) this.openSegmentList(segA); else this.openNodeRecord(dA, 'sigma.altClickNode')
                    return
                }
                if (this.set_selector) {
                    let selector
                    // IE 2026 08 15 / ODOO-4997 (заказ Игоря п.14): Alt/Cmd+клик —
                    // ЭКСКЛЮЗИВНЫЙ отбор (как селектор в таблицах): кликнутый узел
                    // выделяется, отборы всех остальных узлов и строк снимаются
                    const mev = e?.event?.original
                    const exclusive = !!(mev && (mev.altKey || mev.metaKey))
                    if (exclusive) {
                        graph.forEachNode((n) => {
                            if (n !== node && graph.getNodeAttribute(n, 'selector')) graph.removeNodeAttribute(n, 'selector')
                        })
                        const clicked = this.get_dataItem(this.data, node)
                        for (const r of this.data || []) {
                            if (r && r.selector && r !== clicked) r.selector = false
                        }
                        graph.setNodeAttribute(node, "selector", true)
                        selector = true
                    } else if (!graph.getNodeAttribute(node, "selector") || this.isDragged) {
                        graph.setNodeAttribute(node, "selector", true)
                        selector = true
                    } else {
                        graph.removeNodeAttribute(node, "selector")
                        selector = false
                    }

                    // АН 2026 08 15 / ODOO-4997: каскад ПОДСВЕТКИ — ДО каскада отборов:
                    // onApplySelector__Click может перестроить граф (select) и снять
                    // атрибуты selector до эмита
                    this.emit_dimHighlight()

                    // строки бэкендовых граф-источников (PM-tree, segments-links) не несут
                    // _graph → dataItem нет; без guard клик падал TypeError и обрывал обработчик
                    let dataItem = this.get_dataItem(this.data, node);
                    if (dataItem) {
                        dataItem.selector = selector
                        // IE 2026 08 15 / ODOO-4997 (вопрос Игоря п.15): КАСКАД
                        // ОТБОРОВ стола (обновление других виджетов) — только
                        // если у виджета настроен канал (Selector / Set
                        // dimensions = params.fieldSelectors). Без настройки
                        // клик даёт выделение узла и каскад ПОДСВЕТКИ
                        // (emit_dimHighlight выше), данные соседей не трогает.
                        const hasSelChannel = !!((this.WIDGET?.record?.doc?.params?.fieldSelectors || []).length)
                        if (hasSelChannel) {
                            this.store.executeStoreMethod(this.WIDGET.vueObj, { 'command': 'onApplySelector__Click' }, this.attr)
                        }
                    }

                } else {
                    if (!graph.getNodeAttribute(node, "highlighted") || this.isDragged) {
                        graph.setNodeAttribute(node, "highlighted", true)
                    } else {
                        graph.removeNodeAttribute(node, "highlighted")
                    }
                }
                this.isDragged = null

                this.get_highlighted()

                // ODOO-3221: панель связей кликнутой вершины (opt-in через graph-eval)
                if (this.params['command-clickNode']?.links_panel) {
                    this.openLinksPanel(node)
                }
                // IE 2026 09 06 / ODOO-335246 (Igor): узел с атрибутом row — карточка строки таблицы (шаг / вход каскада)
                const rowRef = graph.getNodeAttribute(node, 'row')
                if (rowRef) {
                    const pn = this.sigma.graphToViewport({ x: graph.getNodeAttribute(node, 'x'), y: graph.getNodeAttribute(node, 'y') })
                    // IE 2026 09 07 / ODOO-335246 (Igor): карточка строки — с задержкой: двойной клик открывает саму запись и отменяет её
                    if (this._clickRowTimer) clearTimeout(this._clickRowTimer)
                    this._clickRowTimer = setTimeout(() => { this._clickRowTimer = null; this.openRowWidget(rowRef, pn) }, 280)
                }
            })
            sigma.on("doubleClickNode", (e) => {
                const node = e.node,
                    attrs = this.graph.getNodeAttributes(node)
                // IE 2026 09 07 / ODOO-335246 (Igor): двойной клик = открыть запись узла; отложенную карточку строки одиночного клика отменить
                if (this._clickRowTimer) { clearTimeout(this._clickRowTimer); this._clickRowTimer = null }

                if (attrs?.doc?.id) {
                    const actionMenu = this.WIDGET?.record?.doc?.params?.['actionMenu-doubleClickNode']
                    if (actionMenu) {
                        let vueObj = this.WIDGET.vueObj
                        vueObj.store.executeStoreMethod(vueObj, {
                            ...actionMenu,
                            doc: attrs.doc,
                        })
                    } else {
                        this.openNodeRecord(attrs.doc, 'sigma.doubleClickNode')   // IE 2026 09 08 / ODOO-335246 (Igor): общий вызов с Alt+кликом
                    }
                }

                // Prevent sigma to move camera:
                e.preventSigmaDefault()
            })
            // rightClickNode
            sigma.on("rightClickNode", (e) => this.ctxMenu_mapNode(e))   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — график / узел карты)
            sigma.on("doubleClickEdge", (e) => {
                const edge = e.edge,
                    attrs = this.graph.getEdgeAttributes(edge)

                if (attrs?.doc?.id) {
                    this.store.widget_open({
                        doc: attrs.doc,
                        widget: 'widget-record',
                        parentAction: { 'action_name':'action-front-2024-07-23-2', method:'sigma.doubleClickEdge' },
                    }, this)
                }

                // Prevent sigma to move camera:
                e.preventSigmaDefault()
            })

            // ~~~~~~~~~~~~~~~~~~~ Drag'n'drop ~~~~~~~~~~~~~~~~~~~
            if (this.params['command-dragDrop']?.use) {
                // State for drag'n'drop
                this.draggedNode = null
                this.isDragging = false

                // On mouse down on a node
                //  - we enable the drag mode
                //  - save in the dragged node in the state
                //  - highlight the node
                //  - disable the camera so its state is not updated
                sigma.on("downNode", (e) => {
                    this.isDragging = true
                    this.draggedNode = e.node

                    // Prevent sigma to move camera:
                    e.preventSigmaDefault()
                })

                sigma.getMouseCaptor().on("mousemovebody", (e) => { try { this.rectTitleHover(e) } catch (err) { /* тултип заголовка области — не критично */ } })   // IE 2026 09 10 (Igor)
                // On mouse move, if the drag mode is enabled, we change the position of the this.draggedNode
                sigma.getMouseCaptor().on("mousemovebody", (e) => {
                    if (!this.isDragging || !this.draggedNode) return

                    // Get new position of node
                    const pos = sigma.viewportToGraph(e)

                    graph.setNodeAttribute(this.draggedNode, "x", pos.x)
                    graph.setNodeAttribute(this.draggedNode, "y", pos.y)
                    this.isDragged = true
                    if (this.labelsLive()) this.labelsDragTick()   // IE 2026 09 14 / ODOO-335246 (Igor): подписи следят за узлом во время перетаскивания

                    // Prevent sigma to move camera:
                    e.preventSigmaDefault()
                    e.original.preventDefault()
                    e.original.stopPropagation()
                })

                // On mouse up, we reset the autoscale and the dragging mode
                sigma.getMouseCaptor().on("mouseup", () => {
                    if (this.draggedNode) {
                        // graph.removeNodeAttribute(this.draggedNode, "highlighted")
                    }
                    this.isDragging = false
                    this.draggedNode = null
                
                    if (this.labelsLive()) this.labelsSchedule(0)   // IE 2026 09 14 / ODOO-335246 (Igor): полный проход после отпускания узла
                    this.layout_start({name:'command-dragDrop'})
                })

                // Disable the autoscale at the first down interaction
                sigma.getMouseCaptor().on("mousedown", () => {
                    if (!sigma.getCustomBBox()) sigma.setCustomBBox(sigma.getBBox())
                })
            }
            
            // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Create node (and edge) by click ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
            if (this.params.createNode) {
                // When clicking on the stage, we add a new node and connect it to the closest node
                sigma.on("clickStage", ({ event }) => {
                // Sigma (ie. graph) and screen (viewport) coordinates are not the same.
                // So we need to translate the screen x & y coordinates to the graph one by calling the sigma helper `viewportToGraph`
                const coordForGraph = sigma.viewportToGraph({ x: event.x, y: event.y })

                // We create a new node
                const node = {
                    ...coordForGraph,
                    size: 10,
                    color: chroma.random().hex(),
                }

                // Searching the two closest nodes to auto-create an edge to it
                const closestNodes = graph
                    .nodes()
                    .map((nodeId) => {
                        const attrs = graph.getNodeAttributes(nodeId)
                        const distance = Math.pow(node.x - attrs.x, 2) + Math.pow(node.y - attrs.y, 2)
                        return { nodeId, distance }
                    })
                    .sort((a, b) => a.distance - b.distance)
                    .slice(0, 2)

                // We register the new node into graphology instance
                const id = uuid()
                graph.addNode(id, node)

                // We create the edges
                closestNodes.forEach((e) => graph.addEdge(id, e.nodeId))
                })
            }

            this.rectSel_hook(sigma, graph)   // IE 2026 09 05 / ODOO-336800 (заказ Игоря): выделение прямоугольником
            // IE 2026 09 11 / ODOO-335246 (Igor): потеря WebGL-контекста — на странице много графов (у каждого три контекста,
            // браузер держит около шестнадцати), при открытии новых форм с графами самый старый контекст теряется: узлы и связи
            // исчезали, подписи (2d canvas) оставались. Контекст просим сохранить (preventDefault), а после восстановления
            // или при возврате курсора на граф пересобираем sigma из тех же данных
            try {
                const rebuild = () => { if (!this._glLost) return; this._glLost = false; try { this.load_data(this.data_graph) } catch (err) { console.warn('graph rebuild after WebGL context loss skipped', err) } }
                const cvs = sigma.getCanvases() || {}
                for (const name of Object.keys(cvs)) {
                    const el = cvs[name]
                    if (!el || typeof el.getContext !== 'function') continue
                    let gl = null
                    try { gl = el.getContext('webgl2') || el.getContext('webgl') } catch (e) { gl = null }
                    if (!gl) continue
                    // события только СВОЕГО экземпляра: kill() старой sigma тоже гасит её контексты
                    el.addEventListener('webglcontextlost', (e) => { if (this.sigma !== sigma) return; e.preventDefault(); this._glLost = true }, false)
                    el.addEventListener('webglcontextrestored', () => { if (this.sigma === sigma) setTimeout(rebuild, 50) }, false)
                }
                if (this.sigmaRoot && !this.sigmaRoot._glGuard) {
                    this.sigmaRoot._glGuard = true
                    this.sigmaRoot.addEventListener('mouseenter', rebuild, false)
                }
            } catch (e) { console.warn('WebGL context guard skipped', e) }

            this.set_commandPanel()
        },
        kill() {
            this.antStop()   // IE 2026 09 15: муравьи
            // IE 2026 11 01 / ODOO-349799 (дефект webscm #122495: гонка кадру sigma після kill): отложенные кадры убиваемого экземпляра не должны исполниться
            if (this._firstRaf) { cancelAnimationFrame(this._firstRaf); this._firstRaf = null }
            if (this._ovRaf) { cancelAnimationFrame(this._ovRaf); this._ovRaf = null; this.overlayScheduled = false }
            if (this.sigma) {
                this.sigma.kill()
                this.sigma = null
            }
            if (this.layout) {
                this.layout.kill()
                this.layout = null
            }
        },
        initialized(input) {
            // this.input = input
        },
        attrResize() {
            // if (!this.isVisible) return FIXEDIT Scroll bars are lost
            if (this.attrResize_timeout) {
                clearTimeout(this.attrResize_timeout)
            }
            this.attrResize_timeout = setTimeout(() => {
                this.attrResize_afterTimeout()
                this.attrResize_timeout = null
            }, 1)
        },
        attrResize_afterTimeout() {
            // console.log('attrResize')
                const elementForm = document.getElementById(`WIDGET${this.widget_id}`);
                // const elementForm = document.getElementById(`containerResize${this.attr.html_id}`)
                const elementFlex = this.$refs.sigmaRoot // document.getElementById(this.attr.html_id);
                const attr_container = this.$refs.attr_container
                // const elementTopLine = this.$refs.attr_top_line
                if (!elementForm || !elementFlex) {
                    return
                }
                const elementWidget_Rect = elementForm.getBoundingClientRect()
                const elementFlex_Rect = elementFlex.getBoundingClientRect()
                // const elementTopLine_Rect = elementTopLine.getBoundingClientRect()
                if (elementFlex_Rect.width > 10) { // if mount all elements
                    this.allow_formatItem = true
                    let newHeight = elementFlex_Rect.height
                    if (!this.attr.noResize || newHeight === 50) {
                        newHeight = Math.floor(elementWidget_Rect.bottom - elementFlex_Rect.top) // - 2
                        if (newHeight > elementWidget_Rect.height) {
                        // if (elementFlex_Rect.top < 0) {
                            // let visibleRect = this.getVisibleRect(elementFlex)
                            // newHeight = Math.floor(visibleRect.height) - 2
                            newHeight = 160
                        }
                        if (this.attr.size) {
                            newHeight = Math.round(newHeight * this.attr.size / 100)
                        }
                    } else {
                        return
                    }
                    if (newHeight < (this.attr.minHeight||160)) {
                        newHeight = (this.attr.minHeight||160)
                    }
                    if (this.attr.maxHeight && newHeight > this.attr.maxHeight) {
                        newHeight = this.attr.maxHeight
                    } else if (newHeight > 1500) {
                        newHeight = 1500
                    }
                    if (this.attr.heightAdd) {
                        newHeight += this.attr.heightAdd
                    }
                    // if (this.attr.showGridSummaryLine) {
                        // newHeight -= 20
                    // }
                    // ODOO-3221: sigmaRoot — absolute inset-0, у .attr-graph0 нет flow-высоты;
                    // синкаем её, чтобы оверлеи (легенда/панель связей) якорились к области графа
                    if (attr_container && attr_container.style.height !== `${newHeight}px`) {
                        attr_container.style.height = `${newHeight}px`
                    }
                    if (elementFlex.style.height !== `${newHeight}px`) { // elementFlex_Rect.height !== newHeight
                        // IE 2026 08 17 / ODOO-4997 (замечание Игоря): отладочный лог attrResize∆ убран
                        elementFlex.style.height = `${newHeight}px`
                        // elementFlex.style.width = `${elementFlex_Rect.width}px`

                        // sigma v2:
                        if (this.sigma) {
                            this.set_ratio1()
                            this.sigma.resize();

                            // IE 2026 08 21: высота изменилась — переприменить растяжку/
                            // змейку/резерв подписей под новый размер (первый рендер шёл
                            // по ещё не финальной высоте — граф оставался «полосой»)
                            try { this.graphPostLayout(); this.$nextTick(() => this.autoCheckSpacing()) } catch (e) { console.warn('graph postlayout skipped', e) }   // IE 2026 09 12 (Igor): + авто-проверка шага

                            // важно: сбросить bbox, чтобы autoscale пересчитался под новый viewport
                            this.sigma.setCustomBBox(this._graphBBox || null);
                            this.sigma.refresh();           // перерендер
                            // scheduleOverlayRedraw();        // твой overlay
                        }
                    }
                }
            // } else {
            //     this.allow_formatItem = true
            // }
        },
        set_ratio1() {
            if (this.sigma) {
                // Это лечит размер нод и растояние между ними при ресайзе
                const { width, height } = this.sigma.getDimensions();
                this.sigmaNormWidth =  Math.min(window.innerWidth, window.innerHeight);
                const ref = this.sigmaNormWidth || 900;
                const cur = Math.min(width, height);
                this.ratio1 = Math.min(2.5, Math.max(1, ref / cur));
            }
        },
        setHoveredNode(node) {
            // IE 2026 09 05 / ODOO-336800 (заказ Игоря): пока тянется рамка выделения, узлы под курсором не
            // «наводятся» (подсветка соседей, карточка/тултип узла) — иначе карточка узла всплывала посреди протяжки
            if (this._rs) return
            this.mapHover_node(node)   // IE 2026 09 17 / ODOO-… (заказ Игоря): вид карты — подпись наведения и блок легенды
            if (node) {
                this.state.hoveredNode = node
                this.state.hoveredNeighbors = new Set(this.graph.neighbors(node))

                clearTimeout(this._ttHideTimer);

                const attrs = this.graph.getNodeAttributes(node);

                // 1) координаты узла в графе
                const x = attrs.x;
                const y = attrs.y;

                // 2) переводим в координаты экрана (viewport)
                const p = this.sigma.graphToViewport({ x, y });

                // DOM-rect контейнера sigma
                const rootRect = this.$refs.sigmaRoot.getBoundingClientRect();

                // DPI (важно, если canvas рисуется в 2x)
                const ratio = 1 // this.sigma.getPixelRatio ? this.sigma.getPixelRatio() : (window.devicePixelRatio || 1);

                const TOOLTIP_W = 260;
                const TOOLTIP_H = 120;
                
                // bounds должны быть в координатах контейнера element (sigmaRoot)
                const bounds = new wjcCore.Rect(
                    rootRect.x + p.x / ratio - 30,     // left
                    rootRect.y + p.y / ratio - 30,     // top
                    300, // TOOLTIP_W,    // width
                    300, // TOOLTIP_H     // height
                );

                if (this.tooltip_widget === 'widget-row' && !attrs?.row) {   // IE 2026 09 06: узел с row — карточку открывает openRowWidget
                    const action = { 'tooltip': this.t('Open line'), 'hotKey': 'Alt F2', 'action_name':'action-front-openLine-2024-11-30',command:'widget_open', 'widget':'widget-row', 'get_currentRow':true, 'get_Parent':true, 'open_in_children_widget':true, 'cssClass':'pi p-button-white pi-pencil' }

                    let dataItem = this.get_dataItem(this.data, node);
                    if (!dataItem) {
                        dataItem = { label: attrs.label, _graph: { node } }
                    }
                    const iroot = this.store.iroot(dataItem, this.data)

                    const elementForm = document.getElementById(`WIDGET${this.widget_id}`);
                    const elementWidget_Rect = elementForm.getBoundingClientRect()
                    
                    const elementFlex = this.$refs.sigmaRoot
                    const elementFlex_Rect = elementFlex.getBoundingClientRect()
                    
                    const x0 = elementFlex_Rect.left - elementWidget_Rect.left;
                    const y0 = elementFlex_Rect.top - elementWidget_Rect.top;

                    action.selectedRow = {
                        iroot,
                        dataItem,
                        x: x0 + p.x,
                        y: y0 + p.y
                    }
                    action.binding = '_doc.data'
                    action.attrs = this.store.get_value(this.WIDGET.record, 'doc.viewList', [])
                  
                    const WRow = this.store.get_childrenWidget(this.WIDGET, 'widget-row')
                    if (WRow) {
                        if (WRow.record._meta?.iroot !== iroot || WRow.record._meta?.binding !== this.attr.binding) {
                            this.store.executeStoreMethod(this.WIDGET.vueObj, action, this.attr)
                        }
                    } else {
                        this.store.executeStoreMethod(this.WIDGET.vueObj, action, this.attr)
                    }
                  
                } else {
                    // 3) HTML тултипа
                    const tooltip_source = this.data_graph?.tooltip_source || [
                        { title: this.t('Title'), binding: 'label' },   // IE 2026 09 23 / ODOO-341407: i18n
                    ]
                    // IE 2026 09 12 / ODOO-335246 (Igor): подсказка из одного заголовка дублирует подпись узла, которая и так
                    // нарисована рядом — не показывать; подсказка нужна, только если бэк дал другие поля (tooltip_source)
                    // IE 2026 09 12 (Igor, регрессия): без раннего return — ниже идёт refresh() подсветки соседей при наведении
                    // IE 2026 09 17 / ODOO-… (заказ Игоря): в виде карты большая подсказка закрывает граф — данные узла показывают
                    // подпись наведения и вкладка Node окна легенды (как у карты); вернуть подсказку — fe.ux.graphMapTooltip = true
                    const tipSkip = tooltip_source.every(f => f?.binding === 'label')
                        || (this.mapViewOn && this.store.setting('fe.ux.graphMapTooltip', false) !== true)
                    if (tipSkip) tooltip.hide()

                    const nonce = Date.now(); // или инкремент счётчик
                    const html = this.store.tooltip_html_fromFields(attrs, tooltip_source) +
                                `<span style="display:none">${nonce}</span>`;
                    
                    // 4) показываем тултип в точке
                    if (!tipSkip) tooltip.show(this.$refs.sigmaRoot, html, bounds);   // IE 2026 09 12 (Igor)

                    // Найти DOM тултипа
                    const tip = tipSkip ? null : document.querySelector(".wj-tooltip");
                    if (tip && !tip._boundHoverHandlers) {
                        tip._boundHoverHandlers = true;

                        tip.addEventListener("mouseenter", () => {
                            clearTimeout(this._ttHideTimer);
                            this._ttHideTimer = null;
                        });

                        tip.addEventListener("mouseleave", () => {
                            clearTimeout(this._ttHideTimer);
                            this._ttHideTimer = setTimeout(() => tooltip.hide(), this.store.setting('fe.ux.graphTooltipHideMs', 600));   // IE 2026 09 05 / ODOO-336330
                        });
                    }
                }
            }

            // Compute the partial that we need to re-render to optimize the refresh
            // IE 2026 10 26 / ODOO-348733 (заказ webscm #105553: netOn и реактивные чтения в редьюсерах на каждый проход): результат не используется (partialGraph ниже закомментирован) — два прохода по графу на каждый вход / уход наведения;
            // со снимком редьюсеров (fe.perf.graphReducerSnap, по умолчанию) не считаем, при false — как было
            if (this.store.setting('fe.perf.graphReducerSnap', true) === false) {
                const nodes = this.graph.filterNodes((n) => n !== this.state.hoveredNode && !this.state.hoveredNeighbors?.has(n))
                const nodesIndex = new Set(nodes)
                const edges = this.graph.filterEdges((e) => this.graph.extremities(e).some((n) => nodesIndex.has(n)))
            }

            if (!node) {
                this.state.hoveredNode = undefined
                this.state.hoveredNeighbors = undefined

                clearTimeout(this._ttHideTimer);
                this._ttHideTimer = setTimeout(() => tooltip.hide(), this.store.setting('fe.ux.graphTooltipHideMs', 600) * 2);   // IE 2026 09 05 / ODOO-336330: вдвое дольше после ухода с узла
            }

            this.refresh({
                // partialGraph: {
                //     nodes,
                //     edges,
                // },
                // We don't touch the graph data_graph so we can skip its reindexation
                // skipIndexation: true,
            })
        },
        // IE 2026 09 06 / ODOO-335246 (Igor): карточка строки (widget-row) для узла/связи, у которых бэк задал
        // row = {binding, rid}: строка ищется в WIDGET.record[binding] (с группами attrs) по id или _rid,
        // колонки — у грида вью с тем же binding; открывается как «Open line» у грида
        // IE 2026 09 08 / ODOO-335246 (Igor): открыть запись, на которую ссылается узел / область графа (doc {id, segment}) —
        // тем же вызовом, что ссылка/«Open line» (segment + record{id, segment} + id); двойной клик и Alt+клик
        openNodeRecord(doc, method) {
            if (!doc?.id) return
            // IE 2026 09 12 / ODOO-335246 (Igor): узел текущей записи (выделен кольцом) — виджет уже открыт, второй не открывать
            if (String(doc.id) === String(this.WIDGET?.record?.id || '')) {
                // IE 2026 09 13 / ODOO-335246 (Igor): сказать пользователю, что он уже внутри этой записи (узел с кольцом)
                this.store.show_notification({ text: this.t('You are already in "{title}" — this graph is built from it', { title: doc.title || doc.valueStr || this.WIDGET?.record?.title || doc.id }), status: 'info' })   // IE 2026 09 23 / ODOO-341407: i18n
                return
            }
            // IE 2026 09 10 / ODOO-335246 (Igor): record без segment — узел несёт обобщённый сегмент (TASKS / SEGMENTS-UNION),
            // а у открытого виджета записи он конкретный (TASKS-transform …): findWidget_byProps сравнивает segment и не
            // находил уже открытый (в т.ч. мягко закрытый) виджет — вместо активации открывался второй
            // IE 2026 09 10 (Igor): открытие/активация — ПОСЛЕ цепочки событий клика: иначе обработчики click/mouseup контейнера
            // виджета графа возвращали активность ему, и уже открытый на фоне виджет записи оставался под ним
            setTimeout(() => this.store.widget_open({
                segment: doc.segment, id: doc.id, record: { id: doc.id },
                doc,
                widget: 'widget-record',
                parentAction: { 'action_name':'action-front-2024-07-23', method },
            }, this), this.store.setting('fe.ux.graphOpenRecordDelayMs', 80))
        },
        openRowWidget(row, p) {
            if (!row?.binding || !row?.rid) return false
            const data = this.store.get_value(this.WIDGET.record, row.binding, []) || []
            const find = (arr) => { for (const it of arr || []) { if (it && (it.id === row.rid || it._rid === row.rid)) return it; const f = find(it?.attrs); if (f) return f } return null }
            const dataItem = (row.key_binding || (row.index !== undefined && row.index !== null)) ? schemeFindRow(data, row) : find(data)   // IE 2026 10 25 / ODOO-348925: у строк doc.nodes / doc.edges схемы нет id / _rid; без key_binding / index — как было
            if (!dataItem) return false
            const gridAttr = this.store.get_field0(this.WIDGET.view, row.binding, 'binding')
            const iroot = this.store.iroot(dataItem, data)
            const wr = document.getElementById(`WIDGET${this.widget_id}`)?.getBoundingClientRect() || { left: 0, top: 0 }
            const fr = this.$refs.sigmaRoot.getBoundingClientRect()
            const action = { 'tooltip': this.t('Open line'), 'action_name': 'action-front-openLine-graphRow-2026-09-06',   // IE 2026 09 23 / ODOO-341407: i18n
                'widgetRow_params': { 'width_pct': 0.44, 'height_pct': 0.5, 'top_pct': 0.08, 'left_pct': 0.54 },   // справа, чтобы не закрывать диаграмму
                command: 'widget_open', 'widget': 'widget-row', 'get_currentRow': true, 'get_Parent': true, 'open_in_children_widget': true, 'cssClass': 'pi p-button-white pi-pencil',
                'source_attr_type': 'AttrGraph', binding: row.binding, attrs: gridAttr?.attrs || [],
                selectedRow: { iroot, dataItem, x: fr.left - wr.left + (p?.x || 0), y: fr.top - wr.top + (p?.y || 0) } }
            const WRow = this.store.get_childrenWidget(this.WIDGET, 'widget-row')
            // IE 2026 09 06 (Igor): карточка не меняет место и размер при переходе шаг → связь → вход: рект открытой карточки
            // переносится на ключ нового источника (store хранит ректы по parentWIDGET+binding)
            if (WRow && !WRow._softClosed && WRow.record?._meta?.binding !== row.binding) {
                try {
                    const oldKey = this.store.widgetRowRect_key(WRow)
                    const newKey = `widget-row::${WRow.parentWIDGET?.widget ?? ''}::::${row.binding}`
                    const el = document.getElementById(`WIDGET${WRow.id}`)
                    const cur = (el && el.style && el.style.width) ? { top: el.style.top, left: el.style.left, width: el.style.width, height: el.style.height }
                        : (this.store._widgetRowRects[oldKey] || this.store._widgetRowRects_auto[oldKey])
                    if (cur && oldKey !== newKey) this.store._widgetRowRects[newKey] = { ...cur }
                } catch (e) { console.warn('row card rect carry-over skipped', e) }
            }
            if (!WRow || WRow._softClosed || WRow.record?._meta?.iroot !== iroot || WRow.record?._meta?.binding !== row.binding) {
                // IE 2026 09 06 (Igor): гриды того же виджета не должны «перехватить» карточку своим отложенным selectionChanged
                // (AttrGrid переоткрывает открытую карточку по своей текущей строке) — тот же флаг, что у самих гридов
                try {
                    const grids = Object.values(this.WIDGET.attrs_vueObj || {}).filter(v => v && typeof v.selectionChanged === 'function')
                    grids.forEach(g => { g._skipSelectionWidgetOpen = true })
                    setTimeout(() => grids.forEach(g => { g._skipSelectionWidgetOpen = false }), 800)
                } catch (e) { console.warn('row card guard skipped', e) }
                this.store.executeStoreMethod(this.WIDGET.vueObj, action, this.attr)
            }
            return true
        },
        // АН 2026 08 10: hover по ребру — widget-row строки _doc.data этого ребра
        setHoveredEdge(edge, event, force) {
            if (this._rs) return   // IE 2026 09 05 / ODOO-336800: рамка выделения — ховер связей не нужен
            this._altEdge6 = edge || null   // U6 (заказ Игоря: объяснение элементов по Alt): ребро под курсором — для объяснения по Alt
            this.mapHover_edge(edge)   // IE 2026 09 17 / ODOO-… (заказ Игоря): вид карты — связь под курсором в окне легенды
            // для ребра карточка строки — всегда widget-row (заказ Андрея):
            // ребро и есть строка _doc.data, текстовый тултип тут не нужен
            if (!edge) return
            if (!force) {
                // hover только ОБНОВЛЯЕТ уже открытую карточку; первый показ — клик
                const WRow0 = this.store.get_childrenWidget(this.WIDGET, 'widget-row')
                if (!WRow0 || WRow0._softClosed) return
            }
            const attrs = this.graph.getEdgeAttributes(edge)
            const row_id = attrs?.row_id
            if (!row_id) return
            const find = (arr) => {
                for (const item of arr || []) {
                    if (item._?.id === row_id) return item
                    const found = find(item.attrs)
                    if (found) return found
                }
                return null
            }
            const dataItem = find(this.data)
            if (!dataItem) return

            // якорь — точка наведения (АН 2026 08 10: середина source->target у почти
            // параллельных рёбер указывала «в пустоту»); фолбэк — середина ребра
            let p = event && event.x != null ? { x: event.x, y: event.y } : null
            if (!p) {
                const [ns, nt] = this.graph.extremities(edge)
                const ps = this.sigma.graphToViewport({ x: this.graph.getNodeAttribute(ns, 'x'), y: this.graph.getNodeAttribute(ns, 'y') })
                const pt = this.sigma.graphToViewport({ x: this.graph.getNodeAttribute(nt, 'x'), y: this.graph.getNodeAttribute(nt, 'y') })
                p = { x: (ps.x + pt.x) / 2, y: (ps.y + pt.y) / 2 }
            }

            const action = { 'tooltip': this.t('Open line'), 'action_name': 'action-front-openLine-edge-2026-08-10', 'widgetRow_params': { 'width_pct': 0.5, 'height_pct': 0.45, 'top_pct': 0.08, 'left_pct': 0.08 }, command: 'widget_open', 'widget': 'widget-row', 'get_currentRow': true, 'get_Parent': true, 'open_in_children_widget': true, 'cssClass': 'pi p-button-white pi-pencil' }
            const iroot = this.store.iroot(dataItem, this.data)
            const elementForm = document.getElementById(`WIDGET${this.widget_id}`)
            const elementWidget_Rect = elementForm.getBoundingClientRect()
            const elementFlex_Rect = this.$refs.sigmaRoot.getBoundingClientRect()
            action.selectedRow = {
                iroot,
                dataItem,
                x: elementFlex_Rect.left - elementWidget_Rect.left + p.x,
                y: elementFlex_Rect.top - elementWidget_Rect.top + p.y,
            }
            action.binding = '_doc.data'
            action.attrs = this.store.get_value(this.WIDGET.record, 'doc.viewList', [])
            const WRow = this.store.get_childrenWidget(this.WIDGET, 'widget-row')
            if (!WRow || WRow.record._meta?.iroot !== iroot || WRow.record._meta?.binding !== this.attr.binding) {
                this.store.executeStoreMethod(this.WIDGET.vueObj, action, this.attr)
            }
        },
        layout_start(actionMenu) {
            this.params = this.store.str_toJSON(this.WIDGET, this.WIDGET?.record?.doc?.params?.['graph-eval'] || this.attr?.graphEval || '')   // IE 2026 09 07 / ODOO-335246 (Igor): умолчание из вью (attr.graphEval), если у записи нет graph-eval

            if (actionMenu.clear_graphContext && this.data_graph?.graphContext) {
                this.data_graph.graphContext = []
            }
         
            // IE 2026 09 26 / ODOO-… (дефект Игоря: кнопки раскладки графа не вписывают граф): кнопка панели (Assign / Webworker — у действия есть command) вписывает
            // результат; загрузка данных ('command-select') и перетаскивание узла ('command-dragDrop') — как раньше
            const userCmd = !!actionMenu.command
            let ranAssign = false
            let graph = this.graph,
                layouts = actionMenu.layouts || this.params[actionMenu.name]?.layouts || [],
                timeout = actionMenu.timeout || this.params[actionMenu.name]?.timeout || 1000

            if (this.layoutStop_timeout) {
                clearTimeout(this.layoutStop_timeout)
            }
            if (this.layout) {
                this.layout.stop()
                this.layout.kill()
                this.layout = null
            }
            this._layoutRunning = false   // IE 2026 09 26 / ODOO-…: прежний ход Webworker снят

            for (let layout of layouts) {
                let rowLayout = this.params[layout] || {}
                if (rowLayout.layoutType === 'assign') {
                    ranAssign = true   // IE 2026 09 26 / ODOO-…
                    if (rowLayout.layoutMethod === 'circular') {
                        circular.assign(graph)
                    }

                    if (rowLayout.layoutMethod === 'circlePack') {
                        circlepack.assign(graph, rowLayout.options || {})
                    }

                    if (rowLayout.layoutMethod === 'forceLayout') {
                        forceLayout.assign(graph, rowLayout.options || {})
                    }

                    if (rowLayout.layoutMethod === 'dagre') {
                        this.dagre(rowLayout.options || {})
                    }

                    if (rowLayout.layoutMethod === 'forceAtlas2') {
                        if (rowLayout.options) {
                            const settings = forceAtlas2.inferSettings(graph)
                            forceAtlas2.assign(graph, { 
                                ...rowLayout.options || {},
                                settings
                            })
                        } else {
                            forceAtlas2.assign(graph, rowLayout.options || {})
                        }
                    }

                    if (rowLayout.layoutMethod === 'noverlap') {
                        noverlap.assign(graph, rowLayout.options || {})
                    }
                } else if (rowLayout.layoutType === 'webworker') {
                    if (rowLayout.layoutMethod === 'forceLayout') {
                        this.layout = new ForceSupervisor(graph, { 
                            isNodeFixed: (_, attr) => attr.highlighted, // || (attr.size === 3 && attr.x > 0) || (attr.size !== 3 && attr.x < 0),
                            ...rowLayout.options||{}
                        })
                    } else if (rowLayout.layoutMethod === 'forceAtlas2') {
                        if (rowLayout.options) {
                            const settings = forceAtlas2.inferSettings(graph)
                            this.layout = new FA2Layout(graph, { 
                                ...rowLayout.options || {},
                                settings
                            })
                        } else {
                            this.layout = new FA2Layout(graph, rowLayout.options || {})
                        }
                    } else if (rowLayout.layoutMethod === 'noverlap') {
                        this.layout = new NoverlapLayout(graph, rowLayout.options || {})
                    }
                }
            }
                
            if (userCmd && ranAssign && !this.layout) this.layoutAdoptFit()   // IE 2026 09 26 / ODOO-…: синхронная раскладка кнопкой — сразу вписать
            if (this.layout) {
                if (userCmd) this.layoutRunBegin()   // IE 2026 09 26 / ODOO-…: на время хода — нормировка по габариту узлов
                const run = this.layout
                this.layout.start()
                
                // this.layout.on('step', () => {
                //     graph.forEachNode((nodeKey, attr) => {
                //         if (attr.size === 3 && attr.x > 0) {
                //             graph.setNodeAttribute(nodeKey, 'x', 0)
                //         }
                //     })
                // })
    
                this.layoutStop_timeout = setTimeout(() => {
                    if (this.layout) {
                        this.layout.stop()
                    }
                    this.layoutStop_timeout = null
                    if (userCmd) { this._layoutRunning = false; if (this.layout === run && this.sigma) this.layoutAdoptFit() }   // IE 2026 09 26 / ODOO-…: остановка — вписать итог
                }, timeout)
            }
        },
        animateExpansion(duration = 1000) {
            const startTime = performance.now(),
                graph = this.graph,
                sigmaInstance = this.sigma,
                camera = sigmaInstance.getCamera()
            
            function step() {
                const currentTime = performance.now()
                const elapsedTime = currentTime - startTime
                const progress = Math.min(elapsedTime / duration, 1)
                
                // // Update node positions based on progress
                // graph.forEachNode((node, attributes) => {
                //     attributes.x = attributes.initialX * progress
                //     attributes.y = attributes.initialY * progress
                //     graph.setNodeAttribute(node, attributes)
                // })

                camera.setState({
                    // x: x,
                    // y: y,
                    ratio: 1 + (1-progress)*10,
                })

                sigmaInstance.refresh({
                    // keepCameraState: true,
                    skipIndexation: true,
                    // partialGraph: {
                    //     nodes: ['node1', 'node2'], // Only refresh these nodes
                    //     edges: ['edge1', 'edge2']  // Only refresh these edges
                    // },
                })

                if (elapsedTime < duration) {
                    requestAnimationFrame(step)
                }
            }
            
            requestAnimationFrame(step)
        },
        animateStart() {
            const graph = this.graph,
                sigmaInstance = this.sigma,
                camera = sigmaInstance.getCamera()
            
            // // Store initial positions and start animation
            // graph.forEachNode((node, attributes) => {
            //     attributes.initialX = attributes.x
            //     attributes.initialY = attributes.y
            //     attributes.x = 0
            //     attributes.y = 0
            //     graph.setNodeAttribute(node, attributes)
            // })

            // this.animateExpansion(this.params.webworker.timeout)

            camera.setState({
                // x: 100,       // Move the camera to x = 100
                // y: 200,       // Move the camera to y = 200
                ratio: 5,
                angle: Math.PI / 4  // Rotate the view by 45 degrees (π/4 radians)
            })
            camera.animate({
                // x: 0,
                // y: 0,
                ratio: 1,
                angle: 0
            },{
                duration: 1000,   // Duration of the animation in milliseconds
                easing: 'quadraticInOut',  // Easing function for the animation
                // onNewFrame: () => {
                //     graph.setNodeAttribute(nodeKey, 'size', actualSizes[nodeKey]);
                //     renderer.refresh({
                //         skipIndexation: true
                //     })
                // }
            })

            // animateNodes(graph, { [centralNodeId]: { size: 20 } }, { duration: 1000 })
            // animateNodes(graph, edges, { duration: 1000, easing: 'cubicInOut' })
        },
        animateNodeDeletion(graph, nodes, callback) {
            const nodesToAnimate = {}
            const edgesToAnimate = {}

            nodes.forEach((node) => {
                nodesToAnimate[node] = { size: 0 }
                graph.forEachEdge((edge, attributes, source, target) => {
                    if (source === node || target === node) {
                        edgesToAnimate[edge] = { size: 0 }
                    }
                })
            })

            animateNodes(graph, nodesToAnimate, {
                duration: 10000,
                easing: 'linear',
                onComplete: () => {
                    nodes.forEach((node) => graph.dropNode(node))
                    Object.keys(edgesToAnimate).forEach((edge) => graph.dropEdge(edge))
                    if (callback) callback()
                },
            })
        },
        // IE 2026 09 12 / ODOO-335246 (Igor): «Keep vertical spacing» — АВТО, пока пользователь не задал опцию явно (undefined в
        // doc.params): включается, если в сжатой по высоте раскладке шаг между соседними узлами одной колонки меньше высоты
        // подписи (узлы и подписи накладываются). Явное true/false пользователя — как есть.
        effNoSqY() {
            if (this.layoutFree) return false   // IE 2026 09 26 / ODOO-…: свободная раскладка (Assign / Webworker) — рядов колонок нет, шаг рядов не держим
            const v = this.WIDGET?.record?.doc?.params?.graph_no_squeeze_y
            if (v === true || v === false) return v
            return this.autoNoSqY === true   // IE 2026 09 12 / ODOO-335246 (Igor): поле data, не «_»-свойство — иначе Vue warn при рендере
        },
        // минимальный шаг (px экрана) между соседними узлами одной колонки в текущей отрисовке sigma; null — измерить нельзя
        minColumnPitchPx() {
            const graph = this.graph, sigma = this.sigma
            if (!graph || !sigma) return null
            const cols = {}
            try {
                graph.forEachNode((n, a2) => { const p = sigma.graphToViewport({ x: a2.x, y: a2.y }); const kx = Math.round(p.x / 6); (cols[kx] = cols[kx] || []).push(p.y) })
            } catch (e) { return null }
            let gMin = Infinity
            for (const k in cols) {
                const v = cols[k].sort((a, b) => a - b)
                for (let i = 1; i < v.length; i++) { const d = v[i] - v[i - 1]; if (d > 0.5 && d < gMin) gMin = d }
            }
            return isFinite(gMin) ? gMin : null
        },
        // после отрисовки: опция не задана пользователем, авто ещё выключено, камера в исходном положении, а узлы колонки
        // стоят ближе высоты подписи → включить авто-режим и переложить граф (graphPostLayout идемпотентен)
        autoCheckSpacing() {
            if (this.netOn()) return   // webscm 2026 10 23 / Odoo 348730: сетевой режим — координаты бэка в единицах сетки, авто keep spacing (и с ним потолок 1.25 px/ед.) сжимал граф в полосу
            try {
                const v = this.WIDGET?.record?.doc?.params?.graph_no_squeeze_y
                if (v === true || v === false || this.autoNoSqY || !this.sigma || this._autoRerun || this.layoutFree) return   // IE 2026 09 26 / ODOO-…: + свободная раскладка
                const cam = this.sigma.getCamera?.()
                if (cam && Math.abs((cam.ratio ?? 1) - 1) > 1e-6) return
                const MIN_STEP = this.store.setting('fe.chart.graphMinStepPx', 30)
                const pitch = this.minColumnPitchPx()
                if (pitch != null && pitch < MIN_STEP) {
                    this.autoNoSqY = true
                    this._autoRerun = true
                    try { this.graphPostLayout(); if (this._graphBBox && this.sigma) this.sigma.setCustomBBox(this._graphBBox); this.refresh() } finally { this._autoRerun = false }
                }
            } catch (e) { console.warn('graph auto spacing check skipped', e) }
        },
        graphPostLayout() {
            // IE 2026 08 21: пост-обработка раскладки, вызывается из load_data И при
            // ресайзе (attrResize): восстановить базовые координаты, растянуть по
            // текущей высоте, применить «змейку», зарезервировать поле под титулы
            // крайних правых узлов (кастомный bbox — иначе подписи режутся краем).
            const graph = this.graph
            const data_graph = this.data_graph || {}
            if (!graph) return
            if (this._layoutRunning) { if (this.sigma) this.sigma.setCustomBBox(null); return }   // IE 2026 09 26 / ODOO-…: идёт раскладка Webworker — габарит по узлам, перекладка — по остановке
            try {
                graph.forEachNode((n, a2) => {
                    if (this.layoutFree && a2._xF != null) graph.mergeNodeAttributes(n, { x: a2._xF, y: a2._yF })   // IE 2026 09 26 / ODOO-…: база раскладки кнопкой
                    else if (a2._xB != null) graph.mergeNodeAttributes(n, { x: a2._xB, y: a2._yB })
                })
                for (const r of data_graph.graphContext || []) {
                    if (r._y0B != null) r.y0 = r._y0B
                    if (r._y1B != null) r.y1 = r._y1B
                    if (r._x0B != null) r.x0 = r._x0B   // IE 2026 09 13 (Igor): базовые x областей
                    if (r._x1B != null) r.x1 = r._x1B
                }
            } catch (e) { console.warn("graph base restore skipped", e) }
            const LABEL_PAD_PX = this.store.setting('fe.chart.graphLabelPadPx', 170)   // место под подпись справа от узла; IE 2026 09 05 / ODOO-336330: настройка базы
            // АН 2026 08 11 (заказ Андрея): коэффициент растяжки по вертикали из
            // пропорций выстроенных узлов и виджета — sigma масштабирует равномерно,
            // поэтому широкая плоская раскладка прижимала колонки в линию
            try {
                let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity
                graph.forEachNode((n, a2) => {
                    if (a2.x < minX) minX = a2.x
                    if (a2.x > maxX) maxX = a2.x
                    if (a2.y < minY) minY = a2.y
                    if (a2.y > maxY) maxY = a2.y
                })
                const wN = maxX - minX, hN = maxY - minY
                // IE 2026 09 13 / ODOO-335246 (Igor): пропорции — от ОБЛАСТИ (attr_container), не от холста sigmaRoot: холст мы сами
                // растягиваем (keep spacing / кнопки высоты-ширины), и его высота возвращалась в коэффициент — лавинный рост при
                // каждой перекладке (834 → 14 566 → 69 093 px за три нажатия)
                const rect = this.$refs.attr_container?.getBoundingClientRect?.() || this.$refs.sigmaRoot?.getBoundingClientRect?.()
                this._layoutStale = !(rect && rect.width > 50 && rect.height > 50)   // IE 2026 09 12 (Igor): раскладка считалась на скрытой вкладке — повторить при показе
                if (rect && rect.width > 50 && rect.height > 50 && wN > 0 && hN > 0) {
                    // IE 2026 08 21: ширина под узлы меньше на резерв подписи
                    const effW = Math.max(rect.width - LABEL_PAD_PX, 50)
                    const k = ((rect.height / effW) * wN) / hN * 0.85   // 0.85 — поля
                    if (window.__graphDebug) console.log('graphPostLayout k:', JSON.stringify({ rect: [Math.round(rect.width), Math.round(rect.height)], wN: Math.round(wN), hN: Math.round(hN), k: +k.toFixed(3) }))
                    if (isFinite(k) && k > 0 && Math.abs(k - 1) > 0.05 && !this._layoutStd && !this.layoutFree) {   // IE 2026 09 13 (Igor): стандартная раскладка уже в px — пропорции не трогать; IE 2026 09 26 / ODOO-…: свободная раскладка вписывается равномерно
                        graph.updateEachNodeAttributes((n, a2) => ({ ...a2, y: a2.y * k }))
                        // подписи колонок и пунктирные разделители (graphContext)
                        // построены бэком по СТАРЫМ y (см. комментарий АН 2026 08 11)
                        const ty = (y) => y < minY ? minY * k - (minY - y)
                            : (y > maxY ? maxY * k + (y - maxY) : y * k)
                        for (const r of data_graph.graphContext || []) {
                            if (r.y0 != null) r.y0 = ty(r.y0)
                            if (r.y1 != null) r.y1 = ty(r.y1)
                        }
                    }
                }
            } catch (e) { console.warn("graph stretch skipped", e) }
            // IE 2026 09 06 / ODOO-335246 (Igor): опции «не ужимать» — шаг между соседними рядами/колонками узлов не меньше
            // fe.chart.graphMinStepPx; координаты растягиваются, холст sigma становится выше/шире области и появляется прокрутка
            try {
                const pNS = this.WIDGET?.record?.doc?.params || {}
                const noSqY = this.effNoSqY(), noSqX = pNS.graph_no_squeeze_x === true && !this.layoutFree   // IE 2026 09 12 (Igor): авто-режим; IE 2026 09 26 / ODOO-…: у свободной раскладки рядов нет
                const { fx: fX_, fy: fY_ } = this.userScale()   // IE 2026 09 13 (Igor): кнопки высоты / ширины
                const root = this.$refs.sigmaRoot, cont = this.$refs.attr_container
                const rectC = cont?.getBoundingClientRect?.()
                if (root && cont && rectC && rectC.width > 50 && rectC.height > 50) {
                    if (noSqY || noSqX || fY_ !== 1 || fX_ !== 1 || this._layoutStd) {   // IE 2026 09 13 (Igor): стандартная раскладка — всегда холст 1:1 с прокруткой
                        const MIN_STEP = this.store.setting('fe.chart.graphMinStepPx', 30)
                        let mnX = Infinity, mxX = -Infinity, mnY = Infinity, mxY = -Infinity
                        const xs = [], ys = [], pts = []
                        graph.forEachNode((n, a2) => {
                            if (a2.x < mnX) mnX = a2.x; if (a2.x > mxX) mxX = a2.x
                            if (a2.y < mnY) mnY = a2.y; if (a2.y > mxY) mxY = a2.y
                            xs.push(a2.x); ys.push(a2.y); pts.push({ x: a2.x, y: a2.y })
                        })
                        const wN = Math.max(mxX - mnX, 1e-9), hN = Math.max(mxY - mnY, 1e-9)
                        // IE 2026 09 07 / ODOO-335246 (Igor): «шаг между рядами» — не абсолютный минимум (после равномерного
                        // распределения колонок по высоте дорожки соседние колонки дают зазоры в единицы px и растяжка уходила
                        // в тысячи px), а минимальный из зазоров не меньше четверти медианного
                        const gap = (vals, eps) => {
                            vals.sort((a, b) => a - b)
                            const ds = []
                            for (let i = 1; i < vals.length; i++) { const d = vals[i] - vals[i - 1]; if (d > eps) ds.push(d) }
                            if (!ds.length) return 0
                            const sorted = ds.slice().sort((a, b) => a - b)
                            const med = sorted[Math.floor(sorted.length / 2)]
                            const big = sorted.filter(d => d >= med * 0.25)
                            return big.length ? big[0] : med
                        }
                        // IE 2026 09 07 / ODOO-335246 (Igor): шаг между рядами — внутри ОДНОЙ колонки (узлы с одинаковым x), между
                        // столбцами — внутри одного ряда; соседние колонки распределены по высоте с разным шагом, и глобальный минимум давал единицы px
                        const gapGrouped = (byKey, val, eps) => {
                            const groups = {}
                            for (const q of pts) { const k = Math.round(byKey(q)); (groups[k] = groups[k] || []).push(val(q)) }
                            let g = Infinity
                            for (const k in groups) { if (groups[k].length > 1) { const d = gap(groups[k], eps); if (d > 0 && d < g) g = d } }
                            return isFinite(g) ? g : 0
                        }
                        const gY = gapGrouped(q => q.x, q => q.y, hN * 1e-3) || gap(ys, hN * 1e-3)
                        const gX = gapGrouped(q => q.y, q => q.x, wN * 1e-3) || gap(xs, wN * 1e-3)
                        const cw = cont.clientWidth || rectC.width   // без желоба вертикальной полосы прокрутки
                        const effW = Math.max(cw - LABEL_PAD_PX - 60, 50)   // тот же резерв, что у bbox в этом режиме
                        // IE 2026 09 07 (Igor): в режиме keep spacing масштаб задаёт ширина области (высота холста подстраивается),
                        // иначе граф, ограниченный высотой, не растягивался на всю ширину
                        // IE 2026 09 07 / ODOO-335246 (Igor): узкий граф (структура страницы/стола) не раздувать по ширине —
                        // масштаб не больше 1.25 px на единицу координат (координаты бэка уже в «пикселях»)
                        // IE 2026 09 13 / ODOO-335246 (Igor): растяжка высоты (> 1) — масштаб по ширине, холст выше области (прокрутка);
                        // сжатие (< 1) — масштаб как в обычном режиме (и по высоте), холст не выше области: граф ужимается на экран
                        const s0 = this._layoutStd ? 1 : Math.min((noSqY || fY_ > 1) ? (effW / wN) : Math.min(effW / wN, rectC.height / hN), 1.25)   // IE 2026 09 13 (Igor): std — 1 px на единицу
                        let kY = 1, kX = 1
                        // IE 2026 09 12 / ODOO-335246 (Igor): по вертикали — РОВНО целевой шаг между соседними узлами колонки
                        // (fe.chart.graphKeepStepPx), а не «не меньше MIN_STEP»: широкая область давала масштаб по ширине и
                        // растягивала высоту на тысячи px; при больших базовых зазорах граф теперь и ужимается к целевому шагу
                        const KEEP_STEP = this.store.setting('fe.chart.graphKeepStepPx', 44)
                        if (noSqY && gY > 0 && !this._layoutStd) kY = Math.max(KEEP_STEP, MIN_STEP) / (gY * s0)
                        if (noSqX && gX > 0 && gX * s0 < MIN_STEP && !this._layoutStd) kX = MIN_STEP / (gX * s0)
                        if (this._layoutStd) {   // IE 2026 09 13 / ODOO-335246 (Igor): std — по вертикали растянуть до высоты области (не больше ×4), x остаётся 1:1
                            let cMn = mnY, cMx = mxY
                            for (const r of data_graph.graphContext || []) { for (const v of [r.y0, r.y1]) if (v != null) { if (v < cMn) cMn = v; if (v > cMx) cMx = v } }
                            const ctxH = Math.max(cMx - cMn, 1)
                            kY = Math.max(1, Math.min(4, (rectC.height - 140) / ctxH))
                        }
                        kY *= fY_; kX *= fX_   // IE 2026 09 13 / ODOO-335246 (Igor): кнопки высоты / ширины поверх keep spacing
                        if (Math.abs(kY - 1) > 1e-6 || Math.abs(kX - 1) > 1e-6) {   // IE 2026 09 12 (Igor): kY может быть и < 1
                            graph.updateEachNodeAttributes((n, a2) => ({ ...a2, x: mnX + (a2.x - mnX) * kX, y: mnY + (a2.y - mnY) * kY }))
                            for (const r of data_graph.graphContext || []) {
                                if (r.x0 != null) r.x0 = mnX + (r.x0 - mnX) * kX
                                if (r.x1 != null) r.x1 = mnX + (r.x1 - mnX) * kX
                                if (r.y0 != null) r.y0 = mnY + (r.y0 - mnY) * kY
                                if (r.y1 != null) r.y1 = mnY + (r.y1 - mnY) * kY
                            }
                        }
                        // размер холста: масштаб остаётся s0, лишнее — в прокрутку; в высоту — с запасом на графический контекст
                        // (рамки дорожек и подписи колонок выходят за узлы) — иначе sigma снова ограничит масштаб высотой
                        // IE 2026 09 13 / ODOO-335246 (Igor): только СЖАТИЕ кнопками (без keep spacing и растяжки > 1) — холст остаётся
                        // в области, sigma вписывает ужатую раскладку (граф на одном экране); растяжка / keep spacing — холст под прокрутку
                        if (!(noSqY || noSqX || fY_ > 1 || fX_ > 1) && !this._layoutStd) {
                            cont.style.overflow = ''; root.style.height = `${Math.floor(rectC.height)}px`; root.style.bottom = ''
                            root.style.width = ''; root.style.right = ''
                            this._noSqueezeApplied = false
                            if (this.sigma) { this.sigma.resize(); this.applyCameraMode() }
                        } else {
                        let cyMn = mnY, cyMx = mnY + hN * kY
                        for (const r of data_graph.graphContext || []) { for (const v of [r.y0, r.y1]) if (v != null) { if (v < cyMn) cyMn = v; if (v > cyMx) cyMx = v } }
                        const needH = Math.ceil((cyMx - cyMn) * s0) + 120
                        const needW = (kX > 1 || this._layoutStd) ? Math.ceil(wN * kX * s0) + LABEL_PAD_PX + 40 : Math.floor(cw)   // IE 2026 09 13 (Igor): std — холст по ширине раскладки   // без растяжки по X — ровно область, без лишней прокрутки
                        if (window.__graphDebug) console.log('graphPostLayout ns:', JSON.stringify({ rectC: [Math.round(rectC.width), Math.round(rectC.height)], cw, wN: Math.round(wN), hN: Math.round(hN), gY: Math.round(gY), gX: Math.round(gX), s0: +s0.toFixed(3), kY: +kY.toFixed(3), kX: +kX.toFixed(3), fY_, fX_, cy: [Math.round(cyMn), Math.round(cyMx)], needH, needW }))
                        cont.style.overflow = 'auto'
                        root.style.height = `${Math.max(needH, Math.floor(rectC.height))}px`; root.style.bottom = 'auto'
                        root.style.width = `${Math.max(needW, Math.floor(cw))}px`; root.style.right = 'auto'
                        this._noSqueezeApplied = true
                        // высота холста только что породила вертикальную полосу прокрутки — ширина области уменьшилась на желоб:
                        // пересчитать раскладку один раз от новой ширины (graphPostLayout идемпотентен — идёт от базовых координат)
                        if (cont.clientWidth !== cw && !this._nsRerun) {
                            this._nsRerun = true
                            try { this.graphPostLayout() } finally { this._nsRerun = false }
                            return
                        }
                        if (this.sigma) {
                            this.sigma.resize()
                            // колесо и перетаскивание — нативной прокрутке контейнера, а не камере sigma (если не включён graph_wheel_zoom)
                            this.applyCameraMode()   // IE 2026 09 07 / ODOO-335246 (Igor)
                        }
                        }
                    } else if (this._noSqueezeApplied || cont.style.overflow || root.style.bottom === 'auto' || root.style.width) {
                        // IE 2026 09 13 / ODOO-335246 (Igor): снятие keep spacing / коэффициентов — сброс холста по СТИЛЯМ элемента, а не
                        // только по флагу экземпляра (после перечитывания графа флаг терялся, холст оставался высоким)
                        cont.style.overflow = ''; root.style.height = `${Math.floor(rectC.height)}px`; root.style.bottom = ''
                        root.style.width = ''; root.style.right = ''
                        this._noSqueezeApplied = false
                        if (this.sigma) {
                            this.sigma.resize()
                            this.applyCameraMode()   // IE 2026 09 07 / ODOO-335246 (Igor)
                        }
                    }
                }
            } catch (e) { console.warn("graph no-squeeze skipped", e) }
            // АН 2026 08 11 (заказ Андрея): «змейка» — избегать чисто горизонтальных
            // (и, отдельной опцией, вертикальных) связей: узел справа от горизонтальной
            // связи смещается вверх/вниз поочерёдно. Координаты — снапшот ДО смещений,
            // поэтому цепочка A→B→C→D даёт чередование (B вниз, C вверх, ...).
            try {
                const pSnake = this.WIDGET?.record?.doc?.params || {}
                const avoidH = pSnake.graph_avoid_horizontal !== false && !this.layoutFree   // дефолт ВКЛ; IE 2026 09 26 / ODOO-…: «змейка» — для колонок, не для свободной раскладки
                const avoidV = pSnake.graph_avoid_vertical === true && !this.layoutFree      // дефолт ВЫКЛ
                if (avoidH || avoidV) {
                    let mnX = Infinity, mxX = -Infinity, mnY = Infinity, mxY = -Infinity
                    graph.forEachNode((n, a2) => {
                        if (a2.x < mnX) mnX = a2.x
                        if (a2.x > mxX) mxX = a2.x
                        if (a2.y < mnY) mnY = a2.y
                        if (a2.y > mxY) mxY = a2.y
                    })
                    const epsY = Math.max((mxY - mnY) * 1e-3, 1e-9)
                    const epsX = Math.max((mxX - mnX) * 1e-3, 1e-9)
                    // амплитуда «домика» — полшага между соседними рядами узлов
                    // (медиана), иначе на плотных раскладках сдвиг незаметен;
                    // фолбэк для одно-строчной раскладки — от ширины bbox
                    const _medGap = (vals, eps) => {
                        vals.sort((a, b) => a - b)
                        const lvls = []
                        for (const v of vals) if (!lvls.length || v - lvls[lvls.length - 1] > eps) lvls.push(v)
                        const gaps = []
                        for (let i = 1; i < lvls.length; i++) gaps.push(lvls[i] - lvls[i - 1])
                        gaps.sort((a, b) => a - b)
                        return gaps.length ? gaps[Math.floor(gaps.length / 2)] : 0
                    }
                    const _ys = [], _xs = []
                    graph.forEachNode((n, a2) => { _ys.push(a2.y); _xs.push(a2.x) })
                    const gY = _medGap(_ys, epsY), gX = _medGap(_xs, epsX)
                    const dY = gY ? gY * 0.5 : Math.max((mxY - mnY) * 0.25, (mxX - mnX) * 0.06, 1e-6)
                    const dX = gX ? gX * 0.5 : Math.max((mxX - mnX) * 0.25, (mxY - mnY) * 0.06, 1e-6)
                    const eList = []
                    graph.forEachEdge((e, at, s, t, sa, ta) => {
                        eList.push({ s, t, sx: sa.x, sy: sa.y, tx: ta.x, ty2: ta.y })
                    })
                    // «домик» (пример Андрея для ПФ): в цепочке A→B→C по одной прямой
                    // чётные узлы приподнимаются, нечётные остаются на базе —
                    // база → верх → база (обход слева направо, ось y: больше = выше)
                    if (avoidH) {
                        const lifted = new Set(), seen = new Set()
                        eList.sort((a, b) => Math.min(a.sx, a.tx) - Math.min(b.sx, b.tx))
                        for (const e of eList) {
                            if (Math.abs(e.sy - e.ty2) > epsY) continue
                            const fwd = e.tx >= e.sx
                            const left = fwd ? e.s : e.t, right = fwd ? e.t : e.s
                            if (seen.has(right)) continue
                            seen.add(right)
                            if (!lifted.has(left)) {
                                lifted.add(right)
                                graph.updateNodeAttribute(right, 'y', (y) => y + dY)
                            }
                        }
                    }
                    if (avoidV) {
                        const lifted = new Set(), seen = new Set()
                        eList.sort((a, b) => Math.min(a.sy, a.ty2) - Math.min(b.sy, b.ty2))
                        for (const e of eList) {
                            if (Math.abs(e.sx - e.tx) > epsX) continue
                            const fwd = e.ty2 >= e.sy
                            const low = fwd ? e.s : e.t, high = fwd ? e.t : e.s
                            if (seen.has(high)) continue
                            seen.add(high)
                            if (!lifted.has(low)) {
                                lifted.add(high)
                                graph.updateNodeAttribute(high, 'x', (x) => x + dX)
                            }
                        }
                    }
                }
            } catch (e) { console.warn("graph snake skipped", e) }
            // IE 2026 09 08 / ODOO-335246 (Igor): прямоугольники групп узлов (anchor.nodes — группы источников / виджетов) —
            // края заново по УЗЛАМ после растяжки, keep spacing и «змейки»: растяжка по высоте (k) масштабирует только диапазон
            // узлов, а поля за крайними узлами лишь сдвигает, поэтому отступ над первым узлом группы (внутри диапазона) рос
            // в k раз, а под последним — нет, и узлы «съезжали» вниз. Сверху — полоса заголовка (px → единицы) + зазор,
            // снизу — тот же зазор; зазор = полшага строки колонки, но не больше свободного места до рамки дорожки
            // (с учётом вложенности); вложенные группы — внутри родительских с той же полосой заголовка
            try {
                const rectsA = (data_graph.graphContext || []).filter(r => (r.type === 'rect' || r.type === 'fillRect') && r.anchor?.nodes?.length)
                if (rectsA.length) {
                    const rootR = this.$refs.attr_container?.getBoundingClientRect?.() || this.$refs.sigmaRoot?.getBoundingClientRect?.()   // IE 2026 09 13 (Igor): область, не растянутый холст
                    let mnX = Infinity, mxX = -Infinity, mnY = Infinity, mxY = -Infinity
                    const cols = {}
                    graph.forEachNode((n, a2) => {
                        if (a2.x < mnX) mnX = a2.x; if (a2.x > mxX) mxX = a2.x
                        if (a2.y < mnY) mnY = a2.y; if (a2.y > mxY) mxY = a2.y
                        const kx = Math.round(a2.x / 8); (cols[kx] = cols[kx] || []).push(a2.y)
                    })
                    const wN = Math.max(mxX - mnX, 1e-9), hN = Math.max(mxY - mnY, 1e-9)
                    // px на единицу координат — как sigma впишет граф: по ширине (keep spacing — не больше 1.25), иначе и по высоте
                    let s = 1
                    if (rootR && rootR.width > 50) {
                        const effW = Math.max(rootR.width - LABEL_PAD_PX, 50)
                        const noSqY = this.effNoSqY()   // IE 2026 09 12 (Igor): авто-режим
                        s = Math.min(effW / wN, (noSqY || this.userScale().fy > 1 || rootR.height <= 50) ? Infinity : rootR.height / hN, 1.25)   // IE 2026 09 13 (Igor): растяжка высоты — как keep spacing
                    }
                    if (!isFinite(s) || s <= 0) s = 1
                    const titleU = 18 / s, laneTitleU = 20 / s, laneMarginU = 8 / s   // полоса заголовка группы / дорожки, поле до рамки дорожки (px → единицы)
                    // шаг строки колонки — медиана зазоров между уровнями y её узлов; колонка с одним узлом — общая медиана
                    const levelGap = (vals) => {
                        const v = vals.slice().sort((a, b) => a - b), gaps = []
                        for (let i = 1; i < v.length; i++) { const d = v[i] - v[i - 1]; if (d > hN * 1e-3) gaps.push(d) }
                        gaps.sort((a, b) => a - b)
                        return gaps.length ? gaps[Math.floor(gaps.length / 2)] : 0
                    }
                    const allGaps = Object.values(cols).map(levelGap).filter(g => g > 0).sort((a, b) => a - b)
                    const globalStep = allGaps.length ? allGaps[Math.floor(allGaps.length / 2)] : 40
                    const stepOf = (keys) => {
                        const ks = new Set(keys.filter(n => graph.hasNode(n)).map(n => Math.round(graph.getNodeAttribute(n, 'x') / 8)))
                        const gs = [...ks].map(kx => levelGap(cols[kx] || [])).filter(g => g > 0)
                        return gs.length ? Math.min(...gs) : globalStep
                    }
                    const yOf = (keys) => keys.filter(n => graph.hasNode(n)).map(n => graph.getNodeAttribute(n, 'y'))
                    // дорожка (рамка без anchor, с заголовком), содержащая первый узел группы — по текущим координатам
                    const lanes = (data_graph.graphContext || []).filter(r => r.type === 'rect' && !r.anchor && r.title && r.y0 != null && r.y1 != null)
                    const laneOf = (r) => {
                        const n0 = r.anchor.nodes.find(n => graph.hasNode(n)); if (!n0) return null
                        const x = graph.getNodeAttribute(n0, 'x'), y = graph.getNodeAttribute(n0, 'y')
                        return lanes.find(L => x >= Math.min(L.x0, L.x1) && x <= Math.max(L.x0, L.x1) && y <= Math.max(L.y0, L.y1) && y >= Math.min(L.y0, L.y1)) || null
                    }
                    const info = new Map(), gapByLane = new Map()
                    for (const r of rectsA) {
                        const ys = yOf(r.anchor.nodes); if (!ys.length) continue
                        const top = Math.max(...ys), bot = Math.min(...ys), L = laneOf(r), d = (r.anchor.depth || 0) + 1
                        let gap = 0.5 * stepOf(r.anchor.nodes)
                        if (L) gap = Math.min(gap, (Math.max(L.y0, L.y1) - laneTitleU - top) / d - titleU, (bot - Math.min(L.y0, L.y1) - laneMarginU) / d)
                        info.set(r, { top, bot, L })
                        const key = L || '_'
                        gapByLane.set(key, Math.min(gapByLane.get(key) ?? Infinity, gap))
                    }
                    const byDepth = [...info.keys()].sort((a, b) => (b.anchor.depth || 0) - (a.anchor.depth || 0))   // вложенные — первыми
                    const fin = new Map()
                    for (const r of byDepth) {
                        const { top, bot, L } = info.get(r)
                        const gap = Math.max(gapByLane.get(L || '_') ?? 0, 2)
                        let y0 = top + gap + titleU, y1 = bot - gap
                        const set = new Set(r.anchor.nodes)
                        for (const c of byDepth) {
                            if (c === r || (c.anchor.depth || 0) <= (r.anchor.depth || 0) || !fin.has(c)) continue
                            if (!c.anchor.nodes.every(n => set.has(n))) continue   // не вложенная в r
                            const f = fin.get(c)
                            y0 = Math.max(y0, f.y0 + gap + titleU); y1 = Math.min(y1, f.y1 - gap)
                        }
                        fin.set(r, { y0, y1 })
                    }
                    for (const [r, f] of fin) { r.y0 = f.y0; r.y1 = f.y1 }
                }
            } catch (e) { console.warn('graph group rects anchor skipped', e) }
            this.graphBBox_update()   // IE 2026 09 26 / ODOO-…: расчёт габарита вынесен (тот же) — его зовёт и «Fit to view» без перекладки
            try { this.mapView_apply() } catch (e) { console.warn('graph map view skipped', e) }   // IE 2026 09 17 / ODOO-… (заказ Игоря): вид карты — цвета, размеры, области стран
            if (this.labelsLive()) this.labelsSchedule(null, true)   // IE 2026 09 14 / ODOO-335246 (Igor): координаты изменились — подписи заново (+ сдвиг узлов со связей)
        },
        // IE 2026 09 26 / ODOO-… (дефект Игоря: кнопки раскладки графа не вписывают граф): габарит графа (кастомный bbox sigma) по ТЕКУЩИМ координатам
        // узлов и графическому контексту — вынесен из graphPostLayout без изменений расчёта; «Fit to view» без перекладки считает его заново
        graphBBox_update() {
            const graph = this.graph
            const data_graph = this.data_graph || {}
            if (!graph || this._layoutRunning) return   // идёт раскладка Webworker — габарит по узлам (кастомный bbox выключен до остановки)
            const LABEL_PAD_PX = this.store.setting('fe.chart.graphLabelPadPx', 170)   // тот же резерв под подпись справа, что в graphPostLayout
            // IE 2026 08 21: кастомный bbox с полем справа — узлы не упираются в край,
            // титулы видны целиком; на mousedown-гейт автоскейла не влияет
            try {
                let mnX = Infinity, mxX = -Infinity, mnY = Infinity, mxY = -Infinity
                graph.forEachNode((n, a2) => {
                    if (a2.x < mnX) mnX = a2.x
                    if (a2.x > mxX) mxX = a2.x
                    if (a2.y < mnY) mnY = a2.y
                    if (a2.y > mxY) mxY = a2.y
                })
                const rect = this.$refs.sigmaRoot?.getBoundingClientRect?.()
                // IE 2026 09 06 / ODOO-335246 (Igor): графический контекст (рамки дорожек, разделители и подписи колонок)
                // входит в bbox — иначе подписи за краем узлов режутся холстом
                let cxMn = mnX, cxMx = mxX, cyMn = mnY, cyMx = mxY
                for (const r of data_graph.graphContext || []) {
                    if (r._ieArea) continue   // IE 2026 09 17 / ODOO-… (заказ Игоря): области стран строятся ПО bbox — в его расчёт не входят (иначе поле копится на каждом проходе)
                    for (const v of [r.x0, r.x1]) if (v != null) { if (v < cxMn) cxMn = v; if (v > cxMx) cxMx = v }
                    for (const v of [r.y0, r.y1]) if (v != null) { if (v < cyMn) cyMn = v; if (v > cyMx) cyMx = v }
                }
                if (rect && rect.width > 50 && mxX > mnX) {
                    // IE 2026 09 07 (Igor): в режиме keep spacing правый резерв шире — подписи крайней колонки длиннее 170 px
                    const padPx = LABEL_PAD_PX + ((this.effNoSqY() || this.userScale().fy > 1) ? 60 : 0)   // IE 2026 09 12 (Igor): авто-режим; IE 2026 09 13: и коэффициент высоты
                    const padX = (mxX - mnX) * padPx / Math.max(rect.width - padPx, 50)
                    const padY = rect.height > 50 ? (Math.max(cyMx - cyMn, 1) * 44 / rect.height) : 0   // место под подписи колонок (px → единицы)
                    // IE 2026 09 17 / ODOO-… (заказ Игоря: «Flow-tree-map»): слева — поле под названия областей стран,
                    // иначе они ложатся на подписи узлов первой колонки (как было у пунктирных полос бэка)
                    const padLPx = (this.mapViewOn && this.mapAreasOn && !this.layoutFree) ? this.store.setting('fe.chart.graphAreaLabelPadPx', 130) : 0   // IE 2026 09 26 / ODOO-…: у свободной раскладки полос стран нет
                    const padL = padLPx ? (mxX - mnX) * padLPx / Math.max(rect.width - padLPx, 50) : 0
                    this._graphBBox = { x: [Math.min(mnX, cxMn) - padL, Math.max(mxX + padX, cxMx)], y: [Math.min(mnY, cyMn) - padY, Math.max(mxY, cyMx)] }
                } else {
                    this._graphBBox = null
                }
                if (this.sigma && this._graphBBox) {
                    this.sigma.setCustomBBox(this._graphBBox)
                }
            } catch (e) { console.warn("graph bbox pad skipped", e) }
        },
        dagre(options) {
            let graph = this.graph
            const dagreGraph = new dagre.graphlib.Graph()
            
            dagreGraph.setGraph(options)
            dagreGraph.setDefaultEdgeLabel(() => ({}))

            // nodes++
            graph.forEachNode((node, attrs) => {
                dagreGraph.setNode(node, { label: node, width: attrs.size, height: attrs.size })
            })

            // edge++
            graph.forEachEdge((edge, attrs, source, target) => {
                dagreGraph.setEdge(source, target, { weight: attrs.size })
            })

            dagre.layout(dagreGraph)

            dagreGraph.nodes().forEach(node => {
                const pos = dagreGraph.node(node)
                graph.setNodeAttribute(node, 'x', pos.x)
                graph.setNodeAttribute(node, 'y', pos.y)
            })

            if (this.sigma) {
                this.refresh()
            }
        },
        // IE 2026 09 12 / ODOO-335246 (Igor): переложить граф от базовых координат под реальный размер (после «слепой» раскладки)
        relayoutNow() {
            if (!this.sigma) return
            try { this.sigma.resize(); this.graphPostLayout(); if (this._graphBBox) this.sigma.setCustomBBox(this._graphBBox); this.sigma.resize(); this.applyCameraMode?.(); this.refresh() } catch (e) { console.warn('graph relayout skipped', e) }
        },
        onContainerResize() {
            const r = this.$refs.sigmaRoot?.getBoundingClientRect?.()
            if (!r || r.width <= 50 || r.height <= 50) return
            if (this._pendingData) { const d = this._pendingData; this._pendingData = null; this.load_data(d); return }   // данные пришли, пока вкладка была скрыта
            if (this._layoutStale) this.relayoutNow()
            else if (this.labelsLive()) this.labelsSchedule()   // IE 2026 09 14 / ODOO-335246 (Igor): новая ширина — подписи заново
        },
        // ---- IE 2026 09 15 / ODOO-… (замечание Игоря): муравьиная логистика на графе — частицы по рёбрам; общие часы страницы ----
        antKey() { return `${this.WIDGET?.workspace || 'ws'}::${this.WIDGET?.page || 'page'}` },
        antUid() { return 'graph:' + (this.WIDGET?.id ?? this.attr_id) },
        antEnsure() {
            if (!this.antsOn || !this.sigma || !this.graph) { this.antStop(); return }
            if (!this._antRunner) this.antFlowsBuild()
            if (!this._antRaf) { this._antLast = performance.now(); this._antRaf = requestAnimationFrame(this.antFrame) }
        },
        antStop() {
            if (this._antRaf) { cancelAnimationFrame(this._antRaf); this._antRaf = null }
            if (this.antClockObj) { antClockLeave(this.antClockObj, this.antUid()); this.antClockObj = null }
            this._antRunner = null
        },
        // потоки = рёбра графа (вес — толщина ребра); экранные координаты узлов — в каждом кадре (камера sigma)
        antFlowsBuild() {
            const graph = this.graph, pos = this._antPos = new Map()
            const flows = []; const colorOf = new Map(); let ci = 0
            graph.forEachEdge((e, a, s, t) => {
                if (a.hidden || a.graph_hide) return
                if (!colorOf.has(s)) colorOf.set(s, ci++)
                const w = Number(a.size_base ?? a.size) || 1
                flows.push({ key: e, color: antHex(a.color_base || a.color, colorOf.get(s)), weight: w, months: null, size: 2.2,
                    pointAt: (tt) => { const p = pos.get(s), q = pos.get(t); if (!p || !q) return null; return { x: p.x + (q.x - p.x) * tt, y: p.y + (q.y - p.y) * tt } } })
            })
            this._antRunner = new AntRunner({ antsPerMax: 6, perFlowMax: 8, maxAnts: 1200, travelMs: 2200 })
            this._antRunner.setFlows(flows)
            if (!this.antClockObj) this.antClockObj = markRaw(antClock(this.antKey()))
            antClockStartMode(this.antClockObj, this.WIDGET?.record?.doc?.params?.graph_ants_total !== false)   // IE 2026 09 16 (заказ Игоря): по умолчанию Σ
            antClockJoin(this.antClockObj, this.antUid(), [])
            this.antStats = flows.length ? 'edges ' + flows.length : ''
            this._antSig = ''
        },
        antFrame(now) {
            this._antRaf = requestAnimationFrame(this.antFrame)
            const cv = this.$refs.antCanvas, r = this._antRunner, c = this.antClockObj, sigma = this.sigma, graph = this.graph
            if (!cv || !r || !c || !sigma || !graph) return
            const dt = Math.min(100, now - (this._antLast || now)); this._antLast = now
            const host = this.$refs.attr_container
            const hw = host ? host.clientWidth : cv.clientWidth, hh = host ? host.clientHeight : cv.clientHeight
            const dpr = window.devicePixelRatio || 1
            if (cv.width !== Math.round(hw * dpr) || cv.height !== Math.round(hh * dpr)) { cv.width = Math.round(hw * dpr); cv.height = Math.round(hh * dpr); cv.style.width = hw + 'px'; cv.style.height = hh + 'px' }
            const pos = this._antPos
            graph.forEachNode((n, a) => { pos.set(n, sigma.graphToViewport({ x: a.x, y: a.y })) })
            antClockSyncPeriod(c, this.store, this.WIDGET)   // IE 2026 09 15 (заказ Игоря): шкала времени — по чипсу периода стола
            antClockTick(c, this.antUid(), dt)
            // IE 2026 09 15 (замечание Игоря, вечер): пауза при одном месяце шкалы — снимок начала движения (см. AttrGeoMap.antFrame)
            const single = !c.playing && c.timeline.length === 1
            if (c.playing) { r.freezeLap = null; r.spawn(c.month || 'all', c.lap); r.step(dt, c.speed) }   // новая партия на каждый месяц часов страницы
            else if (single) { if (r.freezeLap !== c.lap) r.freezeBatch(c.month || 'all', c.lap); r.stepTo(dt, c.speed, 0.5) }
            else r.step(dt, c.speed)
            const ctx = cv.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, hw, hh)
            r.draw(ctx)
            const sig = antClockSig(c); if (sig !== this._antSig) { this._antSig = sig; this.antTick++ }
        },
        handleVisibility(isVisible) {
            this.isVisible = isVisible
            this.legendOwner_onVisible(isVisible)   // IE 2026 09 20 / ODOO-… (Игорь: легенда закрывается вместе с виджетом и на вкладке, к которой не относится)
            if (isVisible) {
                this.refresh()
                // IE 2026 09 12 / ODOO-335246 (Igor): граф пересобрали, пока вкладка была скрыта (высота контейнера 0 → «полоса») —
                // при показе повторить раскладку от базовых координат под реальный размер
                if (this._layoutStale) this.$nextTick(() => { try { if (this.sigma) { this.sigma.resize(); this.graphPostLayout(); this.sigma.resize(); this.applyCameraMode?.(); this.refresh() } } catch (e) { console.warn('graph relayout on show skipped', e) } })
            }
        },
        set_highlighted() {
            // WIDGET.record.doc.selector_values > highlighted

            const graph = this.graph

            for (const node of graph.nodes()) {
                graph.setNodeAttribute(node, 'highlighted', false);
            }
            for (const node of this.WIDGET.record.doc.selector_values || []) {
                if (graph.hasNode(node)) {
                    graph.setNodeAttribute(node, 'highlighted', true)
                }
            }
            this.get_highlighted()
        },
        get_highlighted() {
            // highlighted > selector_values... > WIDGET.record.doc.selector_values

            const graph = this.graph

            this.state.selector_values = new Set()
            this.state.selector_valuesNeighbors = new Set()
            for (let node of graph.nodes()) {
                if (graph.getNodeAttribute(node, "highlighted")) {
                    this.state.selector_values.add(node)
                    for (let node2 of this.graph.neighbors(node)) {
                        this.state.selector_valuesNeighbors.add(node2)
                    }
                }
            }
            
            this.state.selector_values_inEdges = new Set()
            this.state.selector_values_outEdges = new Set()
            for (let node of this.state.selector_values) {
                for (let edge of this.graph.inEdges(node)) {
                    this.state.selector_values_inEdges.add(edge)
                }
                for (let edge of this.graph.outEdges(node)) {
                    this.state.selector_values_outEdges.add(edge)
                }
            }

            this.WIDGET.record.doc.selector_values = Array.from(this.state.selector_values)
            this.WIDGET.record.doc.params.flex_havActiveSelectors = this.WIDGET.record.doc.selector_values.length > 0
            this.WIDGET.attrs_vueObj.WIDGET.set_commandPanel()
        },
        applyDimHighlight(detail) {
            // АН 2026 08 15 / ODOO-4997: подсветка узлов по измерениям из других
            // виджетов страницы. Отдельный атрибут dim_hl — НЕ selector (тот пишет
            // отборы и эмитит), поэтому ре-эмита и зацикливания нет by construction.
            if (!detail || detail.source === this.WIDGET?.id || !this.graph) return
            // IE 2026 08 17 / ODOO-4997 (решение Игоря, «строго»): узлы подсвечиваются
            // только по измерениям из Get fields виджета; пусто — не реагируем
            const _gv = this.store.selDims_filter(this.WIDGET, 'get', detail.values, false)
            if (!_gv.length) return
            detail = { ...detail, values: _gv }
            try {
                const keys = new Set()
                for (const v of detail.values || []) {
                    if (v?.kind === 'date') continue // у узлов графа дат нет
                    for (const k of [v?.key, v?.bare, v?.label]) if (k) keys.add(String(k))
                }
                let hits = 0
                this.graph.forEachNode((n, a2) => {
                    const bare = String(n).split('::')[0]
                    const hit = keys.size > 0 && (keys.has(String(n)) || keys.has(bare) || (a2.label && keys.has(String(a2.label))))
                    if (hit) { this.graph.setNodeAttribute(n, 'dim_hl', true); hits++ }
                    else if (a2.dim_hl) this.graph.removeNodeAttribute(n, 'dim_hl')
                    // АН 2026 08 15 / ODOO-4997 (замечание Игоря п.5): новый сигнал
                    // извне снимает прежнее ПОЛЬЗОВАТЕЛЬСКОЕ выделение узла — ТИХО
                    // (без эмита и без каскада отборов): активная подсветка одна
                    if (keys.size > 0 && a2.selector && !hit) this.graph.removeNodeAttribute(n, 'selector')
                })
                if (keys.size > 0) {
                    for (const r of this.data || []) { if (r && r.selector) r.selector = false }
                }
                if (window.__simDebug) console.log('sim: graph dim-highlight', keys.size, 'keys →', hits, 'nodes')
                this.sigma?.refresh()
            } catch (e) { /* чужой формат — молча */ }
        },
        emit_dimHighlight() {
            // АН 2026 08 15 / ODOO-4997 (заказ Игоря): каскад ПОДСВЕТКИ (не отбора,
            // тот управляется опцией selector_set_fields): выделенные узлы/связи
            // графа подсвечивают строки с теми же измерениями в соседних виджетах
            // страницы. Канал — window-событие, приёмник в AttrGrid.
            try {
                const values = []
                const seen = new Set()
                const push = (key, a2) => {
                    if (!key || seen.has(key)) return
                    seen.add(key)
                    // ключ узла = '<uuid>::<сегмент-колонки>' — гридам нужен чистый uuid
                    const bare = String(key).split('::')[0]
                    // узлы Supply Chain Flow — субъектной природы (РЦ/склады/байеры)
                    values.push({ key, kind: 'subject', bare: bare !== String(key) ? bare : undefined,
                                  label: a2?.label || String(key), doc_id: a2?.doc?.id })
                }
                this.graph.forEachNode((n, a2) => { if (a2.selector) push(n, a2) })
                this.graph.forEachEdge((e, a2, s, t, sa, ta) => {
                    if (a2.selector) { push(s, sa); push(t, ta) }
                })
                // IE 2026 08 17 / ODOO-4997 (решение Игоря, «строго»): отдаём только
                // измерения из Set fields виджета (узлы графа — kind 'subject');
                // пустой список — виджет молчит
                const gated = this.store.selDims_filter(this.WIDGET, 'set', values, false)
                if (!gated.length) return
                values.length = 0; values.push(...gated)
                if (window.__simDebug) console.log('sim: emit dim-highlight', values.length, 'values from widget', this.WIDGET?.id)
                window.dispatchEvent(new CustomEvent('wscm-dim-highlight', {
                    detail: { source: this.WIDGET?.id, page: this.WIDGET?.page, values },
                }))
            } catch (e) { console.warn('dim-highlight skipped', e) }
        },
        refresh(params={}) {
            // Refresh rendering
            if (this.sigma) {
                this.sigma.refresh({
                    // partialGraph: {
                    //     nodes,
                    //     edges,
                    // },
                    // We don't touch the graph data so we can skip its reindexation
                    skipIndexation: true,
                    ...params,
                })
            }
        },
        // ------------------ Chips -----------------------------------
        apply_CHIPS(e) {
            const graph = this.graph

            let CHIPS = []
            for (let i = 0; i < this.CHIPS.length; i++) {
                CHIPS.push({
                    segment: 'CHIP-Search', 
                    title: this.CHIPS[i].title.trim().toLowerCase()
                })
            }

            this.state.filter_values = new Set()
            // IE 2026 09 13 / ODOO-335246 (Igor): поиск по графу — ТЕМ ЖЕ механизмом, что чипс селектора и поиск в таблице
            // (utils/searchMatch + keyboardLayout): части через пробел ищутся отдельно (все должны найтись в подписи узла), ничего —
            // другая раскладка (EN↔RU, RU↔UK), снова ничего — ступени опечаток (1 гласная → 1 буква → 2 буквы → пропуски), на каждой
            // ступени — как набрано, затем другая раскладка; нашли — дальше не усложняем. Чипсы — ИЛИ между собой.
            // _searchTerms — [{terms, tier}] действующих терминов (для подсветки совпавшей части подписи в drawNodeLabelIcon);
            // «Show rows without matches» любого чипса — остальные узлы не приглушать
            const labels = graph.nodes().map(n => [n, String(graph.getNodeAttribute(n, 'label') || '')])
            this._searchTerms = []
            this._searchShowAll = (this.CHIPS || []).some(c => (c._raw || c).showAllLines)
            for (const c of CHIPS) {
                if (!c.title) continue
                const res = this.graphSearch(labels, c.title)
                res.nodes.forEach(n => this.state.filter_values.add(n))
                this._searchTerms.push({ terms: res.terms, tier: res.tier, conv: res.conv })
            }
            if (e) {
                this.refresh()
            }
        },
        // IE 2026 09 13 / ODOO-335246 (Igor): ступенчатый поиск по подписям узлов (и ключам): {nodes: Set, terms, tier, conv}
        graphSearch(labels, txt) {
            const t0 = searchTerms(txt)
            const tryT = (terms, tier) => { const s = new Set(); for (const [n, lab] of labels) { if (matchTerms(lab, terms, tier) || matchTerms(n, terms, tier)) s.add(n) } return s }
            let s = tryT(t0, 0)
            if (s.size) return { nodes: s, terms: t0, tier: 0, conv: '' }
            let cands = []
            try { cands = layoutCandidates(txt) } catch (e) { cands = [] }
            for (const cand of cands) { const t = searchTerms(cand); s = tryT(t, 0); if (s.size) return { nodes: s, terms: t, tier: 0, conv: cand } }
            const maxTier = Math.max(0, ...t0.map(fuzzyMaxTier))
            for (let tier = 1; tier <= Math.min(maxTier, FUZZY_TIERS); tier++) {
                s = tryT(t0, tier); if (s.size) return { nodes: s, terms: t0, tier, conv: '' }
                for (const cand of cands) { const t = searchTerms(cand); s = tryT(t, tier); if (s.size) return { nodes: s, terms: t, tier, conv: cand } }
            }
            return { nodes: new Set(), terms: t0, tier: 0, conv: '' }
        },
        check_CHIPS(title, CHIPS) {
            for (let ifilter = 0; ifilter < CHIPS.length; ifilter++) {
                if (title.indexOf(CHIPS[ifilter].title) >= 0) {
                    return true
                }
            }
            return false
        },
        // -----------------------------------------------------
        set_commandPanel() {
            let eval_params = {}
            eval_params['attr'] = this.attr

            let commandPanel = []
            // IE 2026 09 06 (Igor): переключатель режима выделения прямоугольником — в быстрых настройках шестерёнки (graphQuickOptions)

            let need_separator = commandPanel.length
            if (this.attr.groupMenu?.commandPanel) {
                this.attr.groupMenu.commandPanel.forEach(command_ => {
                    const command = command_, v_if = command_['v-if'] // { 'v-if': v_if, ...command } = command_
                    if (!command.autoGeneratedButton) {
                        command.visible = this.store.eval_value(this.WIDGET, v_if, eval_params)
                        if (need_separator) {
                            commandPanel.push({autoGeneratedButton:true})
                            need_separator = false
                        }
                        commandPanel.push(command)
                    }
                })
            }
            // IE 2026 09 13 / ODOO-335246 (Igor): масштаб — кнопки в одном ряду с Refresh, только иконки
            // IE 2026 09 13 / ODOO-335246 (Igor): два набора кнопок — масштаб по высоте и по ширине раскладки (щипок тачпада масштабирует обе оси)
            // IE 2026 09 13 / ODOO-335246 (Igor): свои иконки (SVG-маски, стиль ниже): стрелки от планки наружу — растянуть, к планке — сжать
            // IE 2026 09 23 / ODOO-341407: i18n: подписи кнопок масштаба
            for (const z of [['ie-ico-stretch-v', this.t('Stretch height'), 'scaleAxis', ['y', 1.15], 'chart.graph.stretchH'], ['ie-ico-squeeze-v', this.t('Squeeze height'), 'scaleAxis', ['y', 1 / 1.15], 'chart.graph.squeezeH'],
                             ['ie-ico-stretch-h', this.t('Stretch width'), 'scaleAxis', ['x', 1.15], 'chart.graph.stretchW'], ['ie-ico-squeeze-h', this.t('Squeeze width'), 'scaleAxis', ['x', 1 / 1.15], 'chart.graph.squeezeW'],
                             ['ie-ico-fit', this.t('Fit to view'), 'zoomFit', [], 'chart.graph.fit']]) {   // IE 2026 09 13 (Igor): своя иконка — граф, вписанный в рамку
                commandPanel.push({ attr_type: 'AttrButton', cssClass: `pi p-button-white ${z[0]}`, title: z[1], tooltip: z[1], showCommandTitle: false,
                                    command: 'attrFrontMethod', method: z[2], args: z[3], attr_target: this.attr.id, uiHelp: z[4] })   // U6 (заказ Игоря: объяснение элементов по Alt)
            }
            this.store.prepare_attrs(commandPanel, this.attr.html_id + (++this.ind_commandPanel))

            this.actionMenu = this.store.actionMenu_from_commandPanel(commandPanel, this.WIDGET)   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): + WIDGET — архив прячет запись только у данных модели (ревью #110599)
            this.actionMenu.push(this.store.prepare_actionMenu({ 'attr_type':'AttrButton', 'cssClass':'pi p-button-white pi-file-export', 'title': this.t('Export xlsx'), 'command': 'copyPaste', method: 'exportGrid', 'params':{'format':'xlsx'}, source_name:this.attr.name, 'binding':this.attr.binding }))
            this.actionMenu.push(this.store.prepare_actionMenu({'title':'-'}))

            for (let command_ of this.attr.groupMenu?.actionMenu || []) {
                const command = command_, v_if = command_['v-if'] // { 'v-if': v_if, ...command } = command_
                command.visible = this.store.eval_value(this.WIDGET, v_if, eval_params)
                const lastAddedAttr = this.actionMenu.length > 0 ? this.actionMenu[this.actionMenu.length - 1] : null
                if (command.visible && (!lastAddedAttr || lastAddedAttr.title !== command.title) && this.store.checkAccess(command, this.WIDGET)) {   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): + WIDGET — архив прячет запись только у данных модели (ревью #110599)
                    this.actionMenu.push(this.store.prepare_actionMenu(command))
                }
            }

            // console.log(commandPanel)
            // this.attr.groupMenu = this.attr.groupMenu || {}
            // this.attr.groupMenu.commandPanel = 
            this.commandPanel = commandPanel
        },
        // IE 2026 09 05 / ODOO-336800 (заказ Игоря): режим выделения прямоугольником. Кнопка панели (onRectSelect__Click) включает режим;
        // при нём mousedown на ПУСТОМ месте (downStage) начинает рамку, mousemovebody тянет её, mouseup выделяет узлы,
        // чьи экранные координаты (sigma.graphToViewport) попали в рамку. Семантика та же, что у клика по узлу:
        // атрибут selector (или highlighted при set_selector=false), dataItem.selector, каскад подсветки
        // (emit_dimHighlight) и каскад отборов (onApplySelector__Click) при настроенном канале. Без Shift —
        // выделение заменяется, с Shift — добавляется. Камеру sigma держим (preventSigmaDefault), как при drag узла.
        onRectSelect__Click() {
            this.rectSelect = !this.rectSelect
            this._rs = null; this.rectSel_box = null
            const btn = (this.commandPanel || []).find(b => b?.rectSelectButton)
            if (btn) btn.active = this.rectSelect
        },
        rectSel_hook(sigma, graph) {
            this._rs = null; this.rectSel_box = null
            // старт рамки: mousedown на пустом месте (downStage) и на ЛИНИИ СВЯЗИ (downEdge — при enableEdgeEvents
            // sigma отдаёт нажатие над ребром отдельным событием; для выделения узлов ребро = пустое место)
            // IE 2026 09 05 / ODOO-336800 (заказ Игоря, дополнение): и БЕЗ режима — Shift + нажатие на пустом месте +
            // протяжка запускает ту же рамку; узлы внутри ДОБАВЛЯЮТСЯ к выделению (как Shift в режиме кнопки)
            const rectSel_start = (p) => {
                if (!p?.event) return
                const ev = p.event
                const shift = !!(ev.original?.shiftKey)
                if (!this.rectSelect && !shift) return
                this._rs = { x0: ev.x, y0: ev.y, x1: ev.x, y1: ev.y, add: shift }
                p.preventSigmaDefault?.()
                this.rectSel_draw()
            }
            // IE 2026 09 10 / ODOO-335246 (Igor): перетаскивание области группы узлов (rect с anchor.nodes) за её рамку или
            // заголовок — вместе со всеми её узлами и вложенными областями (их anchor.nodes ⊆ узлов области). Без Shift / Alt
            // и не в режиме рамки выделения; сдвиг — в единицах графа, поэтому одинаков при любом масштабе камеры
            const rectDrag_start = (p) => {
                if (!p?.event || this._rs || this.rectSelect || p.event.original?.shiftKey || p.event.original?.altKey) return
                if (this.rectIconAtPoint(p.event)) return   // нажатие на иконку области — клик, не перетаскивание
                const hit = this.groupRectAtPoint(sigma, p.event)
                if (!hit) return
                const set = new Set(hit.anchor.nodes.filter(n => graph.hasNode(n)))
                if (!set.size) return
                const rects = (this.data_graph?.graphContext || []).filter(r => (r.type === 'rect' || r.type === 'fillRect') && r.anchor?.nodes?.length
                    && r.anchor.nodes.some(n => graph.hasNode(n)) && r.anchor.nodes.every(n => set.has(n) || !graph.hasNode(n)))
                if (!rects.includes(hit)) rects.push(hit)
                this._rd = { nodes: [...set], rects, last: sigma.viewportToGraph({ x: p.event.x, y: p.event.y }), moved: false }
                this.isDragging = true   // гасит hover заголовков областей на время перетаскивания
                p.preventSigmaDefault?.()
            }
            sigma.on('downStage', rectDrag_start)
            sigma.on('downEdge', rectDrag_start)
            sigma.on('downStage', rectSel_start)
            sigma.on('downEdge', rectSel_start)
            const captor = sigma.getMouseCaptor()
            captor.on('mousemovebody', (e) => {
                const rd = this._rd
                if (!rd || !e || typeof e.x !== 'number') return
                const pos = sigma.viewportToGraph({ x: e.x, y: e.y })
                const dx = pos.x - rd.last.x, dy = pos.y - rd.last.y
                rd.last = pos
                if (!dx && !dy) return
                for (const n of rd.nodes) { const a = graph.getNodeAttributes(n); graph.mergeNodeAttributes(n, { x: a.x + dx, y: a.y + dy }) }
                for (const r of rd.rects) { r.x0 += dx; r.x1 += dx; r.y0 += dy; r.y1 += dy }
                rd.moved = true
                e.preventSigmaDefault?.(); e.original?.preventDefault?.(); e.original?.stopPropagation?.()
                this._scheduleOverlayRedraw?.()
            })
            captor.on('mouseup', () => {
                if (!this._rd) return
                this._rd = null; this.isDragging = false
                this._scheduleOverlayRedraw?.()
            })
            captor.on('mousemovebody', (e) => {
                if (!this._rs) return
                this._rs.x1 = e.x; this._rs.y1 = e.y
                e.preventSigmaDefault?.(); e.original?.preventDefault?.()
                this.rectSel_draw()
            })
            captor.on('mouseup', (e) => {
                if (!this._rs) return
                if (e && typeof e.x === 'number') { this._rs.x1 = e.x; this._rs.y1 = e.y }
                this.rectSel_finish(sigma, graph)
            })
            // IE 2026 09 05 / ODOO-336800 (заказ Игоря, дополнение 2): клик по пустому месту БЕЗ протяжки и без Shift
            // снимает выделение с узлов — в обоих режимах. DOM-click приходит и после протяжки (камера, рамка),
            // поэтому сверяем точку нажатия с точкой клика: сдвиг больше 3px = была протяжка, не трогаем
            captor.on('mousedown', (e) => { this._stageDown = (e && typeof e.x === 'number') ? { x: e.x, y: e.y } : null })
            // IE 2026 09 10 / ODOO-335246 (Igor): клик по иконке типа перед подписью узла — то же, что Alt+клик по узлу;
            // на captor, а не на clickStage — под иконкой может лежать линия связи (тогда sigma даёт clickEdge, а не clickStage)
            // IE 2026 09 12 / ODOO-335246 (Igor, уточнение): клик по иконке — ЗАПИСЬ узла; Alt+клик по иконке — СПИСОК записей
            // сегмента / источника данных (как Alt+клик по узлу); у узлов без сегмента списка (задачи) — запись в обоих случаях
            captor.on('click', (e) => {
                if (!e || typeof e.x !== 'number') return
                const d = this._stageDown
                if (d && (Math.abs(e.x - d.x) > 3 || Math.abs(e.y - d.y) > 3)) return
                const node = this.iconAtPoint(e)
                if (node) {
                    const doc = graph.hasNode(node) ? graph.getNodeAttribute(node, 'doc') : null
                    const segI = (e.original?.altKey && doc?.id) ? this.nodeListSegment(doc) : null   // IE 2026 09 12 (Igor): Alt — список
                    if (segI) this.openSegmentList(segI); else if (doc?.id) this.openNodeRecord(doc, 'sigma.clickNodeIcon')
                    return
                }
                const rr = this.rectIconAtPoint(e)   // IE 2026 09 10 (Igor): иконка перед заголовком области — её запись
                if (rr?.doc?.id) this.openNodeRecord(rr.doc, 'sigma.clickRectIcon')
            })
            captor.on('mousemovebody', (e) => {   // IE 2026 09 10 (Igor): курсор-рука над иконкой типа узла; «move» над рамкой / заголовком области группы
                let cur = ''
                if (e && typeof e.x === 'number') cur = this._rd ? 'grabbing' : (this.iconAtPoint(e) || this.rectIconAtPoint(e)) ? 'pointer' : (!this._rs && !this.rectSelect && this.groupRectAtPoint(sigma, e)) ? 'move' : ''
                if (cur !== (this._iconCursor || '')) { this._iconCursor = cur; try { this.sigmaRoot.style.cursor = cur } catch (err) { /* нет контейнера */ } }
            })
            sigma.on('clickStage', (p) => {
                const ev = p?.event
                if (!ev || ev.original?.shiftKey) return
                const d = this._stageDown
                if (d && (Math.abs(ev.x - d.x) > 3 || Math.abs(ev.y - d.y) > 3)) return
                if (this.iconAtPoint(ev) || this.rectIconAtPoint(ev)) return   // IE 2026 09 10 (Igor): клик по иконке узла / области — обрабатывает captor 'click'
                // IE 2026 09 07 / ODOO-335246 (Igor): клик по периметру или заголовку прямоугольной области (graphContext rect с row)
                // — карточка связанной строки (дорожка подсистемы, группа источников, область структуры); самая вложенная область
                const rr = this.rectAtPoint(sigma, ev)
                if (rr) {
                    // IE 2026 09 08 / ODOO-335246 (Igor): Alt+клик по заголовку/периметру области со ссылкой (doc) — открыть её запись
                    if (ev.original?.altKey && !ev.original.ctrlKey && !ev.original.metaKey && rr.doc?.id) { this.openNodeRecord(rr.doc, 'sigma.altClickRect'); return }
                    this.openRowWidget(rr.row, { x: ev.x, y: ev.y }); return
                }
                this.rectSel_clearSelection(graph)
            })
        },
        // IE 2026 09 07 / ODOO-335246 (Igor): прямоугольник graphContext с row, у которого точка (экранные координаты) лежит
        // в полосе периметра (±6 px) или в полосе заголовка (верхние 20 px); из нескольких — самый маленький (вложенный)
        // IE 2026 09 10 / ODOO-335246 (Igor): экранные прямоугольники областей graphContext. Вложенная область с заголовком
        // начинается не выше строки заголовка родителя (RECT_HDR px — высота заголовка на экране не зависит от масштаба графа,
        // а отступы бэка заданы в единицах графа): верхняя грань сдвигается вниз, пока остаётся высота под содержимое
        rectBoxes(sigma) {
            const RECT_HDR = 22
            const boxes = []
            for (const row of this.data_graph?.graphContext || []) {
                if (row.type !== 'rect' && row.type !== 'fillRect') continue
                const p0 = sigma.graphToViewport({ x: row.x0, y: row.y0 }), p1 = sigma.graphToViewport({ x: row.x1, y: row.y1 })
                boxes.push({ row, rx: Math.min(p0.x, p1.x), ry: Math.min(p0.y, p1.y), rw: Math.abs(p1.x - p0.x), rh: Math.abs(p1.y - p0.y) })
            }
            if (boxes.some(b => b.row.titleRoom)) sgTitleRoom(boxes, (k) => this.nodeTopPx(sigma, k))   // IE 2026 10 25 / ODOO-348925: полоса заголовка группы схемы — выше узлов при любом масштабе
            boxes.sort((a, b) => b.rw * b.rh - a.rw * a.rh)   // родители (крупнее) раньше — сдвиг наследуется по цепочке
            for (let i = 0; i < boxes.length; i++) {
                const b = boxes[i]
                let parent = null
                for (let j = 0; j < i; j++) {
                    const a = boxes[j]
                    if (!a.row.title || a.noTitle || a.rx > b.rx + 1 || a.ry > b.ry + 1 || a.rx + a.rw < b.rx + b.rw - 1 || a.ry + a.rh < b.ry + b.rh - 1) continue   // IE 2026 10 25 / ODOO-348925: заголовок родителя не рисуется (noTitle) — вложенную не опускать
                    if (!parent || a.rw * a.rh < parent.rw * parent.rh) parent = a
                }
                if (!parent) continue
                const minTop = parent.ry + RECT_HDR
                if (b.ry < minTop) {
                    const d = Math.min(minTop - b.ry, Math.max(0, b.rh - 24))
                    b.ry += d; b.rh -= d
                }
            }
            return boxes
        },
        // IE 2026 09 10 / ODOO-335246 (Igor): наведение на обрезанный «…» заголовок области — тултип с полным названием
        // (тот же tooltip, что у узлов); уход с заголовка — скрыть с задержкой fe.ux.graphTooltipHideMs
        rectTitleHover(e) {
            if (this.isDragging || this._rs || this.state?.hoveredNode) return
            let hit = null
            for (const row of this.data_graph?.graphContext || []) {
                const t = row._tb   // полоса заголовка любой области (обрезанной или нет)
                if (t && e.x >= t.x && e.x <= t.x + t.w && e.y >= t.y && e.y <= t.y + t.h) { if (!hit || (row._tt && !hit._tt) || (t.w * t.h < hit._tb.w * hit._tb.h)) hit = row }
            }
            // IE 2026 09 10 (Igor): не тултип, а продолжение названия НА МЕСТЕ — как будто его не обрезали (drawGraphContext
            // рисует полное название поверх рамки на подложке); перерисовка только при входе / уходе.
            // IE 2026 09 10 (Igor): + подсветка узлов области и их связей, как при наведении на каждый узел (state.hoveredRect)
            if (this.mapViewOn) this.mapHover_area(hit?._ieArea || null)   // IE 2026 09 17 / ODOO-… (заказ Игоря): область страны — блок легенды и подпись с чекбоксом
            if (hit) {
                if (this._rectTipRow === hit) return
                this._rectTipRow = hit
                const graph = this.graph
                let inside = new Set((hit.anchor?.nodes || []).filter(n => graph.hasNode(n)))
                if (!inside.size) {   // область без anchor (структура стола): узлы по экранному положению внутри рамки
                    const bx = this.rectBoxes(this.sigma).find(b => b.row === hit)
                    if (bx) graph.forEachNode((n, a) => { const p = this.sigma.graphToViewport({ x: a.x, y: a.y }); if (p.x >= bx.rx && p.x <= bx.rx + bx.rw && p.y >= bx.ry && p.y <= bx.ry + bx.rh) inside.add(n) })
                }
                const nbrs = new Set()
                for (const n of inside) for (const m of graph.neighbors(n)) if (!inside.has(m)) nbrs.add(m)
                this.state.hoveredRect = inside.size ? { inside, nbrs } : undefined
                this.sigma?.refresh()
            } else if (this._rectTipRow) {
                this._rectTipRow = null
                this.state.hoveredRect = undefined
                this.sigma?.refresh()
            }
        },
        // IE 2026 09 10 / ODOO-335246 (Igor): подпись узла sigma (defaultDrawNodeLabel) — глиф primeicons типа узла (атрибут icon)
        // ОДНОГО размера (NODE_ICON_PX) цветом узла перед текстом; текст сдвинут вправо на ширину иконки. Прямоугольник иконки
        // запоминается (_iconBoxes) для клика / курсора. data — экранные координаты и размер (sigma 3 даёт их подписи готовыми)
        // IE 2026 09 10 / ODOO-335246 (Igor): положение подписи (иконка + текст) относительно узла — снизу (предпочтительно),
        // сверху, справа или слева: выбирается то, где прямоугольник подписи меньше всего накрывает связи ЭТОГО узла и кружки
        // соседей (штраф 10 за связь, 5 за кружок; при равенстве — снизу, сверху, справа, слева). Снизу / сверху подпись
        // не центрируется: её начало на два символа левее центра узла. Координаты — экранные (данные sigma)
        // IE 2026 09 11 / ODOO-335246 (Igor): варианта «слева» больше нет (только снизу, сверху, справа); forceK — положение,
        // выбранное предрасчётом recomputeLabelVisibility по ПОЛНОЙ подписи (обрезанная «…» подпись не меняет положения)
        labelPlace(ctx, data, settings, forceK) {
            if (this._layoutStd && !forceK && ieGraphLayout.get(this.WIDGET?.record?.doc?.params).labelRight) forceK = 'r'   // IE 2026 09 13 (Igor): стандартная раскладка — подпись справа, место под неё уже отведено
            const size = settings.labelSize, font = settings.labelFont, weight = settings.labelWeight
            const glyph = data.icon ? (this.piGlyph(data.icon) || (this.maskIconImage(data.icon) ? MASK_GLYPH : '')) : ''   // IE 2026 09 13 (Igor): иконки ie-ico-* — картинкой маски
            const iconW = glyph ? this.NODE_ICON_PX + 4 : 0
            ctx.font = `${weight} ${size}px ${font}`
            const w = iconW + ctx.measureText(String(data.label)).width, h = Math.max(size, this.NODE_ICON_PX) + 4
            // IE 2026 09 13 / ODOO-335246 (Igor): у узла записи формы (own) вокруг тела кольцо с белым зазором (drawOwnNodeRing: +4 и
            // ещё 2.5 + половина линии) — подпись отступает от кольца, а не от тела, иначе ложилась под него
            const r = data.size + (data.own ? 9 : 0), cx = data.x, cy = data.y
            const lead = ctx.measureText('00').width   // два символа левее центра узла (Igor 10.09)
            const cands = [
                { k: 'b', x: cx - lead, y: cy + r + h / 2 + 2 },
                { k: 't', x: cx - lead, y: cy - r - h / 2 - 2 },
                { k: 'r', x: cx + r + 3, y: cy },
            ]
            const live = this.labelsLive()
            // IE 2026 09 14 / ODOO-335246 (Igor): ещё два места — справа со сдвигом на 3/4 высоты вверх / вниз (когда «ровно справа» ложится на узел или связь)
            if (live) cands.push({ k: 'ru', x: cx + r + 3, y: cy - h * 0.75 }, { k: 'rd', x: cx + r + 3, y: cy + h * 0.75 })
            // IE 2026 09 14 / ODOO-335246 (Igor): кэш положения — только при ОТРИСОВКЕ (согласованность обрезанной подписи с полной); в проходе пересчёта
            // (this._placeCtx) место выбирается заново — раньше первый расчёт замораживал положение навсегда (скрин Igor 14.09:
            // подпись «Выборка…» сверху проходила под узлом «Расчет…», хотя справа было чисто)
            const fk = forceK || ((live && this._placeCtx) ? null : this._labelPlaceK?.get(data.key))
            if (fk) { const c = cands.find(x => x.k === fk); if (c) return { ...c, sc: 0, w, h, iconW, glyph } }
            const graph = this.graph, sigma = this.sigma
            let nbrs = []
            try {
                if (graph && sigma && data.key && graph.hasNode(data.key)) {
                    nbrs = graph.neighbors(data.key).map(n => { const a = graph.getNodeAttributes(n); const p = sigma.graphToViewport({ x: a.x, y: a.y }); const d = sigma.getNodeDisplayData(n); return { x: p.x, y: p.y, r: d ? Number(sigma.scaleSize(d.size)) || 6 : 6 } })
                }
            } catch (e) { nbrs = [] }
            const segBox = (ax, ay, bx, by, x0, y0, x1, y1) => {   // длина отрезка внутри прямоугольника (px), 0 — не пересекает
                if (Math.max(ax, bx) < x0 || Math.min(ax, bx) > x1 || Math.max(ay, by) < y0 || Math.min(ay, by) > y1) return 0
                const dx = bx - ax, dy = by - ay
                let t0 = 0, t1 = 1
                for (const [p, q] of [[-dx, ax - x0], [dx, x1 - ax], [-dy, ay - y0], [dy, y1 - ay]]) {
                    if (Math.abs(p) < 1e-9) { if (q < 0) return 0; continue }
                    const t = q / p
                    if (p < 0) { if (t > t1) return 0; if (t > t0) t0 = t } else { if (t < t0) return 0; if (t < t1) t1 = t }
                }
                return t0 <= t1 ? (t1 - t0) * Math.hypot(dx, dy) : 0
            }
            let best = null
            const pc0 = this._placeCtx, tbs = pc0 ? (pc0.tbs !== undefined ? pc0.tbs : (pc0.tbs = this.titleBandsClear())) : this.titleBandsClear()   // IE 2026 10 25 / ODOO-348925: полосы заголовков групп схемы (за проход — один раз)
            cands.forEach((c, i) => {
                const x0 = c.x - 2, y0 = c.y - h / 2, x1 = c.x + w + 2, y1 = c.y + h / 2
                let sc = i * 0.1, ec = 0   // IE 2026 09 14 / ODOO-335246 (Igor): ec — часть штрафа от связей под подписью
                if (tbs) sc += sgTitleHit({ x0, y0, x1, y1 }, tbs)   // IE 2026 10 25 / ODOO-348925: место на заголовке группы — только если чище нет
                for (const n of nbrs) {
                    const inside = segBox(cx, cy, n.x, n.y, x0, y0, x1, y1)   // штраф пропорционален длине связи под подписью (полный с 24 px)
                    if (inside > 0) { const v = 10 * Math.min(1, inside / 24); sc += v; ec += v }
                    if (n.x + n.r > x0 && n.x - n.r < x1 && n.y + n.r > y0 && n.y - n.r < y1) sc += 5
                }
                const pc = this._placeCtx   // IE 2026 09 13 / ODOO-335246 (Igor): любой узел под подписью — как сосед; чужая подпись — 3
                if (pc) {
                    // IE 2026 09 14 / ODOO-335246 (Igor): штраф пропорционален ПЛОЩАДИ пересечения (узел: 3 + до 5, чужая подпись: 2 + до 4), кольцо узла-хозяина
                    // учтено; ВСЕ видимые связи (не только свои) — препятствие, до 6 по длине отрезка под подписью
                    const ov = (ax0, ay0, ax1, ay1) => Math.max(0, Math.min(x1, ax1) - Math.max(x0, ax0)) * Math.max(0, Math.min(y1, ay1) - Math.max(y0, ay0))
                    for (const n of pc.pts) {
                        if (n.node === data.key) continue
                        const rr = n.sz + 2 + (live && n.own ? 9 : 0)
                        const a = ov(n.x - rr, n.y - rr, n.x + rr, n.y + rr)
                        if (a > 0) sc += live ? 3 + 5 * Math.min(1, a / (4 * rr * rr)) : 5
                    }
                    for (const b of pc.boxes) {
                        const a = ov(b.x0, b.y0, b.x1, b.y1)
                        if (a > 0) sc += live ? 2 + 4 * Math.min(1, a / Math.max(1, Math.min((x1 - x0) * (y1 - y0), (b.x1 - b.x0) * (b.y1 - b.y0)))) : 3
                    }
                    if (live) for (const e of pc.edges || []) {
                        if (e.s === data.key || e.t === data.key) continue
                        const inside = segBox(e.ax, e.ay, e.bx, e.by, x0, y0, x1, y1)
                        if (inside > 0) { const v = 6 * Math.min(1, inside / 24); sc += v; ec += v }
                    }
                }
                if (!best || sc < best.sc) best = { ...c, sc, ec, w, h, iconW, glyph }
            })
            return best
        },
        // IE 2026 10 25 / ODOO-348925: экранный верх узла (y − радиус, у узла записи — с кольцом) для запаса под заголовок группы; узла нет / скрыт — null
        nodeTopPx(sigma, key) {
            const g = this.graph
            try {
                if (!g || !sigma || !g.hasNode(key)) return null
                const a = g.getNodeAttributes(key)
                if (a.hidden) return null
                const p = sigma.graphToViewport({ x: a.x, y: a.y }), d = sigma.getNodeDisplayData(key)
                return p.y - (d ? Number(sigma.scaleSize(d.size)) || 6 : 6) - (a.own ? 9 : 0)
            } catch (e) { return null }
        },
        // IE 2026 10 25 / ODOO-348925 (замечание ie-dm7 #104334: подписи связей у «Узгоджений план» накладываются): подпись связи с labelDeclutter (граф схемы) — в очередь кадра,
        // рисует drawEdgeLabelsQ по afterRender (sgEdgeLabels: место вдоль связи без наложений, дубли того же текста — одной подписью «×n»); прочие связи — штатно sigma
        drawEdgeLabelQ(context, edgeData, sourceData, targetData, settings) {
            if (!edgeData || !edgeData.labelDeclutter) return drawStraightEdgeLabel(context, edgeData, sourceData, targetData, settings)
            ;(this._elQ || (this._elQ = [])).push({ context, edgeData, sourceData, targetData, settings })
            // IE 2026 10 25 / ODOO-348925: наведение — sigma перерисовывает подписи связей отдельным кадром (scheduleHighlightedNodesRender: renderEdgeLabels без
            // beforeRender / afterRender) — очередь рисуется сразу после него (микрозадачей), иначе подписи связей схемы пропадали до следующего кадра
            if (!this._inRender && !this._elFlush) { this._elFlush = true; queueMicrotask(() => { this._elFlush = false; this.drawEdgeLabelsQ() }) }
        },
        drawEdgeLabelsQ() {
            const q = this._elQ
            this._elQ = null
            if (!q || !q.length) return
            const st = q[0].settings, ctx = q[0].context, size = st.edgeLabelSize
            try {
                ctx.font = `${st.edgeLabelWeight} ${size}px ${st.edgeLabelFont}`
                const cache = new Map(), measure = (t) => { let w = cache.get(t); if (w === undefined) { w = ctx.measureText(t).width; cache.set(t, w) } return w }
                const nodes = new Map(), byKey = new Map()
                const items = q.map(({ edgeData: e, sourceData: s, targetData: t }) => {
                    byKey.set(e.key, e)
                    nodes.set(s.key, { key: s.key, x: s.x, y: s.y, r: s.size }); nodes.set(t.key, { key: t.key, x: t.x, y: t.y, r: t.size })
                    return { key: e.key, label: e.label, sx: s.x, sy: s.y, tx: t.x, ty: t.y, sSize: s.size, tSize: t.size, eSize: e.size, sKey: s.key, tKey: t.key }
                })
                const hide = q.some((x) => x.edgeData && x.edgeData.labelHide)   // IE 2026 10 25 / ODOO-348925: fe.ux.schemeGraphEdgeLabelHide
                const res = sgEdgeLabels(items, measure, size, this.titleBandsClear(), [...nodes.values()], undefined, hide ? { labels: this._nlBoxes || [], hide } : {})   // IE 2026 10 25 / ODOO-348925: подписи узлов кадра — приоритет
                const col = st.edgeLabelColor || {}
                let shown = 0, dups = 0, hits = 0
                for (const r of res) {
                    if (r.hit) hits++   // IE 2026 10 25 / ODOO-348925
                    if (r.hidden) continue
                    const e = byKey.get(r.key) || {}
                    ctx.fillStyle = col.attribute ? (e[col.attribute] || col.color || '#000') : (col.color || '#000')
                    ctx.save(); ctx.translate(r.cx, r.cy); ctx.rotate(r.angle); ctx.fillText(r.text, -r.w / 2, r.y); ctx.restore()
                    shown++; dups += r.dup
                }
                this._elStats = { frames: (this._elStats?.frames || 0) + 1, edges: q.length, shown, dups, hits }   // IE 2026 10 25 / ODOO-348925: hits — не нарисованы из-за наложения
            } catch (err) {
                console.warn('[AttrGraph] edge labels layout failed - drawn as usual', err)
                for (const x of q) { try { drawStraightEdgeLabel(x.context, x.edgeData, x.sourceData, x.targetData, x.settings) } catch (e2) { /* следующий кадр */ } }
            }
        },
        // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы PLAN-MAP-SET v3): экранные полосы заголовков прямоугольников с labelClear (группы AttrSchemeGraph) —
        // по тем же rectBoxes, шрифту строки и прилипанию к видимому углу, что drawGraphContext; нет таких прямоугольников — null (прочие графы не меняются)
        titleBandsClear() {
            const rows = this.data_graph?.graphContext
            const sigma = this.sigma
            if (!sigma || !Array.isArray(rows) || !rows.some(r => r && r.labelClear && r.title)) return null
            if (!this._tbCtx) this._tbCtx = document.createElement('canvas').getContext('2d')
            const m = this._tbCtx, cEl = this.$refs.attr_container
            const view = { left: (cEl?.scrollLeft || 0) + 2, top: (cEl?.scrollTop || 0) + 2 }
            const out = []
            for (const b of this.rectBoxes(sigma)) {
                const r = b.row
                if (!r.labelClear || !r.title || r._ieHide || b.noTitle) continue   // IE 2026 10 25 / ODOO-348925: заголовок не рисуется — полосы нет
                m.font = r.font || '600 12px sans-serif'
                const band = sgTitleBand(b, m.measureText(`${r.title}`).width, view, r.doc?.id ? this.NODE_ICON_PX + 4 : 0)
                if (band) out.push(band)
            }
            return out.length ? out : null
        },
        drawNodeLabelIcon(ctx, data, settings) {
            if (!data.label) return
            const size = settings.labelSize, font = settings.labelFont, weight = settings.labelWeight
            const color = settings.labelColor.attribute ? data[settings.labelColor.attribute] || settings.labelColor.color || '#000' : settings.labelColor.color
            const pl = this.labelPlace(ctx, data, settings)
            let x = pl.x
            const y = pl.y
            ;(this._nlBoxes || (this._nlBoxes = [])).push({ x0: x - 2, y0: y - pl.h / 2, x1: x + pl.w + 2, y1: y + pl.h / 2 })   // IE 2026 10 25 / ODOO-348925: подпись узла кадра — приоритет над подписями связей (drawEdgeLabelsQ)
            // IE 2026 09 10 / ODOO-335246 (Igor): подложка ТОЛЬКО по контурам иконки и текста (обводка + лёгкое размытие),
            // чтобы связи под подписью не мешали читать; там, где контуров нет, ничего не закрашивается
            const hc = this.bgAt(x + pl.w / 2, y)   // IE 2026 09 10 (Igor): цвет подложки = фон под подписью (контейнер + заливки дорожки / областей)
            const halo = (txt, hx, hy) => {
                ctx.save(); ctx.lineJoin = 'round'; ctx.lineWidth = 4; ctx.strokeStyle = hc
                ctx.shadowColor = hc; ctx.shadowBlur = 3
                ctx.strokeText(txt, hx, hy); ctx.restore()
            }
            if (pl.glyph) {
                const IP = this.NODE_ICON_PX
                ctx.save(); ctx.font = `${IP}px primeicons`; ctx.textBaseline = 'middle'; ctx.textAlign = 'left'
                // IE 2026 09 11 / ODOO-335246 (Igor): грязный узел (attributes.dirty — свои драфты, dirty_chain — грязен кто-то выше по
                // цепочке) — жёлто-коричневый кружок под иконкой типа, тем же цветом, что индикатор каскада в шапке; иконка белая
                // IE 2026 09 11 (Igor): стадия узла упала (attributes.error) — красный кружок вместо жёлтого
                // IE 2026 09 13 / ODOO-335246 (Igor): кружка грязноты под иконкой больше нет — состояние узла в заливке тела
                // (applyNodeScheme); иконка — цветом КЛАССА узла (color_type), чтобы класс читался при любой заливке
                const iconColor = data.color_type || data.color_body || data.color || color
                if (pl.glyph === MASK_GLYPH) {   // IE 2026 09 13 / ODOO-335246 (Igor): свой набор иконок (SVG-маска) — картинкой; подложка цветом фона
                    const under = this.maskIconCanvas(data.icon, hc, IP + 4), img = this.maskIconCanvas(data.icon, iconColor, IP)
                    if (under) ctx.drawImage(under, x - 2, y + 0.5 - IP / 2 - 2, IP + 4, IP + 4)
                    if (img) ctx.drawImage(img, x, y + 0.5 - IP / 2, IP, IP)
                } else {
                    halo(pl.glyph, x, y + 0.5)
                    ctx.fillStyle = iconColor
                    ctx.fillText(pl.glyph, x, y + 0.5)
                }
                ctx.restore()
                ;(this._iconBoxes = this._iconBoxes || {})[data.key] = { x0: x - 2, x1: x + IP + 2, y0: y - IP / 2 - 2, y1: y + IP / 2 + 2 }
                x += IP + 4
            }
            ctx.font = `${weight} ${size}px ${font}`
            halo(data.label, x, y + size / 3)
            // IE 2026 09 13 / ODOO-335246 (Igor): поиск чипсами — совпавшие части подписи на жёлтой подложке
            const terms = this._searchTerms
            if (terms && terms.length && this.state.filter_values?.has(data.key)) {
                const lab = String(data.label)
                for (const st of terms) {   // IE 2026 09 13 (Igor): подсветка по найденным частям (точные — жёлтая, с опечаткой / другой раскладкой — оранжевая)
                    let ranges = []
                    try { ranges = foundTerms(lab, st.terms, st.tier) || [] } catch (e) { ranges = [] }
                    for (const r of ranges) {
                        if (!(r.end > r.start)) continue
                        ctx.fillStyle = (r.fuzzy || st.conv) ? 'rgba(255, 150, 60, .55)' : 'rgba(255, 200, 0, .6)'
                        const pre = ctx.measureText(lab.slice(0, r.start)).width, ww = ctx.measureText(lab.slice(r.start, r.end)).width
                        ctx.fillRect(x + pre - 1, y + size / 3 - size * 0.85, ww + 2, size * 1.1)
                    }
                }
            }
            ctx.fillStyle = color
            ctx.fillText(data.label, x, y + size / 3)
        },
        // IE 2026 09 10 / ODOO-335246 (Igor): hover узла — как у sigma (белая плашка с тенью под подписью), но плашка шире
        // на иконку и подпись рисуется drawNodeLabelIcon, иначе текст при наведении прыгал бы влево
        drawNodeHoverIcon(ctx, data, settings) {
            const size = settings.labelSize, font = settings.labelFont, weight = settings.labelWeight
            ctx.font = `${weight} ${size}px ${font}`
            ctx.fillStyle = '#FFF'; ctx.shadowOffsetX = 0; ctx.shadowOffsetY = 0; ctx.shadowBlur = 8; ctx.shadowColor = '#000'
            const PADDING = 2
            if (typeof data.label === 'string') {
                // IE 2026 09 10 (Igor): подпись может стоять не справа (labelPlace) — плашка по её прямоугольнику + кружок узла
                const pl = this.labelPlace(ctx, data, settings)
                const boxHeight = Math.round(pl.h + 2 * PADDING), radius = Math.max(data.size, size / 2) + PADDING
                if (pl.k === 'r') {
                    const boxWidth = Math.round(pl.w + 5)
                    const angleRadian = Math.asin(boxHeight / 2 / radius)
                    const xDeltaCoord = Math.sqrt(Math.abs(Math.pow(radius, 2) - Math.pow(boxHeight / 2, 2)))
                    ctx.beginPath()
                    ctx.moveTo(data.x + xDeltaCoord, data.y + boxHeight / 2)
                    ctx.lineTo(data.x + radius + boxWidth, data.y + boxHeight / 2)
                    ctx.lineTo(data.x + radius + boxWidth, data.y - boxHeight / 2)
                    ctx.lineTo(data.x + xDeltaCoord, data.y - boxHeight / 2)
                    ctx.arc(data.x, data.y, radius, angleRadian, -angleRadian)
                    ctx.closePath(); ctx.fill()
                } else {
                    ctx.beginPath(); ctx.arc(data.x, data.y, radius, 0, Math.PI * 2); ctx.closePath(); ctx.fill()
                    ctx.fillRect(pl.x - 4, pl.y - boxHeight / 2, pl.w + 8, boxHeight)
                }
            } else {
                ctx.beginPath(); ctx.arc(data.x, data.y, data.size + PADDING, 0, Math.PI * 2); ctx.closePath(); ctx.fill()
            }
            ctx.shadowOffsetX = 0; ctx.shadowOffsetY = 0; ctx.shadowBlur = 0
            this.drawNodeLabelIcon(ctx, data, settings)
        },
        // IE 2026 09 11 / ODOO-335246 (Igor): онлайн-обновление грязных узлов: {ids: {id записи: число драфтов}} → attributes.dirty у узлов
        // с этими записями, dirty_chain — у всех, до кого дотягиваются рёбра от грязных (как cascade.apply_dirty_marks на бэке)
        applyDirtyIds(v) {
            const graph = this.graph, sigma = this.sigma
            if (!graph || !sigma || !v || typeof v !== 'object') return
            // IE 2026 09 13 / ODOO-335246 (Igor): у графа каскада есть штамп пометок (data_graph.dirty_stamp, бэк apply_dirty_marks);
            // опрос присылает свой штамп — при отличии граф перечитывается с бэка (перенос пометок документы → задача, состояния
            // wait / stale, пометки рёбер считает бэк), локальная перекраска ниже — только для графов без штампа
            if (v.stamp && this.data_graph && this.data_graph.dirty_stamp) {
                if (v.stamp === this.data_graph.dirty_stamp) return
                this.data_graph.dirty_stamp = v.stamp
                try { this.store.executeStoreMethod(this.WIDGET.vueObj, { command: 'executeWidgetMethod', method: 'select' }, this.attr) } catch (e) { console.warn('graph reread on marks change skipped', e) }
                return
            }
            const per = v.ids || {}, perErr = v.errors || {}
            const dirtyKeys = []
            graph.forEachNode((n, a) => {
                const id = a?.doc?.id ? String(a.doc.id) : ''
                const cnt = id ? (per[id] || 0) : 0, err = id ? (perErr[id] || 0) : 0
                if (cnt) { graph.setNodeAttribute(n, 'dirty', cnt); dirtyKeys.push(n) } else if (a.dirty) graph.removeNodeAttribute(n, 'dirty')
                if (err) { graph.setNodeAttribute(n, 'error', err); if (!cnt) dirtyKeys.push(n) } else if (a.error) graph.removeNodeAttribute(n, 'error')   // IE 2026 09 11 (Igor): упавшая стадия — красный
                if (a.dirty_chain) graph.removeNodeAttribute(n, 'dirty_chain')
            })
            // задача грязна при грязных документах (ребро задача → documents)
            graph.forEachEdge((e, ea, src, tgt) => { if (/^n:documents:/.test(tgt) && /^n:task-/.test(src) && graph.getNodeAttribute(tgt, 'dirty') && !graph.getNodeAttribute(src, 'dirty')) { graph.setNodeAttribute(src, 'dirty', graph.getNodeAttribute(tgt, 'dirty')); dirtyKeys.push(src) } })
            const seen = new Set(dirtyKeys), stack = [...dirtyKeys]
            while (stack.length) {
                const k = stack.pop()
                graph.forEachOutNeighbor(k, (t) => { if (seen.has(t)) return; seen.add(t); stack.push(t); if (!graph.getNodeAttribute(t, 'dirty')) graph.setNodeAttribute(t, 'dirty_chain', true) })
            }
            this.applyNodeScheme(graph, false)   // IE 2026 09 13 (Igor): заливка по новому состоянию
            try { sigma.refresh() } catch (e) { /* граф в перестроении */ }
        },
        // IE 2026 09 13 / ODOO-335246 (Igor): СХЕМА МАРКИРОВКИ УЗЛОВ («форма, заливка, обводка, кольцо», принял Igor 13.09):
        //  форма   — роль: квадрат = задача, круг = данные (бэк, attributes.type);
        //  заливка — состояние: clean серо-синий, dirty (драфты к пересчёту) жёлто-коричневый как индикатор каскада в шапке,
        //            wait (все драфты ждут задачу без Run automatically) синий, stale серый, error (стадия упала) красный;
        //  обводка — участие: белое тело без обводки = вне модели каскада (hollow); тёмная обводка = Use in calculation cascade;
        //            двойная обводка = Run automatically in the cascade (drawFlagMarks); вымпелов больше нет;
        //  кольцо  — внешнее кольцо с белым зазором = запись, в форме которой построен граф (drawOwnNodeRing);
        //  класс узла (источник / запрос / задача / документы) — иконкой перед подписью в цвете класса (color_type с бэка = color).
        // fresh — цвет класса берётся из свежих атрибутов бэка (color); иначе (живое обновление грязных) — из color_type
        applyNodeScheme(graph, fresh) {
            if (!graph) return
            const ST = { clean: '#8a97ad', dirty: '#c98a12', wait: '#5b8fd6', stale: '#c5c9d1', error: '#d64541' }   // цвета заливки по состоянию (та же таблица — в легенде бэка, cascade.legend_scheme_items)
            graph.forEachNode((n, a) => {
                const typeCol = (fresh || !a.color_type) ? (a.color_type_src || a.color || '#2a78d6') : a.color_type
                const state = a.error ? 'error' : a.wait ? 'wait' : a.stale ? 'stale' : a.dirty ? 'dirty' : 'clean'
                const upd = { color_type: typeCol, color_type_src: typeCol, state }
                if (a.hollow) { upd.color = '#ffffff'; upd.color_body = state === 'clean' ? '#b8bfca' : ST[state] }
                else { upd.color = ST[state]; upd.color_body = ST[state] }
                graph.mergeNodeAttributes(n, upd)
            })
            // IE 2026 09 13 / ODOO-335246 (Igor): пометка — это связь «узел → задача»: ребро с attributes.mark (бэк, apply_dirty_marks)
            // красится цветом состояния и толще; скрытое правилом цепочки ребро (graph_hide) показывается только с пометкой
            graph.forEachEdge((e, a) => {
                if (a.color_base === undefined) graph.mergeEdgeAttributes(e, { color_base: a.color, size_base: a.size })
                const b = graph.getEdgeAttributes(e)
                // IE 2026 09 14 / ODOO-335246 (Igor): stale-пометка ребра (изменённый источник → витрина без флага) — цвет заливки stale
                // (#c5c9d1) на ребре не отличим от обычного (#c9ced6); IE 2026 09 15 (Igor): тёмно-серый тоже не читался как выделение —
                // ребро красится оранжевым грязного источника, откуда идёт изменение (та же логика, что заливка узла-источника)
                if (a.mark && ST[a.mark]) graph.mergeEdgeAttributes(e, { color: a.mark === 'stale' ? ST.dirty : ST[a.mark], size: Math.max(Number(b.size_base) || 1, 2.5), hidden: false, zIndex: 3 })
                else graph.mergeEdgeAttributes(e, { color: b.color_base, size: b.size_base, hidden: !!a.graph_hide, zIndex: 0 })
            })
        },
        // IE 2026 09 11 / ODOO-335246 (Igor): узел записи-хозяина формы (attributes.own с бэка) — двойное кольцо вокруг кружка
        // (белое поле + кольцо цветом узла), чтобы на графе задачи / DS / сегмента было видно «это я»
        drawOwnNodeRing(sigma, ctx) {
            const graph = this.graph
            if (!graph || !sigma || !ctx) return
            graph.forEachNode((n, a) => {
                if (!a.own) return
                const d = sigma.getNodeDisplayData(n)
                if (!d || d.hidden) return
                const p = sigma.graphToViewport({ x: a.x, y: a.y })
                const r = (Number(sigma.scaleSize(d.size)) || 6) + 4
                ctx.save()
                // IE 2026 09 12 / ODOO-335246 (Igor): у узла-квадрата (задачи) — скруглённый квадрат вокруг, у круга — кольцо
                const path = () => { ctx.beginPath(); if (a.type === 'square') { const q = r + 2.5, rr = q * 0.24; ctx.roundRect ? ctx.roundRect(p.x - q, p.y - q, 2 * q, 2 * q, rr) : ctx.rect(p.x - q, p.y - q, 2 * q, 2 * q) } else ctx.arc(p.x, p.y, r + 2.5, 0, Math.PI * 2) }
                path(); ctx.strokeStyle = 'rgba(255,255,255,.95)'; ctx.lineWidth = 5; ctx.stroke()
                path(); ctx.strokeStyle = d.color || a.color || '#2a78d6'; ctx.lineWidth = 2.5; ctx.stroke()
                ctx.restore()
            })
        },
        // IE 2026 09 11 / ODOO-335246 (Igor, два флага): flag_use === false — кольцо цветом узла по краю белого тела (пустой узел);
        // flag_auto — значок автозапуска: белый кружок с треугольником цветом узла у правого верхнего края
        drawFlagMarks(sigma, ctx) {
            // IE 2026 09 13 / ODOO-335246 (Igor): обводка = участие (см. applyNodeScheme): hollow — тонкий контур цветом состояния /
            // серый по краю белого тела; flag_use — тёмная обводка 2px; flag_auto — та же плюс вторая линия внутри (двойная)
            const graph = this.graph
            if (!graph || !sigma || !ctx) return
            graph.forEachNode((n, a) => {
                if (!a.hollow && !a.flag_use && !a.flag_auto) return
                const d = sigma.getNodeDisplayData(n)
                if (!d || d.hidden) return
                const p = sigma.graphToViewport({ x: a.x, y: a.y })
                const r = Number(sigma.scaleSize(d.size)) || 6
                const path = (q) => { ctx.beginPath(); if (a.type === 'square') { ctx.roundRect ? ctx.roundRect(p.x - q, p.y - q, 2 * q, 2 * q, q * 0.24) : ctx.rect(p.x - q, p.y - q, 2 * q, 2 * q) } else ctx.arc(p.x, p.y, q, 0, Math.PI * 2) }
                ctx.save()
                if (a.hollow) {
                    ctx.strokeStyle = a.color_body || '#b8bfca'; ctx.lineWidth = 1.5; path(Math.max(r - 0.75, 2)); ctx.stroke()
                } else {
                    ctx.strokeStyle = '#2f3640'; ctx.lineWidth = 2; path(Math.max(r - 1, 2)); ctx.stroke()
                    if (a.flag_auto) { ctx.lineWidth = 1.2; path(Math.max(r - 4.5, 1.5)); ctx.stroke() }
                }
                ctx.restore()
            })
        },
        // IE 2026 09 10 / ODOO-335246 (Igor): узел, чья иконка типа лежит под точкой (экранные координаты), иначе null
        iconAtPoint(ev) {
            const boxes = this._iconBoxes
            if (!boxes || !ev) return null
            for (const n in boxes) { const b = boxes[n]; if (ev.x >= b.x0 && ev.x <= b.x1 && ev.y >= b.y0 && ev.y <= b.y1) return n }
            return null
        },
        // IE 2026 09 10 / ODOO-335246 (Igor): фон под точкой экрана для подложки подписей — цвет контейнера, поверх него
        // полупрозрачные заливки дорожек и областей, в которые попадает точка (в порядке отрисовки)
        parseRGBA(str) {
            const m = /rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)\s*(?:,\s*([\d.]+)\s*)?\)/.exec(String(str || ''))
            if (m) return [+m[1], +m[2], +m[3], m[4] == null ? 1 : +m[4]]
            const h = /^#([0-9a-f]{6})$/i.exec(String(str || '').trim())
            if (h) return [parseInt(h[1].slice(0, 2), 16), parseInt(h[1].slice(2, 4), 16), parseInt(h[1].slice(4, 6), 16), 1]
            return null
        },
        refreshBgFills(sigma) {
            let el = this.$refs.sigmaRoot, base = null
            for (let i = 0; el && i < 12 && !base; i++, el = el.parentElement) {
                const c = this.parseRGBA(getComputedStyle(el).backgroundColor)
                if (c && c[3] > 0) base = c
            }
            this._bgBase = base || [255, 255, 255, 1]
            this._rectFills = this.rectBoxes(sigma).filter(b => b.row.fillStyle).map(b => ({ rx: b.rx, ry: b.ry, rw: b.rw, rh: b.rh, c: this.parseRGBA(b.row.fillStyle) })).filter(b => b.c)
        },
        bgAt(x, y) {
            // заливки — не чаще раза за кадр анимации (beforeRender sigma не покрывает перерисовку подписей после ресайза — кэш устаревал)
            if (!this._bgFresh && this.sigma) {
                try { this.refreshBgFills(this.sigma) } catch (e) { /* подложка — не критично */ }
                this._bgFresh = true; requestAnimationFrame(() => { this._bgFresh = false })
            }
            let [r, g, b] = this._bgBase || [255, 255, 255]
            for (const f of this._rectFills || []) {
                if (x < f.rx || x > f.rx + f.rw || y < f.ry || y > f.ry + f.rh) continue
                const a = f.c[3]
                r = f.c[0] * a + r * (1 - a); g = f.c[1] * a + g * (1 - a); b = f.c[2] * a + b * (1 - a)
            }
            return `rgba(${Math.round(r)},${Math.round(g)},${Math.round(b)},0.92)`
        },
        // IE 2026 09 10 / ODOO-335246 (Igor): область (rect graphContext), чья иконка записи лежит под точкой, иначе null
        rectIconAtPoint(ev) {
            if (!ev) return null
            for (const row of this.data_graph?.graphContext || []) {
                const b = row._ib
                if (b && ev.x >= b.x0 && ev.x <= b.x1 && ev.y >= b.y0 && ev.y <= b.y1) return row
            }
            return null
        },
        // IE 2026 09 10 / ODOO-335246 (Igor): сегмент, чей список записей открывает Alt+клик по узлу: узел хранимого сегмента
        // (doc.segment SEGMENTS / SEGMENTS-inbound …); иначе null — тогда Alt+клик открывает запись (у источника данных списка
        // записей нет — widget-list по id DS не открывается, проверено 10.09)
        // IE 2026 09 11 (Igor): + источники данных и витрины (DATA-SOURCE…) — список с выборкой по ним (widget-list по id DS,
        // проверено 11.09: заголовок, чип DS, строки выборки)
        nodeListSegment(doc) {
            const seg = String(doc?.segment || '')
            return doc?.id && (seg.startsWith('SEGMENTS') || seg.startsWith('DATA-SOURCE')) ? doc.id : null
        },
        // IE 2026 09 10 / ODOO-335246 (Igor): глиф primeicons по классу (pi-folder …) — из content псевдоэлемента ::before, кэш
        // IE 2026 09 13 / ODOO-335246 (Igor): иконки ie-ico-* (SVG-маски из ie-icons*.css) на канвасе графа: маска читается из
        // mask-image псевдоэлемента, грузится как картинка (кэш на окно, по загрузке — перерисовка), красится через offscreen-канвас
        // (fill цветом + destination-in); кэш цветных канвасов по (класс, цвет, размер)
        maskIconImage(cls) {
            if (!cls || !String(cls).startsWith('ie-ico-')) return null
            const cache = (window.__ieIconImgs = window.__ieIconImgs || {})
            if (cls in cache) return cache[cls] && cache[cls].ready ? cache[cls].img : null
            cache[cls] = null
            try {
                const el = document.createElement('i'); el.className = 'pi ' + cls; el.style.position = 'absolute'; el.style.left = '-9999px'
                document.body.appendChild(el)
                const st = getComputedStyle(el, '::before'); const mi = st.webkitMaskImage || st.maskImage || ''
                document.body.removeChild(el)
                const m = /url\(["']?(data:image\/svg\+xml[^"')]+)["']?\)/.exec(mi)
                if (!m) return null
                const img = new Image(); const rec = { img, ready: false }; cache[cls] = rec
                img.onload = () => { rec.ready = true; try { this.sigma?.refresh() } catch (e) { /* граф закрыт */ } }
                img.src = m[1]
            } catch (e) { cache[cls] = null }
            return null
        },
        maskIconCanvas(cls, color, px) {
            const img = this.maskIconImage(cls)
            if (!img) return null
            const cache = (window.__ieIconCanvases = window.__ieIconCanvases || {})
            const key = cls + '|' + color + '|' + px
            if (cache[key]) return cache[key]
            const dpr = Math.min(3, window.devicePixelRatio || 1), c = document.createElement('canvas')
            c.width = Math.ceil(px * dpr); c.height = Math.ceil(px * dpr)
            const g = c.getContext('2d'); g.scale(dpr, dpr)
            g.fillStyle = color || '#000'; g.fillRect(0, 0, px, px)
            g.globalCompositeOperation = 'destination-in'; g.drawImage(img, 0, 0, px, px)
            cache[key] = c
            return c
        },
        piGlyph(cls) {
            const cache = (window.__piGlyphs = window.__piGlyphs || {})   // this — прокси Vue, constructor недоступен
            if (cls in cache) return cache[cls]
            let g = ''
            try {
                const el = document.createElement('i'); el.className = 'pi ' + cls; el.style.position = 'absolute'; el.style.left = '-9999px'
                document.body.appendChild(el)
                const c = getComputedStyle(el, '::before').content || ''
                document.body.removeChild(el)
                g = c.replace(/^["']|["']$/g, '')
                if (g === 'none' || g === 'normal') g = ''
            } catch (e) { g = '' }
            cache[cls] = g
            return g
        },
        // IE 2026 09 10 / ODOO-335246 (Igor): область группы узлов (rect с anchor.nodes), за рамку (±6 px) или заголовок которой
        // взялись; из вложенных — самая маленькая. Для перетаскивания области вместе с узлами
        groupRectAtPoint(sigma, ev) {
            let best = null
            for (const { row, rx, ry, rw, rh } of this.rectBoxes(sigma)) {
                if (!row.anchor?.nodes?.length) continue
                if (ev.x < rx - 6 || ev.x > rx + rw + 6 || ev.y < ry - 6 || ev.y > ry + rh + 6) continue
                const nearBorder = Math.abs(ev.x - rx) <= 6 || Math.abs(ev.x - (rx + rw)) <= 6 || Math.abs(ev.y - ry) <= 6 || Math.abs(ev.y - (ry + rh)) <= 6
                const inTitle = !!row.title && ev.y >= ry && ev.y <= ry + 20 && ev.x >= rx && ev.x <= rx + rw
                if (!nearBorder && !inTitle) continue
                if (!best || rw * rh < best.area) best = { row, area: rw * rh }
            }
            return best ? best.row : null
        },
        rectAtPoint(sigma, ev) {
            let best = null
            for (const { row, rx, ry, rw, rh } of this.rectBoxes(sigma)) {   // IE 2026 09 10 (Igor): те же экранные прямоугольники, что рисуются
                if (!row.row) continue
                const inside = ev.x >= rx - 6 && ev.x <= rx + rw + 6 && ev.y >= ry - 6 && ev.y <= ry + rh + 6
                if (!inside) continue
                const nearBorder = Math.abs(ev.x - rx) <= 6 || Math.abs(ev.x - (rx + rw)) <= 6 || Math.abs(ev.y - ry) <= 6 || Math.abs(ev.y - (ry + rh)) <= 6
                const inTitle = !!row.title && ev.y >= ry && ev.y <= ry + 20 && ev.x >= rx && ev.x <= rx + rw
                if (!nearBorder && !inTitle) continue
                const area = rw * rh
                if (!best || area < best.area) best = { row: row.row, doc: row.doc, area }   // IE 2026 09 08 (Igor): doc — запись области (Alt+клик)
            }
            return best
        },
        rectSel_clearSelection(graph) {
            const attrName = this.set_selector ? 'selector' : 'highlighted'
            let n = 0
            graph.forEachNode((node) => { if (graph.getNodeAttribute(node, attrName)) { graph.removeNodeAttribute(node, attrName); n++ } })
            if (!n) return
            const st = this._rectSelStats || (this._rectSelStats = { drags: 0, selected: 0 })
            st.cleared = (st.cleared || 0) + n
            if (this.set_selector) {
                this.rectSel_clearRows(this.data)
                this.emit_dimHighlight()
                const hasSelChannel = !!((this.WIDGET?.record?.doc?.params?.fieldSelectors || []).length)
                if (hasSelChannel) this.store.executeStoreMethod(this.WIDGET.vueObj, { 'command': 'onApplySelector__Click' }, this.attr)
            }
            this.get_highlighted()
        },
        rectSel_draw() {
            const r = this._rs
            if (!r) { this.rectSel_box = null; return }
            this.rectSel_box = { left: `${Math.min(r.x0, r.x1)}px`, top: `${Math.min(r.y0, r.y1)}px`,
                width: `${Math.abs(r.x1 - r.x0)}px`, height: `${Math.abs(r.y1 - r.y0)}px` }
        },
        rectSel_clearRows(arr) {
            for (const item of arr || []) {
                if (!item) continue
                if (item.selector) item.selector = false
                if (item.attrs) this.rectSel_clearRows(item.attrs)
            }
        },
        rectSel_finish(sigma, graph) {
            const r = this._rs
            this._rs = null; this.rectSel_box = null
            if (!r || !graph || !sigma) return
            const x0 = Math.min(r.x0, r.x1), x1 = Math.max(r.x0, r.x1), y0 = Math.min(r.y0, r.y1), y1 = Math.max(r.y0, r.y1)
            if (x1 - x0 < 3 && y1 - y0 < 3) return   // клик без протяжки — его обработает clickStage (снятие выделения)
            const inside = []
            graph.forEachNode((n, a) => {
                if (a.hidden) return
                const v = sigma.graphToViewport({ x: a.x, y: a.y })
                if (v.x >= x0 && v.x <= x1 && v.y >= y0 && v.y <= y1) inside.push(n)
            })
            const attrName = this.set_selector ? 'selector' : 'highlighted'
            if (!r.add) {
                graph.forEachNode((n) => { if (graph.getNodeAttribute(n, attrName)) graph.removeNodeAttribute(n, attrName) })
                if (this.set_selector) this.rectSel_clearRows(this.data)
            }
            for (const n of inside) {
                graph.setNodeAttribute(n, attrName, true)
                if (this.set_selector) { const di = this.get_dataItem(this.data, n); if (di) di.selector = true }
            }
            const st = this._rectSelStats || (this._rectSelStats = { drags: 0, selected: 0 })
            st.drags++; st.selected += inside.length
            if (this.set_selector) {
                this.emit_dimHighlight()
                const hasSelChannel = !!((this.WIDGET?.record?.doc?.params?.fieldSelectors || []).length)
                if (hasSelChannel && (inside.length || !r.add)) {
                    this.store.executeStoreMethod(this.WIDGET.vueObj, { 'command': 'onApplySelector__Click' }, this.attr)
                }
            }
            this.get_highlighted()
        },

        // ================= IE 2026 09 17 / ODOO-… (заказ Игоря: «Flow-tree-map») =================
        // Граф правил снабжения показывается по правилам карты (AttrGeoMap): области стран — прямоугольники, закрашенные
        // мерой (как территории), узлы — диск (мера размера), кольцо (вторая мера) и красное ядро (непокрытое), связи —
        // толщина по мере и красный цвет при непокрытом объёме; окно легенды с вкладками Node / Legend; подпись наведения —
        // чекбокс селектора и иконка записи, как бейдж карты. Выключатель: fe.ux.graphMapView, настройка виджета graph_map.
        mapPickMeasure(param, defaults) {
            const list = this.mapMeasures
            const has = (b) => b && list.some(m => m.binding === b)
            const cfg = this.get_viewParam(param, '')
            if (cfg === 'none') return ''
            if (has(cfg)) return cfg
            for (const b of defaults) if (has(b)) return b
            return ''
        },
        mapTitleOf(binding) { return (this.mapFields.get(binding) || {})._title || binding || '' },
        mapFmt(v, binding) {
            if (!Number.isFinite(v)) return ''
            const f = this.mapFields.get(binding)
            if (f?.attr_type === 'AttrTime') return this.store.formatTimeHTML(v, f)
            if (f?.attr_type === 'AttrDays') return this.store.formatDaysHTML(v, f)
            try { return this.store.formatNumberHTML(v, f) || String(Math.round(v)) } catch (e) { return String(Math.round(v)) }
        },
        mapFmtText(v, binding) { return String(this.mapFmt(v, binding) || '').replace(/<[^>]*>/g, '').trim() },
        mapScaleOf(values) {
            const vals = (values || []).filter(v => Number.isFinite(v))
            if (!vals.length) return { min: 0, max: 1, single: true, gradient: MAP_SINGLE, colorOf: () => MAP_EMPTY }
            let min = Math.min(...vals), max = Math.max(...vals)
            const single = max <= min
            if (single) max = min + 1
            return {
                min, max, single,
                gradient: single ? MAP_SINGLE : `linear-gradient(90deg, ${MAP_COLORS.join(', ')})`,
                colorOf: (v) => !Number.isFinite(v) ? MAP_EMPTY : (single ? MAP_SINGLE : mapPalette((v - min) / (max - min))),
            }
        },
        // радиус (в единицах размера sigma): площадь пропорциональна значению — то же правило, что у точек карты
        mapSizeOf(v, maxV) {
            if (!Number.isFinite(v) || v <= 0 || !maxV) return 0
            return MAP_MIN_S + (MAP_MAX_S - MAP_MIN_S) * Math.sqrt(Math.min(1, v / maxV))
        },
        // мера-«состояние» (DOS, агрегат Max / Avg) по области усредняется, количественная — суммируется
        mapAggAvg(binding) {
            const f = this.mapFields.get(binding) || {}
            const ag = String(f.aggregate || '').toLowerCase()
            return f.attr_type === 'AttrTime' || ag === 'max' || ag === 'avg' || ag === 'average' || ag === 'wavg' || /^DOS/i.test(binding || '')
        },
        mapNodeD(key) { return (this.graph?.hasNode(key) ? this.graph.getNodeAttributes(key).D : null) || {} },
        mapAreaVals(nodes) {
            const g = this.graph, out = {}, cnt = {}
            if (!g) return out
            for (const n of nodes || []) {
                if (!g.hasNode(n)) continue
                const D = g.getNodeAttributes(n).D || {}
                for (const m of this.mapMeasures) {
                    const v = +D[m.binding]
                    if (!Number.isFinite(v)) continue
                    out[m.binding] = (out[m.binding] || 0) + v
                    if (this.mapAggAvg(m.binding)) cnt[m.binding] = (cnt[m.binding] || 0) + 1
                }
            }
            for (const b in cnt) if (cnt[b]) out[b] = out[b] / cnt[b]
            return out
        },
        // ---- применение вида ----
        mapView_apply() {
            if (!this.graph) return
            if (!this.mapViewOn) { this.mapView_reset(); return }
            this.mapTick++
            this.mapView_applyStyles(this.graph)
            this.mapView_applyAreas()
        },
        mapView_reset() {
            const g = this.graph
            if (!g || !this._mapApplied) return
            this._mapApplied = false
            g.forEachNode((n, a) => {
                const upd = {}
                if (a._mapColor0 !== undefined) upd.color = a._mapColor0
                if (a._mapSize0 !== undefined) upd.size = a._mapSize0
                if (a._mapHollow0 !== undefined) upd.hollow = a._mapHollow0   // IE 2026 09 17: снимаем «пустой» вид узла
                if (a._mapBody0 !== undefined) upd.color_body = a._mapBody0
                if (Object.keys(upd).length) g.mergeNodeAttributes(n, upd)
            })
            g.forEachEdge((e, a) => { const upd = {}; if (a.color_base !== undefined) upd.color = a.color_base; if (a.size_base !== undefined) upd.size = a.size_base; if (Object.keys(upd).length) g.mergeEdgeAttributes(e, upd) })
            const dg = this.data_graph
            if (dg) { dg.graphContext = (dg.graphContext || []).filter(r => !r._ieArea); for (const r of dg.graphContext) if (r._ieHide) delete r._ieHide }
            this.mapAreasData = []
            this.mapBadge = null
            this.mapTick++
            this.refresh()
        },
        mapView_applyStyles(graph) {
            const g = graph || this.graph
            if (!g || !this.mapViewOn) return
            this._mapApplied = true
            const vb = this.mapValueBinding, sb = this.mapSizeBinding
            const sizes = []
            g.forEachNode((n, a) => { const v = +(a.D || {})[sb]; if (Number.isFinite(v) && v > 0) sizes.push(v) })
            const maxS = sizes.length ? Math.max(...sizes) : 0
            this._mapMaxSize = maxS
            const scale = this.mapScale
            g.forEachNode((n, a) => {
                const D = a.D || {}
                const upd = {}
                if (a._mapColor0 === undefined) upd._mapColor0 = a.color
                if (a._mapSize0 === undefined) upd._mapSize0 = a.size
                const v = +D[vb]
                const col = Number.isFinite(v) ? scale.colorOf(v) : MAP_EMPTY
                const s = this.mapSizeOf(+D[sb], maxS)
                upd.size = s || MAP_MIN_S
                // IE 2026 09 17 / ODOO-… (заказ Игоря): узел без движения показываем ПУСТЫМ — белое тело с кольцом
                // цвета меры (у графа правил меры не разложены по месяцам, поэтому «пусто» = нет объёма в итоге)
                if (a._mapHollow0 === undefined) upd._mapHollow0 = !!a.hollow
                if (a._mapBody0 === undefined) upd._mapBody0 = a.color_body
                const h0 = a._mapHollow0 !== undefined ? a._mapHollow0 : !!a.hollow
                const b0 = a._mapBody0 !== undefined ? a._mapBody0 : a.color_body
                if (!s) { upd.hollow = true; upd.color_body = col; upd.color = '#ffffff' }
                else { upd.hollow = h0; upd.color_body = b0; upd.color = col }
                g.mergeNodeAttributes(n, upd)
            })
            // связи: толщина по мере строк ребра, красные — с непокрытым объёмом
            const lv = this.mapLinkVals
            let maxL = 0
            for (const e of lv.values()) maxL = Math.max(maxL, Math.abs(e.value) + Math.abs(e.unc))
            g.forEachEdge((e, a) => {
                const upd = {}
                if (a.color_base === undefined) upd.color_base = a.color
                if (a.size_base === undefined) upd.size_base = a.size
                const m = lv.get(e)
                const val = m ? Math.abs(m.value) + Math.abs(m.unc) : 0
                upd.size = (maxL > 0 && val > 0) ? 1 + 4 * Math.sqrt(val / maxL) : 1
                upd.color = (m && m.unc > 0) ? MAP_UNC : MAP_LINK
                upd.zIndex = (m && m.unc > 0) ? 2 : 0
                g.mergeEdgeAttributes(e, upd)
            })
        },
        // области стран: полосы узлов (кластер y бэка) прямоугольниками graphContext — рисует drawGraphContext на подложке,
        // как дорожки каскада; пунктир и подписи полос с бэка при этом прячутся (_ieHide)
        mapView_applyAreas() {
            const g = this.graph, dg = this.data_graph
            if (!g || !dg) return
            const rows = (dg.graphContext = (dg.graphContext || []).filter(r => !r._ieArea))
            for (const r of rows) if (r._ieHide) delete r._ieHide
            if (!this.mapViewOn || !this.mapAreasOn || this.layoutFree) { this.mapAreasData = []; return }   // IE 2026 09 26 / ODOO-…: + свободная раскладка
            const byC = new Map()
            let minX = Infinity, maxX = -Infinity
            g.forEachNode((n, a) => {
                if (a.hidden || !Number.isFinite(a.x) || !Number.isFinite(a.y)) return
                if (a.x < minX) minX = a.x
                if (a.x > maxX) maxX = a.x
                const c = String(a.country || '').trim()
                if (!c) return
                const e = byC.get(c) || { key: c, nodes: [], y0: Infinity, y1: -Infinity }
                e.nodes.push(n); e.y0 = Math.min(e.y0, a.y); e.y1 = Math.max(e.y1, a.y)
                byC.set(c, e)
            })
            if (!byC.size || !Number.isFinite(minX)) { this.mapAreasData = []; return }
            const list = [...byC.values()].sort((a, b) => a.y0 - b.y0)
            // границы — середины между соседними полосами (сплошные области без зазоров, как дорожки каскада)
            const gaps = []
            for (let i = 1; i < list.length; i++) gaps.push(Math.max(2, (list[i].y0 - list[i - 1].y1) / 2))
            const padY = gaps.length ? Math.max(4, Math.min(...gaps)) : 8
            for (let i = 0; i < list.length; i++) {
                const prev = list[i - 1], next = list[i + 1]
                list[i].top = prev ? (prev.y1 + list[i].y0) / 2 : list[i].y0 - padY
                list[i].bottom = next ? (list[i].y1 + next.y0) / 2 : list[i].y1 + padY
                list[i].vals = this.mapAreaVals(list[i].nodes)
                list[i].value = list[i].vals[this.mapValueBinding]
            }
            this.mapAreasData = list.map(it => ({ key: it.key, nodes: it.nodes, vals: it.vals, value: it.value, top: it.top, bottom: it.bottom }))
            const scale = this.mapAreaScale
            const padX = Math.max((maxX - minX) * 0.01, 4)
            const bb = this._graphBBox   // область — во всю ширину холста: название встаёт в левое поле, не на подписи узлов
            const x0 = bb ? bb.x[0] : minX - padX, x1 = bb ? bb.x[1] : maxX + padX
            for (const it of list) {
                const color = scale.colorOf(it.value)
                const txt = this.mapFmtText(it.value, this.mapValueBinding)
                rows.push({
                    canvas: 'underlay', type: 'fillRect', _ieArea: it.key,
                    x0: x0, x1: x1, y0: it.top, y1: it.bottom, titleLimX: minX,   // название области не заходит за первую колонку узлов
                    fillStyle: mapAlpha(color, 0.22), strokeStyle: mapAlpha(color, 0.5),
                    title: it.key + (txt ? ' · ' + txt : ''), textStyle: '#37474f', font: '600 12px sans-serif',
                    lineDash: [], lineWidth: 1, globalAlpha: 1,
                })
            }
            // пунктирные горизонтальные разделители полос и подписи стран с бэка — их место заняли области
            const titles = new Set(list.map(i => i.key))
            for (const r of rows) {
                if (r._ieArea) continue
                if (r.type === 'stroke' && Math.abs((r.y0 ?? 0) - (r.y1 ?? 0)) < 0.5) r._ieHide = true
                else if (r.type === 'fillText' && titles.has(String(r.title || '').trim())) r._ieHide = true
            }
        },
        // кольцо (вторая мера) и красное ядро (непокрытое) вокруг узла — на верхнем холсте, как флаги узлов
        mapGlyphs(sigma, ctx) {
            if (!this.mapViewOn || !ctx || !sigma) return
            const g = this.graph
            if (!g) return
            const rb = this.mapRingBinding, cb = this.mapCoreBinding
            if (!rb && !cb) return
            const maxS = this._mapMaxSize || 0
            const rOf = (v) => { const s = this.mapSizeOf(v, maxS); return s ? (Number(sigma.scaleSize(s)) || 0) : 0 }
            g.forEachNode((n, a) => {
                const d = sigma.getNodeDisplayData(n)
                if (!d || d.hidden) return
                const D = a.D || {}
                const rr = rb ? rOf(+D[rb]) : 0, rc = cb ? rOf(+D[cb]) : 0
                if (rr < 0.5 && rc < 0.5) return
                const p = sigma.graphToViewport({ x: a.x, y: a.y })
                ctx.save()
                ctx.setLineDash([])
                if (rr > 0.5) { ctx.beginPath(); ctx.arc(p.x, p.y, rr, 0, Math.PI * 2); ctx.strokeStyle = '#2f3b52'; ctx.lineWidth = 1.4; ctx.globalAlpha = 0.9; ctx.stroke() }
                if (rc > 0.5) { ctx.beginPath(); ctx.arc(p.x, p.y, rc, 0, Math.PI * 2); ctx.globalAlpha = 1; ctx.fillStyle = MAP_UNC; ctx.fill(); ctx.strokeStyle = '#b23b37'; ctx.lineWidth = 1; ctx.stroke() }
                ctx.restore()
            })
        },
        // ---- блоки вкладки Node ----
        mapRows(vals) {
            const rows = []
            for (const m of this.mapMeasures) {
                const v = +vals[m.binding]
                if (!Number.isFinite(v)) continue
                rows.push({ title: m.title, text: this.mapFmt(v, m.binding), active: m.binding === this.mapValueBinding })
            }
            return rows
        },
        // IE 2026 09 17 / ODOO-… (замечание Игоря): размер окна легенды не скачет при наведении на разные элементы
        mapLegendBox_fix() {
            this.$nextTick(() => {
                const el = this.$refs.legendPanel
                if (el) stableBoxApply(el, this.mapLegendBox, this.store.setting('fe.ux.legendStableSize', true) !== false)
            })
        },
        mapLegendBox_reset() { stableBoxReset(this.mapLegendBox, this.$refs.legendPanel) },
        mapNodeInfo(key) {
            const g = this.graph
            if (!g?.hasNode(key)) return null
            const a = g.getNodeAttributes(key)
            return { kind: this.t('Node'), title: a.label || key, sub: [a.country, a.x_role?.title].filter(Boolean).join(' · '), rows: this.mapRows(a.D || {}) }   // IE 2026 09 23 / ODOO-341407: i18n
        },
        mapEdgeInfo(key) {
            const g = this.graph
            if (!g?.hasEdge(key)) return null
            const a = g.getEdgeAttributes(key)
            const s = g.source(key), t = g.target(key)
            const from = g.getNodeAttribute(s, 'label') || s, to = g.getNodeAttribute(t, 'label') || t
            const m = this.mapLinkVals.get(key) || { value: 0, unc: 0 }
            const rows = [{ title: this.t('From'), text: from }, { title: this.t('To'), text: to }]   // IE 2026 09 23 / ODOO-341407: i18n
            if (a.label) rows.push({ title: this.t('Rule'), text: a.label })
            if (this.mapLinkValueBinding) rows.push({ title: this.mapLinkValueTitle, text: this.mapFmt(m.value, this.mapLinkValueBinding), active: true })
            if (this.mapLinkUncBinding) rows.push({ title: this.mapLinkUncTitle, text: this.mapFmt(m.unc, this.mapLinkUncBinding), unc: m.unc > 0 })
            return { kind: this.t('Link', null, 'graph'), title: from + ' → ' + to, sub: '', rows }   // IE 2026 09 24 / ODOO-341407: контекстный ключ словаря (ревизия омонимов)
        },
        mapAreaInfo(key) {
            const it = this.mapAreasData.find(a => a.key === key)
            if (!it) return null
            return { kind: this.t('Country'), title: key, sub: this.tn(it.nodes.length, '{n} node', '{n} nodes') + ' · ' + this.t('Σ, stock cover averaged'), rows: this.mapRows(it.vals || {}) }   // IE 2026 09 23 / ODOO-341407: i18n // IE 2026 09 25 / ODOO-5800: DOS → stock cover (Igor 25.09)
        },
        // ---- селектор и запись элемента (как у бейджей карты) ----
        mapBareKey(key) { return String(key || '').split('::')[0] },
        mapNodeBinding(key) { return this.mapNodeBindings.get(this.mapBareKey(key)) || 'subject' },
        mapAreaRef(title) { return this.mapCountryIds.get(String(title || '').trim()) || null },
        mapSelectionRowFor(binding) {
            const WHERE = this.store.WORKSPACES?.[this.WIDGET?.workspace]?.record?.doc?.params?.WHERE
            if (!Array.isArray(WHERE) || !binding) return null
            return WHERE.find(w => w && (w.leftValue || {}).value === binding && (w.condition || 'in') === 'in' && w.type !== 'selector_map_dimensions') || null
        },
        mapSelectedFor(binding) {
            const row = this.mapSelectionRowFor(binding)
            const out = new Set()
            if (!row || !row.use) return out
            for (const a of (row.attrs || [])) { const v = a?.rightValue?.value; if (v && typeof v !== 'object' && a.use !== false) out.add(String(v)) }
            return out
        },
        // клик по чекбоксу: добавить / снять значение в чипсе стола по полю; Alt — оставить только его (правила карты)
        mapToggleSelect(binding, key, exclusive) {
            const WORKSPACE = this.store.WORKSPACES?.[this.WIDGET?.workspace]
            const params = WORKSPACE?.record?.doc?.params
            if (!params || !binding || !key) return
            const WHERE = params.WHERE = params.WHERE || []
            const field = this.mapFields.get(binding) || {}
            let row = this.mapSelectionRowFor(binding)
            if (!row) {
                row = {
                    use: true, attr_type: 'AttrChipWhere', condition: 'in',
                    widget: this.WIDGET.widget, 'widget-segment': this.WIDGET.record?.segment || 'WIDGET-LIST',
                    leftValue: { value: binding, valueStr: field.title || binding, attr_type: 'AttrLink', component: 'AttrLink', valueStr_fix: true, relation_segment: '' },
                    rightValue: { pi: 'pi pi-arrow-right', value: '', valueStr: '', attr_type: 'AttrLink', component: 'AttrLink', relation_segment: field.relation_segment || '' },
                    attrs: [],
                }
                WHERE.push(row)
            }
            const seg = row.rightValue?.relation_segment || field.relation_segment || ''
            const current = [...this.mapSelectedFor(binding)]
            const k = String(key)
            let next
            if (exclusive) next = (current.length === 1 && current[0] === k) ? [] : [k]
            else next = current.includes(k) ? current.filter(x => x !== k) : [...current, k]
            const title = (seg && this.store.itemsSource?.[seg]?.ids?.[k]?.title) || k
            const mkRow = (v) => ({
                use: true,
                leftValue: { pi: '', value: '', valueStr: '', attr_type: 'AttrLink', component: 'AttrLink', hideTitle: true, relation_segment: '' },
                rightValue: { pi: 'pi pi-arrow-right', value: v, valueStr: v === k ? title : ((seg && this.store.itemsSource?.[seg]?.ids?.[v]?.title) || v), attr_type: 'AttrLink', component: 'AttrLink', relation_segment: seg },
            })
            const kept = (row.attrs || []).filter(a => a?.rightValue?.value && next.includes(String(a.rightValue.value)))
            const keptIds = new Set(kept.map(a => String(a.rightValue.value)))
            row.attrs = [...kept, ...next.filter(v => !keptIds.has(v)).map(mkRow)]
            row.use = row.attrs.length > 0
            this.mapTick++
            this.store.workspace_applySelector(this.WIDGET.workspace, this.WIDGET.page, this.WIDGET)
        },
        mapClearSelection() {
            let changed = false
            for (const b of ['subject', 'subject_from', 'subject_to', 'country']) {
                const row = this.mapSelectionRowFor(b)
                if (row && (row.use || (row.attrs || []).length)) { row.attrs = []; row.use = false; changed = true }
            }
            this.mapTick++
            if (changed) this.store.workspace_applySelector(this.WIDGET.workspace, this.WIDGET.page, this.WIDGET)
        },
        mapRecordSegmentFor(binding, key) {
            const seg = this.mapFields.get(binding)?.relation_segment || ''
            const IS = seg ? this.store.itemsSource?.[seg] : null
            const row = IS?.ids?.[key] || (IS?.data || []).find(x => x && String(x.id) === String(key))
            return (row && typeof row.segment === 'string' && row.segment) ? row.segment : seg
        },
        mapOpenIcon(binding, key) {
            const seg = this.mapRecordSegmentFor(binding, key)
            const IS = this.store.itemsSource?.SEGMENTS
            const byId = (id) => IS?.ids?.[id] || (IS?.data || []).find(x => x?.id === id)
            let rec = seg ? byId(seg) : null, guard = 0
            while (rec && !(rec.pi || rec.doc?.pi) && rec.parent && guard++ < 6) rec = byId(rec.parent)
            const pi = String(rec?.pi || rec?.doc?.pi || '').trim()
            return pi ? pi.replace(/^pi\s+/, '') : 'pi-external-link'
        },
        mapOpenRecord(binding, key) {
            const seg = this.mapRecordSegmentFor(binding, key)
            if (!seg || key == null || key === '') return
            this.store.executeStoreMethod(this.WIDGET?.vueObj || this, { command: 'widget_open', widget: 'widget-record', _activate: true, item: { id: String(key), segment: seg } })
        },
        // ---- подпись наведения (бейдж) ----
        mapBadgeHtml(kind, key) {
            const parts = []
            const kv = (b, v) => `<span class="attr-graph-badge-kv"><i>${this.mapTitleOf(b)}</i> ${this.mapFmt(v, b)}</span>`
            if (kind === 'node' || kind === 'area') {
                const vals = kind === 'node' ? this.mapNodeD(key) : ((this.mapAreasData.find(a => a.key === key) || {}).vals || {})
                for (const b of [this.mapValueBinding, this.mapSizeBinding]) if (b && Number.isFinite(+vals[b])) parts.push(kv(b, +vals[b]))
                const cb = this.mapCoreBinding
                if (cb && +vals[cb] > 0) parts.push(`<span class="attr-graph-badge-unc">${this.mapTitleOf(cb)} ${this.mapFmt(+vals[cb], cb)}</span>`)
            }
            return parts.join('')
        },
        // // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — график / узел карты)
        // правая кнопка по узлу в виде карты (sigma rightClickNode) — окно легенды, вкладка Node с этим узлом: узел становится наведённым элементом
        // (mapHover_node, как наведение — вкладка Node показывает его), закрытое окно открывается (как кнопка легенды). Вне вида карты окна легенды нет —
        // не перехватывать (меню виджета). Телефон / выключатель fe.ux.contextMenuActions = false — как до правки. Счётчик window.ctxMenuActions.mapNode
        ctxMenu_mapNode(e) {   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — график / узел карты)
            const ev = e?.event?.original
            if (!ctxMenu_allowed(this.store, ev)) return
            if (!this.mapViewOn || !e.node || !this.graph?.hasNode(e.node)) return
            ev.preventDefault()
            this.mapHover_node(e.node)
            this.mapLegendTab = 'node'
            this.mapLegendVisible = true
            ctxMenu_count('mapNode')
        },
        mapHover_node(node) {
            if (!this.mapViewOn) return
            if (node) {
                clearTimeout(this._mapBadgeTimer); this._mapBadgeTimer = null
                this.mapHoverEl = { kind: 'node', key: node }
                this.mapTick++
                this.mapBadge_place()
            } else if (!this._mapBadgeHold) {
                clearTimeout(this._mapBadgeTimer)
                this._mapBadgeTimer = setTimeout(() => { this._mapBadgeTimer = null; this.mapBadge = null }, this.store.setting('fe.ux.graphTooltipHideMs', 600))
            }
        },
        // U6 (заказ Игоря: объяснение элементов по Alt): ключ объяснения быстрой настройки — свой (chart.graph.qs.<key>), у опций, объявленных вью
        // (attr.graphOptions бэка), — общий chart.graph.qs.custom
        uiHelp6_qsKey(opt) { const k = 'chart.graph.qs.' + (opt && opt.key); return uiHelp_has(k) ? k : 'chart.graph.qs.custom' },
        mapHover_edge(edge) {
            if (!this.mapViewOn || !edge) return
            this.mapHoverEl = { kind: 'edge', key: edge }
            this.mapTick++
        },
        mapHover_area(key) {
            if (!this.mapViewOn) return
            if (!key) { if (!this._mapBadgeHold && this.mapBadge?.kind === 'area') this.mapBadge = null; return }
            this.mapHoverEl = { kind: 'area', key }
            this.mapTick++
            this.mapBadge_place()
        },
        mapBadge_place() {
            const el = this.mapHoverEl
            if (!this.mapViewOn || !el || !this.sigma) return
            let pos = null, binding = '', key = '', title = '', flag = '', country = null
            if (el.kind === 'node' && this.graph?.hasNode(el.key)) {
                const a = this.graph.getNodeAttributes(el.key)
                const d = this.sigma.getNodeDisplayData(el.key)
                const p = this.sigma.graphToViewport({ x: a.x, y: a.y })
                const r = Number(this.sigma.scaleSize(d?.size || a.size || 6)) || 6
                pos = { x: Math.round(p.x + r + 6), y: Math.round(p.y - 9) }
                binding = this.mapNodeBinding(el.key); key = this.mapBareKey(el.key); title = a.label || el.key
                country = this.mapCountryBadge(a.country)   // IE 2026 09 17 / ODOO-… (заказ Игоря): страна узла — своим бейджем
            } else if (el.kind === 'area') {
                const row = (this.data_graph?.graphContext || []).find(r => r._ieArea === el.key)
                const tb = row?._tb
                if (!tb) return
                pos = { x: Math.round(tb.x + tb.w + 8), y: Math.round(tb.y - 1) }
                const ref = this.mapAreaRef(el.key)
                binding = ref?.binding || 'country'; key = ref?.key || ''; title = el.key
                flag = this.mapFlagOf(key, binding)
            }
            if (!pos) return
            const b = this.mapBadge
            if (b && b.kind === el.kind && b.key === key && b.x === pos.x && b.y === pos.y && b.title === title) return
            this.mapBadge = {
                kind: el.kind, key, binding, title, flag, country, x: pos.x, y: pos.y,
                selected: key ? this.mapSelectedFor(binding).has(String(key)) : false,
                icon: key ? this.mapOpenIcon(binding, key) : '',
                html: this.mapBadgeHtml(el.kind, el.key),
            }
        },
        mapBadgeHold(on) {
            this._mapBadgeHold = !!on
            if (on) { clearTimeout(this._mapBadgeTimer); this._mapBadgeTimer = null }
            else this.mapHover_node(null)
        },
        // IE 2026 09 17 / ODOO-… (заказ Игоря): бейдж страны узла — флаг, название, чекбокс селектора и иконка записи
        mapCountryBadge(country) {
            const t = String(country || '').trim()
            if (!t) return null
            const ref = this.mapAreaRef(t), binding = ref?.binding || 'country', key = ref?.key || ''
            return {
                title: t, key, binding, flag: this.mapFlagOf(key, binding),
                selected: key ? this.mapSelectedFor(binding).has(String(key)) : false,
                icon: key ? this.mapOpenIcon(binding, key) : '',
            }
        },
        // эмодзи-флаг страны из справочника (поле flag записи; приходит с itemsSource). Словарь ПОЛЯ бывает
        // источником данных (DS) без поля flag — тогда ищем ту же запись по id в остальных загруженных словарях
        mapFlagOf(key, binding) {
            if (!key || this.store?.setting?.('fe.ux.graphCountryFlags', true) === false) return ''
            const k = String(key)
            const flagOf = (IS) => { const row = IS?.ids?.[k] || (IS?.data || []).find(x => x && String(x.id) === k); return String(row?.flag || row?.doc?.flag || '').trim() }
            const seg = this.mapFields.get(binding || 'country')?.relation_segment
            const own = seg ? flagOf(this.store.itemsSource?.[seg]) : ''
            if (own) return own
            for (const [name, IS] of Object.entries(this.store.itemsSource || {})) {
                if (name === seg) continue
                const f = flagOf(IS)
                if (f) return f
            }
            return ''
        },
        mapBadgeToggle(e, part) {
            const b = this.mapBadge
            const p = part === 'country' ? b?.country : b
            if (!b || !p || !p.key) return
            this.mapToggleSelect(p.binding, p.key, !!e?.altKey)
            const sel = this.mapSelectedFor(p.binding).has(String(p.key))
            this.mapBadge = part === 'country' ? { ...b, country: { ...b.country, selected: sel } } : { ...b, selected: sel }
        },
        mapBadgeOpen(part) { const b = this.mapBadge, p = part === 'country' ? b?.country : b; if (p?.key) this.mapOpenRecord(p.binding, p.key) },
        mapSetMeasure(binding) {
            this.mapActiveBinding = binding
            this.store.set_viewParam(this.WIDGET, this.attr.name, 'graph_value_binding', binding, this.attr)
            this.mapView_apply()
            this.refresh()
        },
        // ---- окно легенды: свободное, как у карты и графика (портал = контейнер страницы, перетаскивание за шапку) ----
        legendEnsurePortal() {
            if (!this.legendPortal) this.legendPortal = document.getElementById('WIDGET' + (this.WIDGET?.id ?? ''))?.parentElement || null
            return this.legendPortal
        },
        legendContainingBlock() {
            let el = this.legendEnsurePortal()
            while (el && el !== document.body && el !== document.documentElement) {
                const cs = getComputedStyle(el)
                if (cs.position !== 'static' || cs.transform !== 'none' || cs.filter !== 'none' || cs.perspective !== 'none') return el
                el = el.parentElement
            }
            return null
        },
        legendToPortal(x, y) {
            const el = this.legendContainingBlock()
            if (!el) return { x: x + window.scrollX, y: y + window.scrollY }
            const r = el.getBoundingClientRect()
            return { x: x - r.left - el.clientLeft + el.scrollLeft, y: y - r.top - el.clientTop + el.scrollTop }
        },
        legendDefaultPos() {
            const wEl = document.getElementById('WIDGET' + (this.WIDGET?.id ?? ''))
            const r = (wEl || this.$refs.attr_container)?.getBoundingClientRect?.()
            if (!r || !r.width) return this.legendToPortal(Math.max(0, window.innerWidth - 300), 90)
            const pr = this.$refs.legendPanel?.getBoundingClientRect?.()
            const w = (pr && pr.width > 50) ? pr.width : 300, h = (pr && pr.height > 30) ? pr.height : 260
            const portal = this.legendEnsurePortal()?.getBoundingClientRect?.()
            const minTop = Math.max(0, portal ? portal.top : 0), gap = 4
            if (r.top - gap - h >= minTop) return this.legendToPortal(Math.max(0, r.right - w), r.top - gap - h)
            if (r.right + gap + w <= window.innerWidth) return this.legendToPortal(r.right + gap, Math.max(minTop, r.top))
            const host = this.$refs.attr_container?.getBoundingClientRect?.() || r
            return this.legendToPortal(Math.max(0, host.right - w - 8), host.top + 36)
        },
        legendPanelStyle() {
            this.legendEnsurePortal()
            if (!this.legendPos && !this._legendDefPos) {
                this._legendDefPos = this.legendDefaultPos()
                this.$nextTick(() => {
                    const el = this.$refs.legendPanel
                    if (!el) return
                    const recalc = () => { if (!this.legendPos && this.$refs.legendPanel) { this._legendDefPos = this.legendDefaultPos(); this.legendDefTick = (this.legendDefTick || 0) + 1 } }
                    recalc()
                    if (typeof ResizeObserver !== 'undefined') {
                        if (this._legendRO) this._legendRO.disconnect()
                        this._legendRO = new ResizeObserver(() => recalc())
                        this._legendRO.observe(el)
                    }
                })
            }
            void this.legendDefTick
            const pos = this.legendPos || this._legendDefPos || (this._legendDefPos = this.legendDefaultPos())
            return { position: 'absolute', left: Math.max(0, pos.x) + 'px', top: Math.max(0, pos.y) + 'px', right: 'auto', bottom: 'auto', zIndex: 1000 }
        },
        legendPanelClosed() {
            if (this._legendRO) { this._legendRO.disconnect(); this._legendRO = null }
            if (!this.legendPos) this._legendDefPos = null
        },
        legendDragStart(e) {
            if (e.button !== 0) return
            if (e.target?.closest?.('.attr-graph-mappanel-close')) return
            const panel = this.$refs.legendPanel
            if (!panel) return
            const p = panel.getBoundingClientRect()
            const ox = panel.offsetLeft - p.left, oy = panel.offsetTop - p.top
            this.legendPos = { x: panel.offsetLeft, y: panel.offsetTop }
            const drag = { dx: e.clientX - p.left, dy: e.clientY - p.top }
            const move = (ev) => {
                const vp = { x: Math.min(Math.max(0, ev.clientX - drag.dx), window.innerWidth - 60), y: Math.min(Math.max(0, ev.clientY - drag.dy), window.innerHeight - 30) }
                this.legendPos = { x: vp.x + ox, y: vp.y + oy }
            }
            const up = () => { document.removeEventListener('mousemove', move); document.removeEventListener('mouseup', up) }
            document.addEventListener('mousemove', move)
            document.addEventListener('mouseup', up)
            e.preventDefault()
        },
        get_viewParam(param, defaultValue) {
            return this.store.get_viewParam(this.WIDGET, this.attr.name, param, defaultValue, this.attr)
        },

        // ===== webscm 2026 10 23 / Odoo 348730 (поручение Андрея, шина #102078: «у нас поломались графы в датахабе. визуально ничего
        // не понятно, еще и тормозят»; условие #102112 — не менять функционал графов Игоря): СЕТЕВОЙ режим графа — ЯВНАЯ опция виджета
        // doc.params.graph_network = true. Ставит её только граф DataHub (предопределённый widget-DS-Graph-DataHub, config_widgets.py
        // бэка). Без опции (каскад, вкладка Cascade формы, граф структуры, прочие графы) поведение прежнее: всё ниже — только под netOn().
        // В режиме: нет авто «Keep vertical spacing» (координаты parse_inOutDegree — единицы сетки, а потолок 1.25 px/ед. сжимал
        // 152 колонки в полосу ~190 px); нет своих проходов подписей (O(N·(N+E)) на загрузке, ресайзе и каждом движении камеры —
        // 6–23 с на 2 621 узле): подписи отбирает сетка sigma по порогу размера ('sigma-options' в graph-eval записи — крупные по
        // степени, больше при приближении); соседи наведённого / выделенного узла подписаны, связи выделенных узлов видны (netEdgeReduce);
        // ответ, построенный по прежним чипсам стола (чипс сменили, пока граф загружался), не рисуется — один перезапрос select;
        // обязательный чипс (строка WHERE с selector_required) пуст — подсказка selector_hint вместо графа
        netOn() { return this.WIDGET?.record?.doc?.params?.graph_network === true },
        // подписи чипсов по строкам 'in selector' отбора виджета: применённые бэком (db.prepare_WHERE_evals копирует значения чипса стола
        // в attrs строки) и текущие чипсы стола
        netSelectorSigs() {
            const vals = (r) => JSON.stringify((!r || r.use === false) ? [] : (r.attrs || []).filter(a => a && a.use !== false).map(a => String(a?.rightValue?.value ?? '')).sort())
            const wsRows = this.store.WORKSPACES?.[this.WIDGET?.workspace]?.record?.doc?.params?.WHERE || []
            let applied = '', current = ''
            for (const r of this.WIDGET?.record?.doc?.params?.WHERE || []) {
                if (!r || r.use === false || r.condition !== 'in selector') continue
                const b = String(r.selector_binding || r.leftValue?.value || '')
                if (!b) continue
                applied += b + '=' + vals(r) + ';'
                current += b + '=' + vals(wsRows.find(x => String(x?.leftValue?.value || '') === b)) + ';'
            }
            return { applied, current }
        },
        // ответ по прежним чипсам (виджет, ещё открывавшийся без записи, updateRelatedWidgets пропускал) → перезапрос select, один на подпись
        // текущих чипсов; ответ на сам перезапрос рисуется в любом случае (_onResponse) — зацикливания нет
        netSelectorStale() {
            const { applied, current } = this.netSelectorSigs()
            if (applied === current) { this._netReselect = null; return false }
            if (this._netReselect !== current) this.netReselect(current)
            return true
        },
        netReselect(sig) {
            this._netReselect = sig
            this.$nextTick(() => {   // из created(): vueObj виджета ещё не готов
                if (this._netReselect !== sig) return
                try {
                    this.store.executeStoreMethod(this.WIDGET.vueObj, { command: 'executeWidgetMethod', method: 'select', record_sendToBackend_exclude: ['_doc'],
                        _onResponse: () => { if (this._netReselect !== sig) return; this._netReselect = null; if (this.isMounted && this.data_graph) this.load_data(this.data_graph) } }, this.attr)
                } catch (e) { this._netReselect = null; console.warn('graph reselect skipped', e) }
            })
        },
        // выделенные узлы (атрибут selector) и их соседи — для редьюсеров; пересчёт лениво после смены selector
        netSelSets() {
            if (this._netSel) return this._netSel
            const g = this.graph, sel = new Set(), nb = new Set()
            if (g) g.forEachNode((n, a) => { if (a.selector) { sel.add(n); g.forEachNeighbor(n, (m) => nb.add(m)) } })
            return (this._netSel = { sel, nb })
        },
        netSelWatch(graph) {
            this._netSel = null
            graph.on('nodeAttributesUpdated', (ev) => {
                if (!ev || !(ev.name === 'selector' || ev.type === 'replace' || (ev.data && 'selector' in ev.data))) return
                this._netSel = null
                // связи узла перекрашивает только полный проход редьюсеров (частичный refresh sigma берёт один узел)
                if (!this._netSelRaf) this._netSelRaf = requestAnimationFrame(() => { this._netSelRaf = null; if (this.graph === graph) this.refresh() })
            })
        },
        // подписи соседей не форсируются (у узла-хаба их сотни) — их отбирает сетка sigma; приглушённые узлы — подпись null, иначе
        // пустая строка занимает ячейку сетки (sigma берёт в неё любую строковую подпись)
        netNodeReduce(node, res) {
            if (this.state.hoveredNode) { if (res.label === '') res.label = null; return }   // наведение — как раньше (редьюсер выше приглушил прочие)
            const ns = this.netSelSets()
            if (!ns.sel.size || ns.sel.has(node) || ns.nb.has(node)) return
            res.label = null; res.type = ''; res.color = '#f6f6f6'; res.zIndex = 0   // выделение — как наведение: вне выделенных и их соседей приглушено
        },
        netEdgeReduce(edge, attributes, res) {
            if (attributes.selector) return   // выделенная связь — как раньше
            const h = this.state.hoveredNode, g = this.graph
            if (h) {   // наведение: при скрытых настройкой рёбрах чужие рёбра скрыты, а не приглушены — сотни серых дуг закрывали граф
                if (this.params?.['command-select']?.edge?.hidden && g.source(edge) !== h && g.target(edge) !== h) res.hidden = true
                return
            }
            const sel = this.netSelSets().sel
            if (!sel.size) return
            if (sel.has(g.target(edge))) { res.hidden = false; res.color = '#7798FA'; res.zIndex = 5 }   // входящая — цветом наведения
            else if (sel.has(g.source(edge))) { res.hidden = false; res.color = '#6DDB55'; res.zIndex = 5 }   // исходящая
        },
        netHint() {
            if (!this.netOn()) return ''
            let picked = false
            for (const r of this.WIDGET?.record?.doc?.params?.WHERE || []) {
                if (!r || r.use === false || !r.selector_required || r.condition !== 'in selector') continue
                if (!(r.attrs || []).some(a => a && a.use !== false)) return this.t(r.selector_hint || 'Select a value in the selector to build the graph')
                picked = true
            }
            // webscm 2026 10 25 / Odoo 348733 (шина #104356, #104367): чипс выбран, ответ по нему пришёл, узлов 0 (коннектор без данных — записи
            // CONNECTION-* на DM) — надпись вместо пустого поля. Пока идёт запрос виджета или его данные по прежним чипсам — ничего.
            // Только УСПЕШНЫЙ пустой ответ (ревью ie-webscm7 #104574): граф пришёл (nodes — массив) и на виджете нет ошибки. Сбой запроса и
            // исключение метода запись не меняют (data_graph — {} из data() или прежний граф), сбой источника widget_DS.select даёт пустой граф
            // с уведомлением error — «нет данных» там неправда
            const dg = this.data_graph
            if (!picked || !Array.isArray(dg?.nodes) || dg.nodes.length) return ''
            const W = this.WIDGET, n = W.notification, { applied, current } = this.netSelectorSigs()
            return (W.loading || W.firstBackendCheck || W._staleOpen || applied !== current
                || (n?.visible && ['error', 'critical'].includes(n.status))) ? '' : this.t('No data for this connector')
        },

        // АН 2026 08 11: какие лейблы узлов показывать — по реальным прямоугольникам
        // текста в экранных координатах (замечание Андрея: наложения и лишние пропуски)
        // IE 2026 09 14 / ODOO-335246 (Igor): живое размещение подписей — флаг fe.ux.graphLabelsLive (умолчание ВКЛ; выключить для сравнения:
        // localStorage / настройки, как прочие fe.ux.*). Под флагом: кандидаты справа-вверх / справа-вниз, штрафы по площади,
        // все связи как препятствия, пересчёт после раскладки, ресайза, при перетаскивании узла (каждый кадр) и после него
        labelsLive() {
            if (this.netOn()) return false   // webscm 2026 10 23 / Odoo 348730: сетевой режим — без живого размещения подписей (и сдвига узлов со связей)
            try { return this.store.setting('fe.ux.graphLabelsLive', true) !== false } catch (e) { return true }
        },
        arrowScale() {   // IE 2026 09 14 / ODOO-335246 (Igor): множитель головки стрелки (fe.ux.graphArrowScale, умолчание 2; 1 — как у sigma)
            try { const v = Number(this.store.setting('fe.ux.graphArrowScale', 2)); return v > 0 ? v : 2 } catch (e) { return 2 }   // IE 2026 09 14: 3 было грузно на помеченных рёбрах (18 px)
        },
        labelsSchedule(ms, nudge) {
            clearTimeout(this._lvTimer)
            const d = ms != null ? ms : this.store.setting('fe.ux.graphLabelDebounceMs', 150)
            this._lvTimer = setTimeout(() => { try { this.recomputeLabelVisibility(nudge ? { nudge: true } : undefined) } catch (e) { /* граф в перестроении */ } }, d)
        },
        // IE 2026 09 14 / ODOO-335246 (Igor): опция «Move nodes off the links crossing their labels» (шестерёнка, doc.params.graph_nudge_off_links, умолчание ВКЛ,
        // локальная — без запроса к бэку): после раскладки узел, чья подпись лежит на связях, сдвигается по вертикали (полстроки…
        // две строки) в пределах своей дорожки туда, где подпись чище, а его собственные связи не ложатся на чужие подписи.
        // Только при событиях раскладки (graphPostLayout / tryPatchGraph), не при зуме и перетаскивании
        nudgeOn() {
            return (this.WIDGET?.record?.doc?.params || {}).graph_nudge_off_links !== false && this.labelsLive() && !this.layoutFree   // IE 2026 09 26 / ODOO-…: + не для свободной раскладки
        },
        labelsDragTick() {   // при перетаскивании — не чаще кадра
            if (this._lvRaf) return
            this._lvRaf = requestAnimationFrame(() => { this._lvRaf = null; try { this.recomputeLabelVisibility() } catch (e) { /* граф в перестроении */ } })
        },
        nudgeNodesOffLinks(items, nodePts, edgePts, mctx, settings) {
            const sigma = this.sigma, graph = this.graph
            const segBox = (ax, ay, bx, by, x0, y0, x1, y1) => {
                if (Math.max(ax, bx) < x0 || Math.min(ax, bx) > x1 || Math.max(ay, by) < y0 || Math.min(ay, by) > y1) return 0
                const dx = bx - ax, dy = by - ay
                let t0 = 0, t1 = 1
                for (const [p, q] of [[-dx, ax - x0], [dx, x1 - ax], [-dy, ay - y0], [dy, y1 - ay]]) {
                    if (Math.abs(p) < 1e-9) { if (q < 0) return 0; continue }
                    const t = q / p
                    if (p < 0) { if (t > t1) return 0; if (t > t0) t0 = t } else { if (t < t0) return 0; if (t < t1) t1 = t }
                }
                return t0 <= t1 ? (t1 - t0) * Math.hypot(dx, dy) : 0
            }
            // шаг строки в пикселях — медиана зазоров между соседями одной вертикали
            const cols = new Map()
            for (const n of nodePts) { const kx = Math.round(n.x / 30); if (!cols.has(kx)) cols.set(kx, []); cols.get(kx).push(n.y) }
            const gaps = []
            for (const ys of cols.values()) { ys.sort((a, b) => a - b); for (let i = 1; i < ys.length; i++) if (ys[i] - ys[i - 1] > 5) gaps.push(ys[i] - ys[i - 1]) }
            gaps.sort((a, b) => a - b)
            const rowPx = gaps.length ? gaps[Math.floor(gaps.length / 2)] : 40
            const lanes = this.rectBoxes(sigma).filter(b => b.row?.title)
            const laneOf = (x, y) => { let best = null; for (const b of lanes) { if (x >= b.rx && x <= b.rx + b.rw && y >= b.ry && y <= b.ry + b.rh && (!best || b.rw * b.rh < best.rw * best.rh)) best = b } return best }
            const byNode = new Map(nodePts.map(n => [n.node, n]))
            const boxOf = new Map(items.map(it => [it.node, it]))
            const ownCross = (node, x, y) => {   // связи узла (в новом положении) поверх ЧУЖИХ подписей
                let c = 0
                for (const e of edgePts) {
                    if (e.s !== node && e.t !== node) continue
                    const ax = e.s === node ? x : e.ax, ay = e.s === node ? y : e.ay, bx = e.t === node ? x : e.bx, by = e.t === node ? y : e.by
                    const other = e.s === node ? e.t : e.s
                    for (const b of items) { if (b.node === node || b.node === other) continue; if (segBox(ax, ay, bx, by, b.x0, b.y0, b.x1, b.y1) > 0) c++ }
                }
                return c
            }
            const moves = []
            const cand = items.filter(it => it.ec >= 4 && !it.a.own).sort((u, v) => v.ec - u.ec)
            for (const it of cand) {
                const pt = byNode.get(it.node); if (!pt) continue
                const lane = laneOf(pt.x, pt.y)
                const lo = lane ? lane.ry + 22 + 10 : -Infinity, hi = lane ? lane.ry + lane.rh - 10 : Infinity
                const colYs = nodePts.filter(n => n.node !== it.node && Math.abs(n.x - pt.x) < 30).map(n => n.y)
                let best = { score: it.sc + 3 * ownCross(it.node, pt.x, pt.y), dy: 0 }
                const x0 = pt.x, y0 = pt.y
                for (const f of [-0.5, 0.5, -1, 1]) {   // IE 2026 09 14 (Igor): не дальше строки
                    const dy = f * rowPx, ny = y0 + dy
                    if (ny < lo || ny > hi) continue
                    if (colYs.some(y => Math.abs(y - ny) < rowPx * 0.9)) continue
                    pt.y = ny
                    for (const e of edgePts) { if (e.s === it.node) e.ay = ny; if (e.t === it.node) e.by = ny }
                    this._placeCtx = { pts: nodePts, boxes: items.filter(b => b.node !== it.node), edges: edgePts }
                    let pl = null
                    try { pl = this.labelPlace(mctx, { key: it.node, label: it.label, icon: it.a.icon, x: x0, y: ny, size: it.sz, own: it.a.own, color: it.a.color }, settings, null) } catch (e) { pl = null }
                    this._placeCtx = null
                    pt.y = y0
                    for (const e of edgePts) { if (e.s === it.node) e.ay = y0; if (e.t === it.node) e.by = y0 }
                    if (!pl) continue
                    // IE 2026 09 14 (Igor): сдвиг принимается, только если связи с подписи УХОДЯТ (ec ≤ 1), выигрыш ≥ 2 и цена строки 1 —
                    // иначе узлы веера съезжали к краю дорожки ради частичного выигрыша (прогон 14.09: пересечений 12 → 11, три узла на дне)
                    if ((pl.ec || 0) > 1) continue
                    const score = pl.sc + 3 * ownCross(it.node, x0, ny) + 1.0 * Math.abs(f)
                    if (score < best.score - 2) best = { score, dy }
                }
                if (best.dy) {
                    moves.push([it.node, best.dy])
                    pt.y = y0 + best.dy   // следующие кандидаты видят уже сдвинутый узел
                    for (const e of edgePts) { if (e.s === it.node) e.ay = pt.y; if (e.t === it.node) e.by = pt.y }
                    const b = boxOf.get(it.node); if (b) { b.y0 += best.dy; b.y1 += best.dy }
                }
            }
            for (const [node, dy] of moves) {
                const a = graph.getNodeAttributes(node)
                const p = sigma.graphToViewport({ x: a.x, y: a.y })
                const g = sigma.viewportToGraph({ x: p.x, y: p.y + dy })
                graph.setNodeAttribute(node, 'y', g.y)
            }
            if (this.store.setting('fe.ux.graphLabelDebug', false)) console.log('graph nudge:', JSON.stringify({ rowPx: Math.round(rowPx), candidates: cand.length, moved: moves.map(([n, dy]) => [n, Math.round(dy)]) }))
            return moves.length
        },
        recomputeLabelVisibility(opts) {
            if (this.netOn()) { this._labelVis = null; this._labelCut = null; return }   // webscm 2026 10 23 / Odoo 348730: подписи отбирает сетка sigma (порог размера), O(N²)-проход не нужен
            const sigma = this.sigma, graph = this.graph
            if (!sigma || !graph) return
            const { width, height } = sigma.getDimensions()
            const fs = sigma.getSetting('labelSize') || 14
            if (!this._measureCtx) this._measureCtx = document.createElement('canvas').getContext('2d')
            const mctx = this._measureCtx
            const settings = { labelSize: fs, labelFont: sigma.getSetting('labelFont') || 'Arial', labelWeight: sigma.getSetting('labelWeight') || '' }
            mctx.font = `${settings.labelWeight} ${fs}px ${settings.labelFont}`.trim()
            // IE 2026 09 11 / ODOO-335246 (Igor): прямоугольники подписей — по их РЕАЛЬНОМУ положению (labelPlace: снизу / сверху /
            // справа), а не «всегда справа от узла»; положение считается по полной подписи и запоминается (_labelPlaceK)
            const items = [], nodePts = [], placeK = new Map(), todo = []
            graph.forEachNode((node, a) => {
                const p = sigma.graphToViewport({ x: a.x, y: a.y })
                const d = sigma.getNodeDisplayData(node)
                const sz = d ? Number(sigma.scaleSize(d.size)) || 3 : (a.size || 3)
                nodePts.push({ node, x: p.x, y: p.y, sz, own: !!a.own })   // IE 2026 09 14 / ODOO-335246 (Igor): own — кольцо хозяина как препятствие
                if (!a.label) return
                if (p.x < -60 || p.x > width + 60 || p.y < -30 || p.y > height + 30) return
                todo.push({ node, a, p, sz })
            })
            // IE 2026 09 13 / ODOO-335246 (Igor): место подписи выбирается с учётом ВСЕХ узлов и уже поставленных подписей (labelPlace
            // читает this._placeCtx), а не только соседей по связям: подпись через колонку ложилась на чужой узел (скрин 13.09);
            // слева направо — правые подписи обходят левые, уже поставленные
            todo.sort((u, v) => u.p.x - v.p.x || u.p.y - v.p.y)
            const live = this.labelsLive()
            const edgePts = []
            if (live) {   // IE 2026 09 14 / ODOO-335246 (Igor): все видимые связи (экранные координаты) — препятствия для подписей любых узлов
                try {
                    const vp = new Map(nodePts.map(n => [n.node, n]))
                    graph.forEachEdge((e, ea, s_, t_) => { if (ea.hidden) return; const a_ = vp.get(s_), b_ = vp.get(t_); if (a_ && b_) edgePts.push({ s: s_, t: t_, ax: a_.x, ay: a_.y, bx: b_.x, by: b_.y }) })
                } catch (e) { /* граф в перестроении */ }
            }
            this._placeCtx = { pts: nodePts, boxes: [], edges: edgePts }
            for (const { node, a, p, sz } of todo) {
                let pl = null
                try { pl = this.labelPlace(mctx, { key: node, label: String(a.label), icon: a.icon, x: p.x, y: p.y, size: sz, own: a.own, color: a.color }, settings, null) } catch (e) { pl = null }
                if (!pl) continue
                placeK.set(node, pl.k)
                const box = { x0: pl.x, x1: pl.x + pl.w, y0: pl.y - pl.h / 2, y1: pl.y + pl.h / 2 }
                this._placeCtx.boxes.push(box)
                items.push({ node, size: a.size || 0, label: String(a.label), px: p.x, py: p.y, k: pl.k, iconW: pl.iconW || 0, sc: pl.sc || 0, ec: pl.ec || 0, a, sz, ...box })
            }
            this._placeCtx = null
            this._labelPlaceK = placeK
            // IE 2026 09 14 / ODOO-335246 (Igor): сдвиг узлов со связей (см. nudgeOn) — только по событию раскладки; после сдвига проход повторяется без него
            if (opts?.nudge && live && this.nudgeOn() && !this.isDragging) {
                let moved = 0
                try { moved = this.nudgeNodesOffLinks(items, nodePts, edgePts, mctx, settings) } catch (e) { console.warn('graph nudge skipped', e) }
                if (moved) { this.graphBBox_update(); sigma.refresh(); return this.recomputeLabelVisibility() }   // IE 2026 09 26 / ODOO-…: сдвинутый узел мог выйти за габарит — габарит заново (иначе он за краем)
            }
            // АН 2026 08 11 (заказ Андрея): длинное название, налезающее на СОСЕДНИЙ УЗЕЛ, обрезаем с «…» до начала этого узла;
            // IE 2026 09 11 (Igor): и до начала СОСЕДНЕЙ ПОДПИСИ той же строки (отступ PAD); совсем короткий обрезок (<40px) — прячем
            const PAD = 6
            const cut = new Map()
            mctx.font = `${settings.labelWeight} ${fs}px ${settings.labelFont}`.trim()
            for (let i = items.length - 1; i >= 0; i--) {
                const it = items[i]
                let maxW = Infinity   // доступная ширина всей подписи (иконка + текст) от it.x0
                for (const np of nodePts) {
                    if (np.node === it.node) continue
                    if (np.x - np.sz <= it.x0 + 1) continue                 // кружок левее начала подписи
                    if (np.y + np.sz <= it.y0 || np.y - np.sz >= it.y1) continue   // другой ряд
                    const lim = np.x - np.sz - PAD - it.x0
                    if (lim < maxW) maxW = lim
                }
                for (const ot of items) {
                    if (ot === it || ot.x0 <= it.x0 + 1) continue          // сама подпись и подписи левее
                    if (ot.y0 >= it.y1 - 1 || ot.y1 <= it.y0 + 1) continue // другой ряд
                    const lim = ot.x0 - PAD - it.x0
                    if (lim < maxW) maxW = lim
                }
                let w = it.x1 - it.x0
                if (w > maxW) {
                    const textMax = maxW - it.iconW
                    if (textMax < 40) { items.splice(i, 1); continue }
                    let str = it.label
                    while (str.length > 1 && mctx.measureText(str + '\u2026').width > textMax) str = str.slice(0, -1)
                    cut.set(it.node, str + '\u2026')
                    w = it.iconW + mctx.measureText(str + '\u2026').width
                }
                it.x1 = it.x0 + w
            }
            this._labelCut = cut
            // приоритет — крупные узлы, затем левые (стабильность при равных)
            items.sort((a, b) => b.size - a.size || a.x0 - b.x0 || (a.node < b.node ? -1 : 1))
            const taken = [], vis = new Set()
            for (const it of items) {
                let ok = true
                for (const t of taken) {
                    if (it.x0 < t.x1 && it.x1 > t.x0 && it.y0 < t.y1 && it.y1 > t.y0) { ok = false; break }
                }
                if (ok) { vis.add(it.node); taken.push(it) }
            }
            this._labelVis = vis
            // IE 2026 09 14 / ODOO-335246 (Igor): метрика прохода — пары «узел под подписью» и «подпись на подписи» среди ПОКАЗАННЫХ подписей (для сравнения
            // с флагом и без: window.<граф>.__vueGraph._labelStats; вывод в консоль при fe.ux.graphLabelDebug)
            try {
                let nodeUnder = 0, labelLabel = 0
                const shown = items.filter(it => vis.has(it.node))
                for (const it of shown) {
                    for (const np of nodePts) { if (np.node === it.node) continue; const rr = np.sz; if (np.x + rr > it.x0 && np.x - rr < it.x1 && np.y + rr > it.y0 && np.y - rr < it.y1) nodeUnder++ }
                    for (const ot of shown) { if (ot === it || ot.node < it.node) continue; if (it.x0 < ot.x1 && it.x1 > ot.x0 && it.y0 < ot.y1 && it.y1 > ot.y0) labelLabel++ }
                }
                this._labelStats = { labels: todo.length, shown: shown.length, cut: cut.size, nodeUnder, labelLabel, live }
                if (this.store.setting('fe.ux.graphLabelDebug', false)) console.log('graph labels:', JSON.stringify(this._labelStats))
            } catch (e) { /* метрика не критична */ }
            sigma.refresh({ skipIndexation: true })
        },

        // ~~~~~~~~~~~~~~~~~~~ graphContext ~~~~~~~~~~~~~~~~~~~
        drawGraphContext({ sigma, ctx, data_graph, overlay = false }) {
            const { width, height } = sigma.getDimensions();
            ctx.clearRect(0, 0, width, height);
            
            const dpr = window.devicePixelRatio || 1;
            // // 1) гарантированно чистим весь canvas
            // ctx.setTransform(1, 0, 0, 1, 0, 0);
            // ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
            // 2) рисуем в CSS координатах
            // ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
            
            // стиль линий
            ctx.save();
            const boxes = new Map(this.rectBoxes(sigma).map(b => [b.row, b]))   // IE 2026 09 10 (Igor)

            for (const row of data_graph.graphContext || []) {
                if (row._ieHide) continue   // IE 2026 09 17 / ODOO-… (заказ Игоря): пунктир и подпись полосы страны заменены областью вида карты
                if (row.lineDash) {
                    ctx.setLineDash(row.lineDash);
                }
                if (row.lineWidth) {
                    ctx.lineWidth = row.lineWidth;
                }
                if (row.globalAlpha) {
                    ctx.globalAlpha = row.globalAlpha;
                }
                if (row.lineCap) {
                    ctx.lineCap = row.lineCap;
                }

                if (row.type === 'fillText') {
                    const poin0 = sigma.graphToViewport({ x: row.x0, y: row.y0 });

                    ctx.fillText(`${row.title}`, poin0.x + (row.x0_ptx || 0), poin0.y + (row.y0_ptx || 0));

                } else if (row.type === 'stroke') {
                    const poin0 = sigma.graphToViewport({ x: row.x0, y: row.y0 });
                    const poin1 = sigma.graphToViewport({ x: row.x1, y: row.y1 });

                    ctx.beginPath();
                    ctx.moveTo(poin0.x + (row.x0_ptx || 0), poin0.y + (row.y0_ptx || 0));
                    ctx.lineTo(poin1.x + (row.x1_ptx || 0), poin1.y + (row.y1_ptx || 0));
                    ctx.stroke();

                } else if (row.type === 'rect' || row.type === 'fillRect') {
                    // IE 2026 09 06 / ODOO-335246 (Igor, п.4.4): прямоугольник области (дорожка подсистемы каскада) —
                    // углы в координатах графа, заливка/обводка/подпись из строки; рисуется на подложке под рёбрами
                    // IE 2026 09 10 (Igor): экранные координаты — rectBoxes (вложенная область ниже заголовка родителя)
                    const bx = boxes.get(row)
                    if (!bx) continue
                    const { rx, ry, rw, rh } = bx
                    if (row.fillStyle) { ctx.fillStyle = row.fillStyle; ctx.fillRect(rx, ry, rw, rh) }
                    if (row.strokeStyle) { ctx.strokeStyle = row.strokeStyle; ctx.strokeRect(rx, ry, rw, rh) }
                    row._tt = null; row._tb = null; row._ib = null
                    if (row.title && !bx.noTitle) {   // IE 2026 10 25 / ODOO-348925: места под заголовок нет (sgTitleRoom, мелкий масштаб) — рамка без заголовка
                        ctx.fillStyle = row.textStyle || '#5b6470'; ctx.font = row.font || '600 12px sans-serif'
                        // IE 2026 09 06 (Igor): подпись липнет к видимому верхнему-левому углу, но не выходит за свой прямоугольник
                        const cEl = this.$refs.attr_container, vL = (cEl?.scrollLeft || 0) + 2, vT = (cEl?.scrollTop || 0) + 2   // видимый угол контейнера (прокрутка)
                        const tx = Math.min(Math.max(rx, vL), rx + rw - 8), ty = Math.min(Math.max(ry, vT), ry + rh - 18)
                        if (ty + 16 <= ry + rh && tx + 8 <= rx + rw) {
                            // IE 2026 09 10 / ODOO-335246 (Igor): иконка записи области (doc — запрос / строитель MV) перед заголовком;
                            // клик по ней открывает запись (как по иконке узла); прямоугольник — row._ib
                            let iw = 0
                            const gi = row.doc?.id ? this.piGlyph(row.icon || 'pi-database') : ''
                            if (gi) {
                                const IP = this.NODE_ICON_PX
                                ctx.save(); ctx.font = `${IP}px primeicons`; ctx.textBaseline = 'middle'; ctx.textAlign = 'left'
                                ctx.lineJoin = 'round'; ctx.lineWidth = 4; ctx.strokeStyle = this.bgAt(tx + 8, ty + 11); ctx.strokeText(gi, tx + 8, ty + 11)   // IE 2026 09 10 (Igor): подложка по контуру цветом фона
                                ctx.fillText(gi, tx + 8, ty + 11)
                                ctx.restore()
                                row._ib = { x0: tx + 6, x1: tx + 8 + IP + 2, y0: ty + 2, y1: ty + 20 }
                                iw = IP + 4
                            }
                            // IE 2026 09 10 / ODOO-335246 (Igor): название не выходит за правую грань своей области — обрезка «…»;
                            // полное название — тултипом при наведении (rectTitleHover)
                            // IE 2026 09 17 / ODOO-… (заказ Игоря): у области страны название живёт в левом поле — дальше первой
                            // колонки узлов не идёт (обрезка «…», полное название — при наведении, как у других областей)
                            let maxW = rx + rw - 8 - (tx + 8 + iw)
                            if (row.titleLimX != null) maxW = Math.min(maxW, sigma.graphToViewport({ x: row.titleLimX, y: 0 }).x - 6 - (tx + 8 + iw))
                            let text = `${row.title}`
                            const fullW = ctx.measureText(text).width
                            let w = fullW
                            if (w > maxW) {
                                const hover = row === this._rectTipRow   // IE 2026 09 10 (Igor): наведение — полное название на месте
                                if (hover) {
                                    text = ''   // рисует верхний слой (overlay) — поверх узлов и связей, не под ними
                                } else {
                                    let s = text
                                    while (s.length > 1 && ctx.measureText(s + '\u2026').width > maxW) s = s.slice(0, -1)
                                    text = s + '\u2026'
                                    w = ctx.measureText(text).width
                                }
                                row._tt = { x: tx + 8 + iw, y: ty + 2, w: Math.max(hover ? fullW : w, 12), h: 18, full: `${row.title}` }
                            }
                            row._tb = { x: tx + 8 + iw, y: ty + 2, w: Math.max(w, 12), h: 18 }   // IE 2026 09 10 (Igor): полоса заголовка — hover области
                            if (text) {
                                ctx.save(); ctx.lineJoin = 'round'; ctx.lineWidth = 4; ctx.strokeStyle = this.bgAt(tx + 8 + iw, ty + 12); ctx.strokeText(text, tx + 8 + iw, ty + 16); ctx.restore()   // IE 2026 09 10 (Igor): подложка по контуру цветом фона
                                ctx.fillText(text, tx + 8 + iw, ty + 16)
                            }
                        }
                    }
                }
            }

            // IE 2026 09 10 / ODOO-335246 (Igor): полное название области под курсором — на ВЕРХНЕМ слое, поверх узлов и связей
            const hr = overlay && this._rectTipRow
            if (hr && hr._tt) {
                ctx.save(); ctx.setLineDash([])
                ctx.font = hr.font || '600 12px sans-serif'
                const fw = ctx.measureText(hr._tt.full).width
                ctx.fillStyle = 'rgba(255, 255, 255, 0.94)'; ctx.fillRect(hr._tt.x - 4, hr._tt.y, fw + 8, 18)
                ctx.strokeStyle = 'rgba(120, 130, 150, 0.35)'; ctx.lineWidth = 1; ctx.strokeRect(hr._tt.x - 4, hr._tt.y, fw + 8, 18)
                ctx.fillStyle = hr.textStyle || '#5b6470'; ctx.fillText(hr._tt.full, hr._tt.x, hr._tt.y + 14)
                ctx.restore()
            }
            ctx.restore();
        },        
        get_dataItem(arr, node) {
            const get_dataItem0 = (arr) => {
                for (let item of arr) {
                    if (item._graph?.node === node) {
                        return item
                    }
                    if (item.attrs) {
                        const found = get_dataItem0(item.attrs);
                        if (found) {
                            return found
                        }
                    }
                }
                return null
            }
            const get_dataItem1 = (arr) => {
                for (let item of arr) {
                    if (item._graph?.node1 === node || item._graph?.node2 === node) {
                        return item
                    }
                    if (item.attrs) {
                        const found = get_dataItem0(item.attrs);
                        if (found) {
                            return found
                        }
                    }
                }
                return null
            }
            
            let dataItem = get_dataItem0(arr)
            if (!dataItem) {
                dataItem = get_dataItem1(arr)
            }
            return dataItem
        },

        // ~~~~~~~~~~~~~~~~~~~ Links panel (ODOO-3221) ~~~~~~~~~~~~~~~~~~~
        // Панель связей вершины: строится ЦЕЛИКОМ из уже загруженного graphology-графа
        // (те же вершины/рёбра, что собрал бэкенд) — без второго сборщика данных.
        openLinksPanel(node) {
            const graph = this.graph
            if (!graph?.hasNode(node)) return

            const link_row = (edge, other) => ({
                binding: graph.getEdgeAttribute(edge, 'label') || '',
                node: other,
                label: graph.getNodeAttribute(other, 'label') || other,
            })
            const sort_rows = (a, b) => (a.label + a.binding).localeCompare(b.label + b.binding)

            const attrs = graph.getNodeAttributes(node),
                cfg = this.params?.['command-clickNode']?.links_panel
            this.linksPanel = {
                node,
                label: attrs.label || node,
                segment: attrs.doc?.id || node,
                color: attrs.color || '#999',
                links_out: graph.outEdges(node).map((edge) => link_row(edge, graph.target(edge))).sort(sort_rows),
                links_in: graph.inEdges(node).map((edge) => link_row(edge, graph.source(edge))).sort(sort_rows),
                ui: (cfg && typeof cfg === 'object') ? cfg : {},
            }
        },
        openSegmentList(segment) {
            // штатный LIST-виджет сегмента (как кнопка Records в реестре SEGMENTS)
            this.store.widget_open({
                widget: 'widget-list',
                parentAction: { 'action_name':'action-front-2026-07-19-graph-links', method:'AttrGraph.openSegmentList', title: segment },
                props: { id: segment },
                fieldsMapping: [
                    {'leftValue':'doc.params.segment', 'rightValue': segment},
                ],
            }, this)
        },

    }
}
</script>

<style>
.attr-graph {
    width: 100%;
    height: 300px;
}

/* ODOO-3221: легенда и панель связей поверх графа */
.attr-graph0 {
    position: relative;
    /* demo-webscm 2026 10 19 / ODOO-347310 (owner: the scrollbar on the right keeps appearing and disappearing): keep the gutter of the
       vertical scrollbar reserved while the area scrolls (keep spacing: graphPostLayout sets overflow:auto) — clientWidth and the
       ResizeObserver content box no longer change when the bar shows/hides, so a relayout cannot flip it back. No effect when overflow is visible */
    scrollbar-gutter: stable;
}
/* IE 2026 09 05 / ODOO-336800 (заказ Игоря): рамка выделения узлов и курсор режима */
.attr-graph-rectsel {
    position: absolute;
    z-index: 5;
    pointer-events: none;
    border: 1px dashed var(--primary-color, #6366f1);
    background: rgba(99, 102, 241, 0.12);
}
/* IE 2026 09 13 / ODOO-335246 (Igor): полосы прокрутки растянутого графа — всегда видимые и широкие (overlay-полосы Mac не ухватить) */
.attr-graph0::-webkit-scrollbar { width: 12px; height: 12px; }
.attr-graph0::-webkit-scrollbar-thumb { background: rgba(120, 130, 150, 0.45); border-radius: 6px; border: 3px solid transparent; background-clip: content-box; }
.attr-graph0::-webkit-scrollbar-thumb:hover { background: rgba(120, 130, 150, 0.75); background-clip: content-box; }
.attr-graph0::-webkit-scrollbar-track { background: transparent; }
.attr-graph-rectsel-on .sigma-mouse {
    cursor: crosshair;
}
/* webscm 2026 10 23 / Odoo 348730: сетевой режим — подсказка «выберите значение чипса» вместо пустого графа */
.attr-graph-net-hint {
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
    z-index: 4;
    max-width: 80%;
    padding: 10px 16px;
    border: 1px dashed #c3c8d1;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.92);
    color: #5f6b7a;
    font-size: 14px;
    text-align: center;
    pointer-events: none;
}
.attr-graph-legend {
    position: absolute;
    left: 8px;
    bottom: 8px;
    z-index: 4;
    background: rgba(255, 255, 255, 0.92);
    border: 1px solid #e3e3e3;
    border-radius: 6px;
    padding: 6px 10px;
    font-size: 12px;
    line-height: 1.6;
    pointer-events: none;
    max-width: 46%;
}
.attr-graph-legend-row {
    display: flex;
    align-items: center;
    gap: 6px;
}
.attr-graph-legend-swatch {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex: 0 0 auto;
}
.attr-graph-legend-marker {
    font-weight: 700;
    width: 14px;
    text-align: center;
    flex: 0 0 auto;
}
.attr-graph-links {
    position: absolute;
    right: 8px;
    top: 8px;
    z-index: 5;
    width: 300px;
    max-width: 55%;
    max-height: calc(100% - 16px);
    overflow: auto;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    padding: 8px 10px;
    font-size: 12px;
}
.attr-graph-links-header {
    display: flex;
    align-items: center;
    gap: 6px;
}
.attr-graph-links-label {
    flex: 1 1 auto;
    font-size: 13px;
}
.attr-graph-links-close {
    cursor: pointer;
    color: #888;
    padding: 2px;
}
.attr-graph-links-close:hover {
    color: #333;
}
.attr-graph-links-sub {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 2px 0 4px 16px;
}
.attr-graph-links-id {
    color: #999;
    font-family: monospace;
}
.attr-graph-links-openlist {
    color: #2196f3;
    cursor: pointer;
    white-space: nowrap;
}
.attr-graph-links-openlist:hover {
    text-decoration: underline;
}
.attr-graph-links-section {
    font-weight: 600;
    margin: 6px 0 2px;
    color: #555;
}
.attr-graph-links-table {
    border-collapse: collapse;
    width: 100%;
}
.attr-graph-links-table td {
    padding: 1px 4px;
    vertical-align: top;
}
.attr-graph-links-binding {
    color: #777;
    font-family: monospace;
    word-break: break-word;
}
.attr-graph-links-arrow {
    color: #aaa;
}
.attr-graph-links-node {
    color: #2196f3;
    cursor: pointer;
    min-width: 90px; /* не даём колонке биндингов схлопывать имена сегментов до по-буквенного переноса */
}
.attr-graph-links-node:hover {
    text-decoration: underline;
}

</style>

<style>
/* IE 2026 09 13 / ODOO-335246 (Igor): иконки кнопок масштаба по осям графа — свои SVG-маски цветом текста (в primeicons нет пары
   «растянуть / сжать» по одной оси); глобально — кнопки рендерит командная панель вне этого компонента.
   Растянуть — стрелки от планки наружу, сжать — к планке; Fit to view — уголки рамки и вписанный в неё граф */
/* IE 2026 09 13 (Igor): базовое правило .pi[class*="ie-ico-"]::before — ОДНО, в src/assets/styles/ie-icons.css (общее с ie-icons-platform.css
   коллеги ie-webscm7); здесь только маски пяти кнопок графа */
.pi.ie-ico-stretch-v::before { -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='black'><rect x='2' y='7' width='12' height='2'/><rect x='7' y='3.6' width='2' height='2.6'/><polygon points='8,0 3.2,4.6 12.8,4.6'/><rect x='7' y='9.8' width='2' height='2.6'/><polygon points='8,16 3.2,11.4 12.8,11.4'/></svg>"); mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='black'><rect x='2' y='7' width='12' height='2'/><rect x='7' y='3.6' width='2' height='2.6'/><polygon points='8,0 3.2,4.6 12.8,4.6'/><rect x='7' y='9.8' width='2' height='2.6'/><polygon points='8,16 3.2,11.4 12.8,11.4'/></svg>"); }
.pi.ie-ico-squeeze-v::before { -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='black'><rect x='2' y='7' width='12' height='2'/><rect x='7' y='0' width='2' height='2.2'/><polygon points='8,6.2 3.2,1.8 12.8,1.8'/><rect x='7' y='13.8' width='2' height='2.2'/><polygon points='8,9.8 3.2,14.2 12.8,14.2'/></svg>"); mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='black'><rect x='2' y='7' width='12' height='2'/><rect x='7' y='0' width='2' height='2.2'/><polygon points='8,6.2 3.2,1.8 12.8,1.8'/><rect x='7' y='13.8' width='2' height='2.2'/><polygon points='8,9.8 3.2,14.2 12.8,14.2'/></svg>"); }
.pi.ie-ico-stretch-h::before { -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='black'><rect x='7' y='2' width='2' height='12'/><rect x='3.6' y='7' width='2.6' height='2'/><polygon points='0,8 4.6,3.2 4.6,12.8'/><rect x='9.8' y='7' width='2.6' height='2'/><polygon points='16,8 11.4,3.2 11.4,12.8'/></svg>"); mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='black'><rect x='7' y='2' width='2' height='12'/><rect x='3.6' y='7' width='2.6' height='2'/><polygon points='0,8 4.6,3.2 4.6,12.8'/><rect x='9.8' y='7' width='2.6' height='2'/><polygon points='16,8 11.4,3.2 11.4,12.8'/></svg>"); }
.pi.ie-ico-squeeze-h::before { -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='black'><rect x='7' y='2' width='2' height='12'/><rect x='0' y='7' width='2.2' height='2'/><polygon points='6.2,8 1.8,3.2 1.8,12.8'/><rect x='13.8' y='7' width='2.2' height='2'/><polygon points='9.8,8 14.2,3.2 14.2,12.8'/></svg>"); mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='black'><rect x='7' y='2' width='2' height='12'/><rect x='0' y='7' width='2.2' height='2'/><polygon points='6.2,8 1.8,3.2 1.8,12.8'/><rect x='13.8' y='7' width='2.2' height='2'/><polygon points='9.8,8 14.2,3.2 14.2,12.8'/></svg>"); }
.pi.ie-ico-fit::before { -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='black'><path d='M0 5V0h5v2H2v3zM11 0h5v5h-2V2h-3zM0 11h2v3h3v2H0zM14 11h2v5h-5v-2h3z'/><circle cx='4.5' cy='8' r='1.7'/><circle cx='11.5' cy='5' r='1.7'/><circle cx='11.5' cy='11' r='1.7'/><path d='M5.2 7.4l5.6-2.2.6 1.4-5.6 2.2zM5.2 8.6l5.6 2.2.6-1.4-5.6-2.2z'/></svg>"); mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='black'><path d='M0 5V0h5v2H2v3zM11 0h5v5h-2V2h-3zM0 11h2v3h3v2H0zM14 11h2v5h-5v-2h3z'/><circle cx='4.5' cy='8' r='1.7'/><circle cx='11.5' cy='5' r='1.7'/><circle cx='11.5' cy='11' r='1.7'/><path d='M5.2 7.4l5.6-2.2.6 1.4-5.6 2.2zM5.2 8.6l5.6 2.2.6-1.4-5.6-2.2z'/></svg>"); }

/* IE 2026 09 15 / ODOO-… (заказ Игоря): командная панель графа — островок в нижнем правом углу поля графа */
.attr-graph0 > .corner-island-br { top: auto !important; bottom: 10px !important; right: 10px !important; left: auto !important; max-width: calc(100% - 20px); flex-wrap: wrap; justify-content: flex-end; }
.attr-graph0 > .graph-panel-island .p-button, .attr-graph0 > .graph-panel-island .button-1 { position: static !important; }

/* IE 2026 09 15 / ODOO-… (замечание Игоря): муравьи по рёбрам графа — холст поверх sigma, мышь проходит сквозь */
.attr-graph0 > .attr-graph-ants { position: absolute; inset: 0; pointer-events: none; z-index: 4; }

/* IE 2026 09 17 / ODOO-… (заказ Игоря: «Flow-tree-map»): окно легенды графа и подпись наведения — по образцу карты (AttrGeoMap) */
.attr-graph-btn-on { background: rgba(47, 59, 82, 0.12); border-radius: 4px; }
.attr-graph-mappanel {
    position: absolute;
    z-index: 20;
    user-select: none;
    max-width: 380px;
    min-width: 220px;
    background: rgba(255, 255, 255, 0.96);
    border: 1px solid #2f3b52;
    border-radius: 8px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
    padding: 6px 8px 8px;
    font-size: 12px;
    color: #1f2937;
}
.attr-graph-mappanel-head { display: flex; align-items: center; gap: 8px; font-weight: 600; margin-bottom: 4px; cursor: move; }
.attr-graph-mappanel-close { cursor: pointer; color: #c62828; }
.attr-graph-mappanel-tabs { display: flex; gap: 2px; margin: 0 0 4px; border-bottom: 1px solid #e5e7eb; }
.attr-graph-mappanel-tab { padding: 2px 8px 3px; cursor: pointer; color: #4b5563; border-bottom: 2px solid transparent; margin-bottom: -1px; }
.attr-graph-mappanel-tab:hover { color: #1f2937; }
.attr-graph-mappanel-tab.is-on { color: #1f2937; font-weight: 600; border-bottom-color: #2f3b52; }
.attr-graph-mappanel-hover { padding-top: 2px; }
.attr-graph-mappanel-hint { color: #6b7280; padding: 6px 2px; }
.attr-graph-mappanel-hover-head { display: flex; align-items: baseline; gap: 6px; margin-bottom: 4px; min-width: 0; }
.attr-graph-mappanel-hover-kind { font-size: 10px; letter-spacing: 0.06em; text-transform: uppercase; color: #6b7280; flex: none; }
.attr-graph-mappanel-hover-title { max-width: 220px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.attr-graph-mappanel-hover-sub { color: #6b7280; font-size: 11px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.attr-graph-mappanel-table { border-collapse: collapse; width: 100%; }
.attr-graph-mappanel-table td { padding: 2px 4px; white-space: nowrap; }
.attr-graph-mappanel-table tr.is-active { background: rgba(47, 59, 82, 0.07); }
.attr-graph-mappanel-name { color: #4b5563; max-width: 170px; overflow: hidden; text-overflow: ellipsis; }
.attr-graph-mappanel-val { text-align: right; font-weight: 600; border-radius: 4px; }
.attr-graph-mappanel-val.is-unc { background: rgba(198, 40, 40, 0.16); color: #b71c1c; }
.attr-graph-mappanel-row { display: flex; align-items: center; gap: 6px; padding: 3px 2px; cursor: pointer; border-radius: 4px; }
.attr-graph-mappanel-row:hover { background: rgba(47, 59, 82, 0.08); }
.attr-graph-mappanel-row.is-active .attr-graph-mappanel-title { font-weight: 600; }
.attr-graph-mappanel-bar { display: inline-block; width: 48px; height: 8px; border-radius: 4px; margin-left: auto; border: 1px solid #2f3b52; }
.attr-graph-mappanel-foot { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; margin-top: 6px; padding-top: 6px; border-top: 1px solid #e5e7eb; color: #4b5563; }
.attr-graph-mappanel-dot { display: inline-block; width: 10px; height: 10px; border-radius: 50%; background: #8fa8c8; border: 1px solid #2f3b52; }
.attr-graph-mappanel-line { display: inline-block; width: 18px; height: 3px; border-radius: 2px; }
.attr-graph-mappanel-area { display: inline-block; width: 14px; height: 10px; border-radius: 2px; background: linear-gradient(90deg, rgba(229,115,115,.35), rgba(129,199,132,.35)); border: 1px solid rgba(47, 59, 82, 0.4); }
.attr-graph0 > .attr-graph-badge {
    position: absolute;
    z-index: 6;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 1px 6px;
    font-size: 12px;
    background: rgba(255, 255, 255, 0.92);
    border: 1px solid rgba(47, 59, 82, 0.25);
    border-radius: 10px;
    white-space: nowrap;
    pointer-events: auto;
}
.attr-graph-badge .attr-graph-check { font-size: 13px; color: #1a237e; cursor: pointer; }
.attr-graph-badge .attr-graph-open { font-size: 12px; color: #4b5563; cursor: pointer; }
.attr-graph-badge .attr-graph-open:hover { color: #1a237e; }
.attr-graph-badge-name { font-weight: 500; color: #374151; max-width: 220px; overflow: hidden; text-overflow: ellipsis; }
/* IE 2026 09 17 / ODOO-… (заказ Игоря): флаг и бейдж страны поставщика в подписи наведения */
.attr-graph-badge-flag { font-size: 13px; line-height: 14px; }
.attr-graph-badge-country { display: inline-flex; align-items: center; gap: 3px; margin-left: 6px; padding: 0 6px 0 4px; border-radius: 9px; background: rgba(26, 35, 126, 0.07); }
.attr-graph-badge-cname { font-size: 11px; font-weight: 500; color: #4b5563; max-width: 140px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.attr-graph-badge-ext { display: inline-flex; align-items: center; gap: 4px; margin-left: 2px; font-weight: 500; }
.attr-graph-badge-ext .attr-graph-badge-kv i { font-style: normal; font-weight: 400; color: #6b7280; font-size: 11px; margin-right: 2px; }
.attr-graph-badge-ext .attr-graph-badge-unc { display: inline-block; padding: 0 5px; border-radius: 8px; font-size: 11px; font-weight: 600; line-height: 14px; background: rgba(198, 40, 40, 0.16); color: #b71c1c; }
</style>
